/* Appligator Factory route shell: live Office push-feed factory view. */
(function () {
  const { useCallback, useEffect, useMemo, useRef, useState } = React;
  const Icon = window.Icon || (() => null);
  const MarkdownText = window.MarkdownText || (({ text }) => <React.Fragment>{text || ""}</React.Fragment>);
  const MAX_FACTORY_EVENTS = 8;
  const FACTORY_CANVAS = Object.freeze({ width: 1420, height: 700, tileW: 52, tileH: 26, originX: 530, originY: 76 });

  const FACTORY_MAP = Object.freeze([
    "gggggggggggggggggggggggggggggggg",
    "g##############################g",
    "g#ooooooo#..............#ooooo#g",
    "g#ooooooo#..............#ooooo#g",
    "g#oooooooD..............Dooooo#g",
    "g#ooooooo#..............#ooooo#g",
    "g#ooooooo#..............#ooooo#g",
    "g####D####..............#######g",
    "g#ooooooo#..............#ooooo#g",
    "g#ooooooo#..............Dooooo#g",
    "g#ooooooo#..............#ooooo#g",
    "g#ooooooo#..............#ooooo#g",
    "g#oooooooD.......###D##########g",
    "g#ooooooo#.......#bbbbbb#bbbbb#g",
    "g#ooooooo#.......#bbbbbb#bbbbb#g",
    "g#ooooooo#.......DbbbbbbDbbbbb#g",
    "g#ooooooo#.......#bbbbbb#bbbbb#g",
    "g#ooooooo#.......#bbbbbb#bbbbb#g",
    "g##############################g",
    "cccccccccccccccccccccccccccccccc",
  ]);

  const FACTORY_FURNITURE = Object.freeze([
    Object.freeze({ type: "shelf", tiles: Object.freeze([[2, 2], [3, 2]]) }),
    Object.freeze({ type: "shelf", tiles: Object.freeze([[5, 2], [6, 2]]) }),
    Object.freeze({ type: "lectern", tiles: Object.freeze([[4, 4], [5, 4]]) }),
    Object.freeze({ type: "plant", tiles: Object.freeze([[8, 2]]) }),
    Object.freeze({ type: "cabinet", tiles: Object.freeze([[2, 8]]) }),
    Object.freeze({ type: "deskT", tiles: Object.freeze([[3, 9]]) }),
    Object.freeze({ type: "deskL", tiles: Object.freeze([[6, 9]]) }),
    Object.freeze({ type: "deskL", tiles: Object.freeze([[3, 12]]) }),
    Object.freeze({ type: "deskT", tiles: Object.freeze([[6, 12]]) }),
    Object.freeze({ type: "mailbox", tiles: Object.freeze([[2, 14]]) }),
    Object.freeze({ type: "reception", tiles: Object.freeze([[5, 15], [6, 15]]) }),
    Object.freeze({ type: "plant", tiles: Object.freeze([[2, 17]]) }),
    Object.freeze({ type: "board", tiles: Object.freeze([[11, 5], [12, 5]]) }),
    Object.freeze({ type: "press", tiles: Object.freeze([[13, 2], [14, 2], [13, 3], [14, 3]]) }),
    Object.freeze({ type: "lathe", tiles: Object.freeze([[19, 2], [20, 2]]) }),
    Object.freeze({ type: "bench", tiles: Object.freeze([[12, 8], [13, 8]]) }),
    Object.freeze({ type: "bench", tiles: Object.freeze([[17, 8], [18, 8]]) }),
    Object.freeze({ type: "engine", tiles: Object.freeze([[14, 12], [15, 12]]) }),
    Object.freeze({ type: "draft", tiles: Object.freeze([[11, 14]]) }),
    Object.freeze({ type: "easel", tiles: Object.freeze([[10, 16]]) }),
    Object.freeze({ type: "easel", tiles: Object.freeze([[13, 16]]) }),
    Object.freeze({ type: "crates", tiles: Object.freeze([[22, 3], [23, 3], [22, 4]]) }),
    Object.freeze({ type: "pillar", tiles: Object.freeze([[16, 5]]) }),
    Object.freeze({ type: "stove", tiles: Object.freeze([[23, 13]]) }),
    Object.freeze({ type: "rack", tiles: Object.freeze([[18, 13]]) }),
    Object.freeze({ type: "table", tiles: Object.freeze([[20, 15], [21, 15]]) }),
    Object.freeze({ type: "deskT", tiles: Object.freeze([[28, 3]]) }),
    Object.freeze({ type: "deskL", tiles: Object.freeze([[28, 9]]) }),
    Object.freeze({ type: "deskT", tiles: Object.freeze([[28, 15]]) }),
    Object.freeze({ type: "draft", tiles: Object.freeze([[19, 15]]) }),
    Object.freeze({ type: "table", tiles: Object.freeze([[22, 15], [23, 15]]) }),
  ]);

  const FACTORY_RUGS = Object.freeze([[5, 5], [6, 5], [4, 15]]);
  const FACTORY_LAMPS = Object.freeze([[5.5, 3.2, 58], [3, 9.5, 54], [13.5, 4.2, 68], [12.5, 8, 60], [17.5, 8, 60], [20.5, 15, 54], [28, 3.5, 52], [28, 9.5, 52], [28, 15.5, 52], [6, 14.4, 54], [16, 5, 60], [11.5, 5.4, 62]]);
  const FACTORY_POSTS = Object.freeze([[5, 19.85], [13, 19.85], [21, 19.85], [30.5, 19.85], [31, 6], [31, 14]]);
  const FACTORY_FLOWERS = Object.freeze([[3, 18.62], [6, 18.62], [10, 18.62], [13, 18.62], [16, 18.62], [19, 18.62], [22, 18.62], [28, 18.62], [30.62, 5], [30.62, 10], [30.62, 16]]);
  const FACTORY_BUSHES = Object.freeze([[31.7, 3], [32.3, 9], [31.9, 15], [8, 23.6], [18, 23.9], [-1.5, 21.5], [6, 0], [17, 0], [0, 11]]);
  const FACTORY_DESKS = Object.freeze([[5, 4], [3, 10], [3, 13], [6, 16], [11, 15], [12, 9], [17, 9], [13, 4], [19, 3], [14, 13], [20, 16], [22, 16], [28, 3], [28, 9], [28, 15]]);
  const FACTORY_ZONE_TILES = Object.freeze({
    dispatch: Object.freeze([[10, 6], [11, 6], [12, 6], [13, 6]]),
    archive: Object.freeze([[2, 3], [3, 3], [5, 3], [6, 3], [4, 5], [5, 5]]),
    records: Object.freeze([[3, 10], [6, 10], [3, 13], [6, 13]]),
    mailroom: Object.freeze([[5, 16], [6, 16], [4, 15], [7, 15], [3, 14]]),
    steamworks: Object.freeze([[13, 4], [14, 4], [13, 12], [16, 12], [19, 3], [20, 3], [14, 13], [15, 13]]),
    atelier: Object.freeze([[11, 15], [10, 17], [13, 17], [12, 16]]),
    workshop: Object.freeze([[12, 9], [13, 9], [17, 9], [18, 9], [14, 8], [16, 8]]),
    common: Object.freeze([[19, 14], [20, 16], [21, 14], [22, 16], [19, 16], [22, 15], [20, 14], [18, 15]]),
    cfo_office: Object.freeze([[26, 3], [27, 4], [29, 4], [26, 5], [29, 5]]),
    executive_assistant_office: Object.freeze([[26, 9], [27, 10], [28, 10], [29, 10], [26, 11]]),
    senior_dev_office: Object.freeze([[26, 14], [27, 15], [29, 15], [26, 16], [28, 16]]),
    design_lead_studio: Object.freeze([[18, 14], [18, 15], [19, 16], [20, 14]]),
    planning_office: Object.freeze([[21, 14], [21, 16], [22, 16], [23, 14]]),
    exception: Object.freeze([[14, 9], [17, 9], [16, 5]]),
  });

  const CATEGORY_META = Object.freeze({
    action_center_activity: Object.freeze({ label: "Dispatch", zone: "dispatch", tone: "dispatch", icon: "play" }),
    delegation: Object.freeze({ label: "Handoff", zone: "dispatch", tone: "delegated", icon: "handover" }),
    project_context_read: Object.freeze({ label: "Archive", zone: "archive", tone: "context", icon: "archive" }),
    source_review: Object.freeze({ label: "Source", zone: "archive", tone: "context", icon: "search" }),
    ticket_work_package: Object.freeze({ label: "Ticket", zone: "steamworks", tone: "ticket", icon: "list" }),
    document_note_email: Object.freeze({ label: "Docs", zone: "records", tone: "mail", icon: "mail" }),
    note_document_email: Object.freeze({ label: "Docs", zone: "records", tone: "mail", icon: "mail" }),
    note: Object.freeze({ label: "Note", zone: "records", tone: "mail", icon: "mail" }),
    document: Object.freeze({ label: "Document", zone: "records", tone: "mail", icon: "doc" }),
    email: Object.freeze({ label: "Mail", zone: "mailroom", tone: "mail", icon: "mail" }),
    sketch: Object.freeze({ label: "Sketch", zone: "atelier", tone: "sketch", icon: "edit" }),
    tool_call: Object.freeze({ label: "Tool", zone: "workshop", tone: "tool", icon: "settings" }),
    command_execution: Object.freeze({ label: "Press", zone: "workshop", tone: "tool", icon: "terminal" }),
    test_check: Object.freeze({ label: "Check", zone: "workshop", tone: "done", icon: "check" }),
    planning_thinking: Object.freeze({ label: "Plan", zone: "steamworks", tone: "ticket", icon: "bookOpen" }),
    generic_tool_work: Object.freeze({ label: "Tool work", zone: "workshop", tone: "tool", icon: "tool" }),
    completed: Object.freeze({ label: "Done", zone: "common", tone: "done", icon: "check" }),
    idle_available: Object.freeze({ label: "Available", zone: "common", tone: "idle", icon: "clock" }),
    blocked: Object.freeze({ label: "Blocked", zone: "exception", tone: "blocked", icon: "alert" }),
    failed: Object.freeze({ label: "Failed", zone: "exception", tone: "failed", icon: "alert" }),
    restricted_missing_stale: Object.freeze({ label: "Limited", zone: "exception", tone: "limited", icon: "shield" }),
  });

  function norm(value) { return String(value || "").trim().toLowerCase(); }
  function hasValue(value) { return value !== null && value !== undefined && String(value).trim().length > 0; }
  function changedAtMillis(value) {
    const millis = Date.parse(value || "");
    return Number.isFinite(millis) ? millis : 0;
  }
  function factoryPermissionDenied(error) {
    const message = norm(error && error.message);
    return error && (error.status === 401 || error.status === 403) || message.includes("authentication required") || message.includes("forbidden") || message.includes("not authorized") || message.includes("permission");
  }
  function dateTimeLabel(value) {
    if (!value) return "Not loaded";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? "Not loaded" : date.toLocaleString([], { month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" });
  }
  function ageLabel(value) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const seconds = Math.max(0, Math.round((Date.now() - date.getTime()) / 1000));
    if (seconds < 60) return `${seconds}s`;
    const minutes = Math.round(seconds / 60);
    if (minutes < 60) return `${minutes}m`;
    return `${Math.round(minutes / 60)}h`;
  }
  function titleLabel(value) {
    const clean = String(value || "").replace(/[-_]+/g, " ").trim();
    return clean ? clean.replace(/\b\w/g, (match) => match.toUpperCase()) : "Unknown";
  }
  function workTitle(item) {
    return String(item && (item.title || item.displayLabel || item.currentWorkTitle) || "Untitled work").trim();
  }
  function latestWorkTime(item) {
    return item && (item.updatedAt || item.lastEventAt || (item.timing && item.timing.updatedAt) || (item.timing && item.timing.createdAt) || "");
  }
  function workRunId(item) {
    return item && (item.runId || item.id || "");
  }
  function workThreadId(item) {
    const tool = (item && item.tool) || {};
    const refs = (item && item.animationIntent && item.animationIntent.backingReferences) || {};
    return item && (item.threadId || item.threadID) || tool.threadId || refs.threadId || "";
  }
  function workCategory(item) {
    let category = norm(item && (item.category || item.representativeCategory || (item.semanticEvent && item.semanticEvent.category) || (item.animationIntent && item.animationIntent.category)));
    if (category.includes("sketch")) return "sketch";
    const searchable = norm(`${item && item.title || ""} ${item && item.detail || ""} ${item && item.displayLabel || ""}`);
    if ((category === "" || category === "document" || category === "note" || category === "generic_tool_work") && /sketch|draw(ing)?\b|paint|canvas|diagram|wireframe|mock-?up|illustrat/.test(searchable)) return "sketch";
    return category || "generic_tool_work";
  }
  function workStatus(item) {
    return norm(item && (item.status || item.state || item.representativeStatus)) || "idle";
  }
  function isActiveWork(item) {
    const state = workStatus(item);
    return state.includes("run") || state.includes("work") || state.includes("queue") || state.includes("delegat") || state.includes("input") || state.includes("pending");
  }
  function officeChangeFromChange(change) {
    const details = change && change.details;
    const officeChange = details && details.officeChange;
    if (!officeChange || officeChange.contractVersion !== "office-action-center.v1") return null;
    return officeChange;
  }
  function isFactoryRefreshChange(change) {
    const toolName = norm(change && change.toolName);
    if (toolName.startsWith("action-center/")) return true;
    if (change && change.kind === "employee-activity" && change.jobId) return true;
    if (change && change.kind === "tool-call" && change.aiEmployeeId) return true;
    return false;
  }
  function officeChangeRunKey(officeChange) {
    return String((officeChange && officeChange.runId) || (officeChange && officeChange.workItem && officeChange.workItem.runId) || "");
  }
  function officeChangeIsNewer(previous, officeChange) {
    if (!previous) return true;
    const nextVersion = Number(officeChange && officeChange.version) || 0;
    const previousVersion = Number(previous.version) || 0;
    if (nextVersion !== previousVersion) return nextVersion > previousVersion;
    return changedAtMillis(officeChange && officeChange.changedAt) >= changedAtMillis(previous.changedAt);
  }
  function workByRunId(snapshot, runId) {
    const work = snapshot && Array.isArray(snapshot.work) ? snapshot.work : [];
    return work.find((item) => String(workRunId(item)) === String(runId)) || null;
  }
  function workReference(item) {
    if (!item) return null;
    const timing = item.timing || {};
    return {
      runId: workRunId(item),
      state: item.state || "",
      status: item.status || "",
      category: workCategory(item),
      title: workTitle(item),
      updatedAt: latestWorkTime(item) || timing.updatedAt || timing.createdAt || "",
      animationIntent: item.animationIntent || null,
    };
  }
  function employeeStateFromWorkItem(item) {
    const state = workStatus(item);
    if (state.includes("restricted") || state.includes("denied") || state.includes("permission")) return "restricted";
    if (state.includes("stale")) return "stale";
    if (state.includes("missing") || state.includes("unavailable")) return "missing";
    if (state.includes("loading") || state.includes("pending")) return "loading";
    if (state.includes("fail") || state.includes("error")) return "failed";
    if (state.includes("block") || state.includes("need")) return "blocked";
    if (state.includes("queue")) return "queued";
    if (state.includes("delegat")) return "delegated";
    if (state.includes("complete") || state.includes("done")) return "completed";
    if (state.includes("run") || state.includes("work") || state.includes("progress")) return "running";
    return item ? (item.state || item.status || "running") : "idle";
  }
  function mergeFactoryWorkItemIntoSnapshot(snapshot, officeChange) {
    const workItem = officeChange && officeChange.workItem;
    const runId = workRunId(workItem);
    const employeeId = workItem && workItem.employeeId;
    if (!snapshot || !workItem || !runId || !employeeId) return null;

    let employeeFound = false;
    const work = Array.isArray(snapshot.work) ? snapshot.work.slice() : [];
    const workIndex = work.findIndex((item) => String(workRunId(item)) === String(runId));
    if (workIndex >= 0) work[workIndex] = { ...work[workIndex], ...workItem };
    else work.push(workItem);
    work.sort((a, b) => new Date(latestWorkTime(b) || 0) - new Date(latestWorkTime(a) || 0));

    const reference = workReference(workItem);
    const employees = (Array.isArray(snapshot.employees) ? snapshot.employees : []).map((employee) => {
      if (String(employee && employee.id) !== String(employeeId)) return employee;
      employeeFound = true;
      const recentHistory = Array.isArray(employee.recentHistory) ? employee.recentHistory.filter((item) => String(item && item.runId) !== String(runId)) : [];
      const activeWorkCount = work.filter((item) => String(item.employeeId) === String(employeeId) && isActiveWork(item)).length;
      return {
        ...employee,
        state: employeeStateFromWorkItem(workItem),
        currentRunId: runId,
        currentWorkTitle: workTitle(workItem),
        queueCount: Math.max(Number(employee.queueCount) || 0, activeWorkCount),
        lastActivityAt: latestWorkTime(workItem) || employee.lastActivityAt,
        currentWork: reference,
        recentHistory: [reference, ...recentHistory].filter(Boolean).slice(0, 12),
      };
    });
    if (!employeeFound) return null;

    const generatedAt = (officeChange && officeChange.changedAt) || new Date().toISOString();
    return {
      ...snapshot,
      generatedAt,
      freshness: {
        ...(snapshot.freshness || {}),
        state: "live",
        lastRunUpdatedAt: generatedAt,
        reason: "Updated from the live Office change stream.",
      },
      caps: {
        ...(snapshot.caps || {}),
        includedWorkCount: work.length,
      },
      employees,
      work,
    };
  }
  function orderedEmployees(snapshot) {
    const employees = snapshot && Array.isArray(snapshot.employees) ? snapshot.employees : [];
    return employees.slice().sort((a, b) => {
      const activeDiff = (isActiveEmployee(b) ? 1 : 0) - (isActiveEmployee(a) ? 1 : 0);
      if (activeDiff) return activeDiff;
      return String(a && a.name || "").localeCompare(String(b && b.name || ""));
    });
  }
  function factoryRosterEmployees(snapshot, db) {
    const officeEmployees = snapshot && Array.isArray(snapshot.employees) ? snapshot.employees : [];
    const fullEmployees = db && Array.isArray(db.employees) ? db.employees : [];
    const work = snapshot && Array.isArray(snapshot.work) ? snapshot.work : [];
    const activeCounts = new Map();
    const activeThreadsByEmployee = new Map();
    work.forEach((item) => {
      if (!item || !isActiveWork(item)) return;
      const employeeId = String(item.employeeId || "");
      if (!employeeId) return;
      activeCounts.set(employeeId, (activeCounts.get(employeeId) || 0) + 1);
      const threads = activeThreadsByEmployee.get(employeeId) || [];
      threads.push(item);
      activeThreadsByEmployee.set(employeeId, threads);
    });
    activeThreadsByEmployee.forEach((threads, employeeId) => {
      activeThreadsByEmployee.set(employeeId, threads.slice().sort((a, b) => changedAtMillis(latestWorkTime(b)) - changedAtMillis(latestWorkTime(a))));
    });
    const byId = new Map(fullEmployees.map((employee) => [String(employee && employee.id || ""), employee]).filter(([id]) => !!id));
    const seen = new Set();
    const merged = officeEmployees.map((officeEmployee) => {
      const full = byId.get(String(officeEmployee && officeEmployee.id || "")) || {};
      const id = String((officeEmployee && officeEmployee.id) || full.id || "");
      if (id) seen.add(id);
      return {
        ...full,
        ...officeEmployee,
        standardTasks: Array.isArray(full.standardTasks) ? full.standardTasks : (officeEmployee && officeEmployee.standardTasks) || [],
        type: full.type || officeEmployee.type || "Ai",
        active: full.active !== false && officeEmployee.active !== false,
        activeThreadCount: activeCounts.get(id) || 0,
        activeThreads: activeThreadsByEmployee.get(id) || [],
      };
    });
    fullEmployees.forEach((employee) => {
      const id = String(employee && employee.id || "");
      if (!id || seen.has(id) || employee.active === false || norm(employee.type || "Ai") !== "ai") return;
      merged.push({ ...employee, activeThreadCount: activeCounts.get(id) || 0, activeThreads: activeThreadsByEmployee.get(id) || [] });
      seen.add(id);
    });
    return merged.sort((a, b) => {
      const activeDiff = (isActiveEmployee(b) ? 1 : 0) - (isActiveEmployee(a) ? 1 : 0);
      if (activeDiff) return activeDiff;
      const queueDiff = (Number(b && b.activeThreadCount) || 0) - (Number(a && a.activeThreadCount) || 0);
      if (queueDiff) return queueDiff;
      return String(a && a.name || "").localeCompare(String(b && b.name || ""));
    });
  }
  function isActiveEmployee(employee) {
    const state = norm(employee && employee.state);
    return !["", "idle", "completed", "done"].includes(state) || !!(employee && employee.currentRunId);
  }
  function currentWorkForEmployee(snapshot, employee) {
    if (!snapshot || !employee) return null;
    if (employee.currentRunId) return workByRunId(snapshot, employee.currentRunId) || employee.currentWork || null;
    const work = Array.isArray(snapshot.work) ? snapshot.work : [];
    return work.find((item) => String(item.employeeId) === String(employee.id) && isActiveWork(item)) || employee.currentWork || null;
  }
  function metaForWork(work, employee) {
    const status = workStatus(work) || norm(employee && employee.state);
    if (status.includes("block") || status.includes("need")) return CATEGORY_META.blocked;
    if (status.includes("fail") || status.includes("error")) return CATEGORY_META.failed;
    if (status.includes("complete") || status.includes("done")) return CATEGORY_META.completed;
    if (status.includes("restrict") || status.includes("stale") || status.includes("missing")) return CATEGORY_META.restricted_missing_stale;
    return CATEGORY_META[workCategory(work)] || CATEGORY_META.generic_tool_work;
  }
  function hashString(value) {
    let h = 0;
    for (let i = 0; i < value.length; i += 1) h = (h * 31 + value.charCodeAt(i)) | 0;
    return Math.abs(h);
  }
  function avatarFor(employee) {
    const preset = window.avatarPreset ? window.avatarPreset(employee && employee.avatarKey) : null;
    const color = window.avatarColor ? window.avatarColor((employee && (employee.avatarKey || employee.name)) || "") : "#d9c69a";
    if (preset && preset.image) return <span className="factory-avatar has-image" style={{ background: color }}><img src={preset.image} alt="" aria-hidden="true" /></span>;
    return <span className="factory-avatar" style={{ background: color }}>{preset ? preset.glyph : window.initials ? window.initials(employee && employee.name) : String(employee && employee.name || "A").slice(0, 2).toUpperCase()}</span>;
  }
  function currentUrlWithoutHash() {
    return `${window.location.origin}${window.location.pathname}${window.location.search}`;
  }
  function activityReferenceFor(employee) {
    return {
      type: "Action Center",
      id: (employee && employee.id) || "",
      label: (employee && employee.name) || "AI employee",
      url: currentUrlWithoutHash(),
      fields: {
        Employee: (employee && employee.name) || "",
        EmployeeId: (employee && employee.id) || "",
        Role: (employee && employee.role) || "AI employee",
      },
    };
  }
  function submitPromptOnEnter(event, submit) {
    if (event.key !== "Enter" || event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) return;
    event.preventDefault();
    submit();
  }
  const FACTORY_THREAD_CHIPS = Object.freeze({
    action_center_activity: Object.freeze({ label: "DISPATCH", color: "#8a6a28" }),
    delegation: Object.freeze({ label: "HANDOFF", color: "#6d5580" }),
    project_context_read: Object.freeze({ label: "ARCHIVE", color: "#4c6342" }),
    source_review: Object.freeze({ label: "ARCHIVE", color: "#4c6342" }),
    ticket_work_package: Object.freeze({ label: "TICKET", color: "#40607a" }),
    note: Object.freeze({ label: "NOTE", color: "#84642e" }),
    document: Object.freeze({ label: "DOCUMENT", color: "#84642e" }),
    email: Object.freeze({ label: "MAIL", color: "#8a5a30" }),
    sketch: Object.freeze({ label: "SKETCH", color: "#7a4460" }),
    generic_tool_work: Object.freeze({ label: "TOOL WORK", color: "#535e56" }),
    blocked: Object.freeze({ label: "BLOCKED", color: "#8c3524" }),
    failed: Object.freeze({ label: "FAILED", color: "#8c3524" }),
    completed: Object.freeze({ label: "DONE", color: "#3c6344" }),
  });
  function factoryRunId(value) {
    return String(value && (value.runId || value.id) || "");
  }
  function factoryThreadStatus(value, active) {
    const clean = norm(value && (value.status || value.state));
    if (clean.includes("need") || clean.includes("block")) return "blocked";
    if (clean.includes("fail") || clean.includes("error") || clean.includes("cancel") || clean.includes("stop")) return "failed";
    if (clean.includes("done") || clean.includes("complete") || clean === "review") return "completed";
    return active === false ? "completed" : "running";
  }
  function factoryThreadCategory(value) {
    const semantic = value && value.semanticEvent || {};
    const clean = norm(value && (value.category || value.representativeCategory) || semantic.category || value && value.sourceType);
    if (clean.includes("sketch")) return "sketch";
    if (clean.includes("ticket")) return "ticket_work_package";
    if (clean.includes("mail") || clean.includes("email")) return "email";
    if (clean.includes("document")) return "document";
    if (clean.includes("note")) return "note";
    if (clean.includes("delegat") || clean.includes("handoff")) return "delegation";
    if (clean.includes("archive") || clean.includes("context") || clean.includes("source")) return "project_context_read";
    return clean || "generic_tool_work";
  }
  function factoryThreadChip(value, status) {
    if (status === "blocked") return FACTORY_THREAD_CHIPS.blocked;
    if (status === "failed") return FACTORY_THREAD_CHIPS.failed;
    if (status === "completed") return FACTORY_THREAD_CHIPS.completed;
    return FACTORY_THREAD_CHIPS[factoryThreadCategory(value)] || FACTORY_THREAD_CHIPS.generic_tool_work;
  }
  function factoryIsFinishedWork(item) {
    return factoryThreadStatus(item, true) === "completed";
  }
  function factoryThreadUpdatedAt(item) {
    return item && (item.updatedAt || item.lastEventAt || (item.timing && item.timing.updatedAt) || (item.timing && item.timing.createdAt) || item.createdAt) || "";
  }
  function factoryFinishedThreads(snapshot) {
    const work = snapshot && Array.isArray(snapshot.finishedWork)
      ? snapshot.finishedWork
      : snapshot && Array.isArray(snapshot.work) ? snapshot.work : [];
    const employees = snapshot && Array.isArray(snapshot.employees) ? snapshot.employees : [];
    const employeeById = new Map(employees.map((employee) => [String(employee && employee.id || ""), employee]).filter(([id]) => !!id));
    return work
      .filter((item) => item && factoryRunId(item) && factoryIsFinishedWork(item))
      .map((item) => ({
        run: item,
        work: item,
        employee: employeeById.get(String(item.employeeId || "")) || {
          id: item.employeeId || "",
          name: item.employeeName || item.aiEmployeeName || "AI employee",
          role: item.employeeRole || "",
        },
        title: workTitle(item),
        threadId: workThreadId(item),
        updatedAt: factoryThreadUpdatedAt(item),
        active: false,
      }))
      .sort((a, b) => changedAtMillis(b.updatedAt) - changedAtMillis(a.updatedAt))
      .slice(0, 24);
  }
  function factoryFinishedThreadTime(value) {
    if (!value) return "Finished";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "Finished";
    return date.toLocaleDateString([], { month: "short", day: "2-digit" });
  }
  function factoryThreadMessageType(message) {
    const kind = norm(message && message.kind);
    const role = norm(message && message.role);
    const isTool = kind.includes("tool") || kind.includes("command") || kind.includes("exec");
    if (!isTool && (role === "system" || ["step", "done", "prompt-tags", "steering"].includes(kind))) return "system";
    if (isTool) return "tool";
    if (role === "user") return "you";
    return "agent";
  }
  function factoryThreadTime(value) {
    if (!value) return "";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? "" : date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  }
  function factoryThreadChangedAtMillis(value) {
    const date = new Date(value || 0);
    return Number.isNaN(date.getTime()) ? 0 : date.getTime();
  }
  function factoryThreadSort(a, b) {
    const byTime = factoryThreadChangedAtMillis(a && a.at) - factoryThreadChangedAtMillis(b && b.at);
    if (byTime) return byTime;
    return (Number(a && a.position) || 0) - (Number(b && b.position) || 0);
  }
  function factoryThreadSameText(a, b) {
    const left = String(a && a.text || "").trim();
    const right = String(b && b.text || "").trim();
    if (!left || !right) return false;
    return left === right || (factoryThreadMessageType(a) === "agent" && factoryThreadMessageType(b) === "agent" && (left.startsWith(right) || right.startsWith(left)));
  }
  function factoryThreadLiveKey(parts) {
    return ["live"].concat(parts.map((part) => String(part || "").trim()).filter(Boolean)).join(":");
  }
  function factoryThreadLiveSpeechKey(runId, messageType, toolName, turnId, itemId, eventMethod) {
    const method = norm(eventMethod);
    const type = norm(messageType || toolName || "assistant");
    const item = String(itemId || "").trim();
    const turn = String(turnId || "").trim();
    return factoryThreadLiveKey(["speech", runId || "run", type || method || "assistant", item || turn || method || "current"]);
  }
  function factoryThreadSpeechText(value) {
    const text = String(value || "").replace(/\s+/g, " ").trim();
    if (!text || text.length > 8000) return "";
    if (/(authorization|credential|secret|password|api[_-]?key|bearer\s)/i.test(text)) return "";
    return text;
  }
  function factorySpeechTextFromActivity(activity) {
    return window.ActionCenterActivity ? window.ActionCenterActivity.speechTextFromActivity(activity) : factoryThreadSpeechText(activity && (activity.streamText || activity.lastSpeechText || activity.message));
  }
  function factoryActivityKey(activity) {
    if (!activity) return "";
    return [
      activity.runId || "",
      activity.id || "",
      activity.changedAt || activity.createdAt || "",
      activity.messageType || activity.toolName || "",
      activity.streamPreviewText || activity.message || "",
    ].map((part) => String(part || "").trim()).filter(Boolean).join(":");
  }
  function factoryToolGlyph(activity) {
    const meta = window.actionCenterActivityMeta ? window.actionCenterActivityMeta(activity) : null;
    const icon = norm(meta && meta.icon);
    const toolName = norm(activity && (activity.toolName || activity.messageType));
    if (icon.includes("terminal") || toolName.includes("command") || toolName.includes("exec")) return ">_";
    if (icon.includes("search") || icon.includes("globe") || toolName.includes("search") || toolName.includes("web")) return "⌕";
    if (icon.includes("book") || icon.includes("doc") || toolName.includes("read") || toolName.includes("get")) return "B";
    if (icon.includes("edit") || toolName.includes("write") || toolName.includes("update")) return "✎";
    if (icon.includes("plus") || toolName.includes("create") || toolName.includes("add")) return "+";
    if (icon.includes("trash") || toolName.includes("delete") || toolName.includes("remove")) return "×";
    if (icon.includes("mail") || toolName.includes("email") || toolName.includes("message")) return "@";
    if (icon.includes("calendar") || toolName.includes("meeting") || toolName.includes("calendar")) return "◷";
    if (icon.includes("wallet") || icon.includes("invoice") || toolName.includes("finance") || toolName.includes("invoice") || toolName.includes("expense")) return "$";
    if (icon.includes("check") || toolName.includes("test")) return "✓";
    if (icon.includes("handover") || toolName.includes("delegate")) return "⇄";
    return "⚙";
  }
  function factoryToolBubbleFromActivity(activity) {
    if (!activity) return null;
    const toolKey = window.ActionCenterActivity ? window.ActionCenterActivity.activityToolKey(activity) : norm(activity.toolName || activity.messageType);
    if (!toolKey || toolKey === "assistant_response" || toolKey === "assistant-delta") return null;
    const key = factoryActivityKey(activity);
    if (!key) return null;
    const meta = window.actionCenterActivityMeta ? window.actionCenterActivityMeta(activity) : null;
    const label = String((meta && meta.label) || activity.toolText || activity.message || activity.toolName || "Using tool").trim();
    return { key, label, glyph: factoryToolGlyph(activity), at: performance.now() / 1000 };
  }
  function factorySpeechMessageFromActivity(activity) {
    const text = factorySpeechTextFromActivity(activity);
    if (!text) return null;
    return {
      id: factoryThreadLiveKey(["speech", activity && (activity.runId || activity.id || activity.changedAt || "bridge")]),
      kind: activity && (activity.messageType || activity.toolName) || "assistant_response",
      role: "assistant",
      text,
      at: activity && (activity.changedAt || activity.createdAt) || new Date().toISOString(),
      live: true,
    };
  }
  function factoryToolMessageFromActivity(activity) {
    if (!activity || factorySpeechTextFromActivity(activity)) return null;
    const toolName = String(activity.toolName || activity.messageType || "").trim();
    if (!toolName || norm(toolName).startsWith("action-center/")) return null;
    const command = String(activity.command || "").trim();
    const label = String(activity.message || (command ? "Running command" : `Calling ${toolName}`)).trim();
    return {
      id: factoryThreadLiveKey(["tool", activity.runId || "", toolName, activity.changedAt || activity.id || "bridge"]),
      kind: "tool",
      role: "tool",
      text: `${label}${command ? `\n${command}` : ""}`.trim(),
      at: activity.changedAt || activity.createdAt || new Date().toISOString(),
      live: true,
      toolName,
    };
  }
  function factoryThreadStableMessage(next, previous, animate) {
    const nextType = factoryThreadMessageType(next);
    const previousType = factoryThreadMessageType(previous);
    let text = String(next && next.text || "").trim();
    if (nextType === "agent") {
      const previousText = String(previous && previous.text || "").trim();
      const incomingText = factoryThreadSpeechText(next && next.text);
      const incomingDelta = String(next && next.delta || "");
      const cleanDelta = factoryThreadSpeechText(incomingDelta);
      if (previous && previousType === "agent" && incomingDelta) {
        const hasAccumulatedText = incomingText && cleanDelta && incomingText.length > cleanDelta.length;
        text = hasAccumulatedText ? incomingText : factoryThreadSpeechText(`${previousText}${incomingDelta || incomingText}`);
      } else if (previous && previousType === "agent" && previousText && incomingText && previousText.startsWith(incomingText) && (previous.live || next && next.live)) {
        text = previousText;
      } else {
        text = incomingText;
      }
    }
    const typedLength = text.length;
    const previousTyped = previous ? Math.min(previous.typed || 0, typedLength) : null;
    const liveAgent = !!(next && next.live) && nextType === "agent";
    const typed = liveAgent ? typedLength : previousTyped !== null ? previousTyped : animate && nextType === "agent" ? 0 : typedLength;
    const merged = {
      id: String(previous && previous.live && next && next.live && previousType === nextType ? previous.id : next && next.id || factoryThreadLiveKey([next && next.kind, next && next.at, text])),
      kind: String(next && next.kind || ""),
      role: String(next && next.role || ""),
      text,
      at: next && next.at || new Date().toISOString(),
      position: Number(next && next.position) || 0,
      typed,
      local: !!(next && next.local),
      live: !!(next && next.live),
      toolName: String(next && next.toolName || ""),
    };
    if (previous
      && previous.kind === merged.kind
      && previous.role === merged.role
      && previous.text === merged.text
      && previous.at === merged.at
      && previous.position === merged.position
      && previous.typed === merged.typed
      && previous.local === merged.local
      && previous.live === merged.live
      && previous.toolName === merged.toolName) return previous;
    return merged;
  }
  function factoryThreadServerMessage(message, previous, animateAgent) {
    const text = String(message && message.text || "").trim();
    return factoryThreadStableMessage({
      id: String(message && message.id || `srv:${message && message.position || ""}:${message && message.createdAt || ""}:${text}`),
      kind: String(message && message.kind || ""),
      role: String(message && message.role || ""),
      text,
      at: message && message.createdAt || new Date().toISOString(),
      position: Number(message && message.position) || 0,
      local: false,
    }, previous, animateAgent);
  }
  function factoryWorkNeedsInput(item) {
    const queue = item && item.queue || {};
    const status = workStatus(item);
    return !!(queue.needsInput || queue.approvalRequestId || queue.approvalRequestTitle || status.includes("needs-input") || status.includes("need"));
  }
  function factoryApprovalFromRun(run, fallback) {
    if (window.actionCenterApprovalFromRun) {
      const approval = window.actionCenterApprovalFromRun(run || {});
      if (approval) return approval;
    }
    const queue = fallback && fallback.queue || {};
    const requestId = String((run && run.approvalRequestId) || queue.approvalRequestId || "").trim();
    const title = String((run && run.approvalRequestTitle) || queue.approvalRequestTitle || fallback && fallback.approvalTitle || "Needs your input").trim();
    const body = String((run && run.approvalRequestBody) || queue.approvalRequestBody || "").trim();
    const payloadJson = String((run && run.approvalRequestPayloadJson) || queue.approvalRequestPayloadJson || "").trim();
    if (!requestId && !title && !body) return null;
    return {
      requestId,
      method: (run && run.approvalRequestMethod) || queue.approvalRequestMethod || "",
      title,
      body,
      payloadJson,
      response: (run && run.approvalResponseText) || "",
    };
  }
  function factoryThreadDetail(change, key) {
    const details = change && change.details || {};
    return details[key] ?? details[key.charAt(0).toUpperCase() + key.slice(1)] ?? "";
  }
  function factoryThreadLiveMessagesFromChange(change, runId) {
    if (!change || String(change.jobId || "") !== String(runId || "")) {
      const officeChange = officeChangeFromChange(change);
      if (String(officeChangeRunKey(officeChange)) !== String(runId || "")) return [];
    }
    const changedAt = change.changedAt || new Date().toISOString();
    const activityKind = String(change.toolName || "").trim();
    const messageType = String(factoryThreadDetail(change, "messageType") || activityKind).trim();
    const toolName = String(factoryThreadDetail(change, "toolName") || "").trim();
    const itemId = String(factoryThreadDetail(change, "itemId") || "");
    const turnId = String(factoryThreadDetail(change, "turnId") || "");
    const detailText = String(factoryThreadDetail(change, "text") || "");
    const delta = String(factoryThreadDetail(change, "delta") || "");
    const command = String(factoryThreadDetail(change, "command") || "");
    const explanation = String(factoryThreadDetail(change, "explanation") || "");
    const eventMethod = String(factoryThreadDetail(change, "eventMethod") || "");
    const officeChange = officeChangeFromChange(change);
    const work = officeChange && officeChange.workItem;
    const event = work && work.event || {};
    const officeMessageId = event.latestMessageId || officeChange && officeChange.latestMessageId || "";
    const officeKind = event.latestMessageKind || "";
    const officeRole = event.latestMessageRole || "";
    const officeText = event.latestMessageText || "";
    const officeAt = event.latestMessageAt || officeChange && officeChange.changedAt || changedAt;
    const messages = [];
    const activity = window.ActionCenterActivity ? {
      toolName,
      messageType,
      streamText: detailText || delta,
      lastSpeechText: detailText || delta,
      changedAt,
    } : null;
    const looksLikeSpeech = /assistant[-_](delta|response|thinking)|agentmessage|agent_message|reasoning/.test(norm(`${activityKind} ${messageType} ${toolName} ${eventMethod}`));
    const isSpeech = (window.ActionCenterActivity && window.ActionCenterActivity.isAssistantResponseActivity(activity)) || looksLikeSpeech;
    if (isSpeech) {
      const speech = factoryThreadSpeechText(detailText || delta || change.message || officeText);
      if (speech) {
        messages.push({
          id: factoryThreadLiveSpeechKey(runId, messageType, toolName, turnId, itemId || officeMessageId, eventMethod),
          kind: messageType || "assistant_response",
          role: "assistant",
          text: speech,
          delta,
          at: changedAt,
          live: true,
        });
      }
      return messages;
    }
    if (toolName && !norm(toolName).startsWith("action-center/") && !/assistant_(response|thinking)/.test(norm(toolName))) {
      const cleanCommand = command ? `\n${command}` : "";
      const cleanExplanation = explanation ? `\n${explanation}` : "";
      const label = change.message || (command ? "Running command" : `Calling ${toolName}`);
      messages.push({
        id: factoryThreadLiveKey(["tool", toolName, turnId, itemId || changedAt]),
        kind: "tool",
        role: "tool",
        text: `${String(label || "Tool call").trim()}${cleanCommand}${cleanExplanation}`.trim(),
        at: changedAt,
        live: true,
        toolName,
      });
    }
    if (officeMessageId && officeText) {
      messages.push({
        id: String(officeMessageId),
        kind: officeKind,
        role: officeRole,
        text: officeText,
        at: officeAt,
        live: true,
      });
    }
    return messages;
  }
  function factoryThreadMenuSeed(employee, work) {
    const status = factoryThreadStatus(work, true);
    return {
      run: work,
      work,
      employee: {
        id: (employee && employee.id) || (work && work.employeeId) || "",
        name: (employee && employee.name) || (work && (work.employeeName || work.aiEmployeeName)) || "AI employee",
        role: (employee && employee.role) || (work && work.employeeRole) || "",
      },
      title: workTitle(work),
      threadId: workThreadId(work),
      approvalTitle: work && work.queue && work.queue.approvalRequestTitle || "",
      active: !["completed", "failed"].includes(status),
    };
  }
  function FactoryRoster({ employees, busyKey, onStart, onOpenThreads }) {
    return (
      <section className="factory-roster-panel" data-appligator-id="factory-roster">
        <header>
          <div>
            <strong>Factory roster</strong>
            <span>Start standard tasks or custom Action Center threads.</span>
          </div>
          <span>{employees.length} on roster</span>
        </header>
        {employees.length === 0 ? (
          <div className="factory-roster-empty">No AI employees are available in this workspace.</div>
        ) : (
          <div className="factory-roster-grid">
            {employees.map((employee) => {
              const activeCount = Number(employee && employee.activeThreadCount) || 0;
              const hasThreads = activeCount > 0 && Array.isArray(employee && employee.activeThreads) && employee.activeThreads.length > 0;
              const openThreads = (event) => {
                if (!hasThreads || !onOpenThreads) return;
                if (event && event.stopPropagation) event.stopPropagation();
                onOpenThreads(employee, event);
              };
              return (
                <article
                  key={employee.id || employee.name}
                  className={`factory-roster-card ${isActiveEmployee(employee) ? "active" : ""} ${hasThreads ? "has-threads" : ""}`}
                  data-appligator-id={`factory-roster-employee-${employee.id || employee.name}`}
                  onClick={openThreads}
                >
                  <div className="factory-roster-main">
                    <button
                      type="button"
                      className="factory-roster-entry-button"
                      disabled={!hasThreads}
                      aria-haspopup={hasThreads ? "menu" : undefined}
                      aria-label={hasThreads ? `Open ${activeCount} active thread${activeCount === 1 ? "" : "s"} for ${employee.name || "AI employee"}` : undefined}
                      title={hasThreads ? `Open active threads for ${employee.name || "AI employee"}` : undefined}
                      onClick={openThreads}
                    >
                      {avatarFor(employee)}
                      <strong>{employee.name || "AI employee"}</strong>
                      <span className="factory-roster-count" title={`${activeCount} active thread${activeCount === 1 ? "" : "s"}`}>{activeCount}</span>
                    </button>
                    <button type="button" className="factory-roster-new" disabled={!!busyKey} title={`Start a new thread with ${employee.name || "AI employee"}`} aria-label={`Start a new thread with ${employee.name || "AI employee"}`} onClick={(event) => { event.stopPropagation(); onStart(employee, event); }}>
                      <Icon name="plus" size={12} />
                      <span>New</span>
                    </button>
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </section>
    );
  }
  function FactoryRosterThreadMenu({ menu, onClose, onOpen }) {
    if (!menu || !menu.employee) return null;
    const employee = menu.employee;
    const threads = Array.isArray(employee.activeThreads) ? employee.activeThreads : [];
    return (
      <div className="factory-roster-thread-menu" style={{ left: menu.x, top: menu.y }} onMouseDown={(event) => event.stopPropagation()} role="menu" data-appligator-id="factory-roster-thread-menu">
        <header>
          <div>
            <strong>Active threads</strong>
            <span>{employee.name || "AI employee"}</span>
          </div>
          <button type="button" className="iconbtn" title="Close" aria-label="Close active threads" onClick={onClose}><Icon name="close" size={14} /></button>
        </header>
        <div className="factory-roster-thread-list">
          {threads.map((work) => {
            const runId = factoryRunId(work);
            const meta = metaForWork(work, employee);
            const updatedAt = latestWorkTime(work);
            return (
              <button key={runId || `${employee.id}-${workTitle(work)}`} type="button" className="factory-roster-thread-item" role="menuitem" onClick={() => onOpen(factoryThreadMenuSeed(employee, work))}>
                <span className={`factory-roster-thread-icon tone-${meta.tone || "tool"}`}><Icon name={meta.icon || "play"} size={13} /></span>
                <span className="factory-roster-thread-copy">
                  <strong>{workTitle(work)}</strong>
                  <em>{[meta.label, ageLabel(updatedAt)].filter(Boolean).join(" - ") || runId}</em>
                </span>
                <Icon name="chevR" size={13} />
              </button>
            );
          })}
        </div>
      </div>
    );
  }
  function FactoryFinishedThreadStack({ threads, onOpen }) {
    return (
      <section className="factory-finished-thread-stack" data-appligator-id="factory-finished-thread-stack">
        <header>
          <div>
            <strong>Task board</strong>
            <span>Finished threads handed back for follow-up.</span>
          </div>
          <span>{threads.length}</span>
        </header>
        {threads.length === 0 ? (
          <div className="factory-finished-thread-empty">No finished threads are waiting on the board.</div>
        ) : (
          <div className="factory-finished-thread-list">
            {threads.map((thread) => {
              const runId = factoryRunId(thread.run || thread.work || thread);
              const employee = thread.employee || {};
              return (
                <button
                  key={runId}
                  type="button"
                  className="factory-finished-thread-card"
                  data-appligator-id={`factory-finished-thread-${runId}`}
                  onClick={() => onOpen(thread)}
                >
                  <span className="factory-finished-folder" aria-hidden="true"><Icon name="archive" size={16} /></span>
                  <span className="factory-finished-thread-copy">
                    <strong>{thread.title || "Finished thread"}</strong>
                    <em>{employee.name || "AI employee"} - {factoryFinishedThreadTime(thread.updatedAt)}</em>
                  </span>
                  <Icon name="chevR" size={14} />
                </button>
              );
            })}
          </div>
        )}
      </section>
    );
  }
  function FactoryThreadModal({ seed, activity, speechActivity, onClose, onChanged, onToast, onError }) {
    const [run, setRun] = useState(seed && seed.run || null);
    const [messages, setMessages] = useState([]);
    const [text, setText] = useState("");
    const [loading, setLoading] = useState(true);
    const [busy, setBusy] = useState("");
    const [error, setError] = useState("");
    const pollRef = useRef(null);
    const unsubscribeRef = useRef(null);
    const logRef = useRef(null);
    const stickToBottomRef = useRef(true);
    const runId = factoryRunId(seed && (seed.run || seed.work || seed));
    const employee = seed && seed.employee || {};
    const currentRun = run || (seed && seed.run) || {};
    const title = String(currentRun.title || seed && seed.title || "Action Center thread").trim();
    const threadId = String(currentRun.threadId || currentRun.tool && currentRun.tool.threadId || seed && seed.threadId || "");
    const status = factoryThreadStatus(currentRun, run ? true : seed && seed.active);
    const active = status !== "failed";
    const followUpMode = status === "completed";
    const needsInput = active && (status === "blocked" || !!(currentRun.queue && currentRun.queue.needsInput) || norm(currentRun.status).includes("needs-input"));
    const approvalTitle = String(currentRun.approvalRequestTitle || currentRun.queue && currentRun.queue.approvalRequestTitle || seed && seed.approvalTitle || "the work at hand").trim();
    const chip = factoryThreadChip(currentRun, status);

    const requestClose = useCallback(() => {
      if (busy) return;
      onClose();
    }, [busy, onClose]);

    const mergeMessages = useCallback((incoming, animateNew) => {
      const list = Array.isArray(incoming) ? incoming : [];
      if (!list.length) return;
      setMessages((current) => {
        const byId = new Map(current.map((item) => [String(item.id), item]));
        const consumed = new Set();
        const next = current.slice();
        let changed = false;
        list.forEach((message) => {
          const id = String(message && message.id || "");
          let previous = id ? byId.get(id) : null;
          if (!previous) {
            previous = next.find((item) => !consumed.has(item.id) && item.live && factoryThreadSameText(item, message)) || null;
          }
          const merged = factoryThreadStableMessage(message, previous, animateNew && !previous);
          const index = previous ? next.findIndex((item) => String(item.id) === String(previous.id)) : -1;
          if (index >= 0) {
            consumed.add(previous.id);
            if (next[index] !== merged) {
              next[index] = merged;
              changed = true;
            }
          } else {
            next.push(merged);
            changed = true;
          }
        });
        if (!changed) return current;
        next.sort(factoryThreadSort);
        return next;
      });
    }, []);

    const mergeUpdate = useCallback((update, animateNew) => {
      const nextRun = update && update.run ? update.run : null;
      if (nextRun) setRun(nextRun);
      setMessages((current) => {
        const byId = new Map(current.map((item) => [String(item.id), item]));
        const remainingLive = current.filter((item) => item.local || item.live);
        const incoming = Array.isArray(update && update.messages) ? update.messages : [];
        const server = incoming.map((message) => {
          const id = String(message && message.id || "");
          const textValue = String(message && message.text || "").trim();
          const matchedLocal = remainingLive.find((local) => norm(local.role) === norm(message && message.role) && (String(local.text || "").trim() === textValue || factoryThreadSameText(local, message)));
          if (matchedLocal) remainingLive.splice(remainingLive.indexOf(matchedLocal), 1);
          return factoryThreadServerMessage(message, byId.get(id) || matchedLocal, animateNew && !byId.has(id) && !matchedLocal);
        });
        const next = [...server, ...remainingLive].sort(factoryThreadSort);
        const same = next.length === current.length && next.every((item, index) => item === current[index]);
        return same ? current : next;
      });
    }, []);

    const loadRun = useCallback(async (animateNew) => {
      if (!runId || !window.API.getActionCenterRun) {
        setError("Action Center run endpoint is not available.");
        setLoading(false);
        return null;
      }
      try {
        const update = await window.API.getActionCenterRun(runId);
        mergeUpdate(update || {}, animateNew);
        setError(update && update.exists === false ? "This thread no longer exists." : "");
        return update || null;
      } catch (err) {
        setError((err && err.message) || "Failed to load thread.");
        if (onError) onError(err);
        return null;
      } finally {
        setLoading(false);
      }
    }, [mergeUpdate, onError, runId]);

    useEffect(() => {
      setRun(seed && seed.run || null);
      setMessages([]);
      setText("");
      setLoading(true);
      setError("");
      stickToBottomRef.current = true;
      loadRun(false);
      pollRef.current = setInterval(() => loadRun(false), 12000);
      if (window.API.subscribeToChanges) {
        unsubscribeRef.current = window.API.subscribeToChanges((change) => {
          if (String(change && change.jobId || "") !== String(runId || "") && String(officeChangeRunKey(officeChangeFromChange(change))) !== String(runId || "")) return;
          const officeChange = officeChangeFromChange(change);
          if (officeChange && officeChange.workItem) {
            const work = officeChange.workItem;
            setRun((current) => ({
              ...(current || {}),
              id: workRunId(work) || runId,
              title: workTitle(work) || (current && current.title) || "",
              status: work.status || work.state || (current && current.status) || "",
              threadId: workThreadId(work) || (current && current.threadId) || "",
              queue: work.queue || (current && current.queue) || null,
              approvalRequestTitle: work.queue && work.queue.approvalRequestTitle || (current && current.approvalRequestTitle) || "",
            }));
          }
          mergeMessages(factoryThreadLiveMessagesFromChange(change, runId), true);
          setError("");
        }, {
          onError: () => loadRun(false),
        });
      }
      const onKey = (event) => { if (event.key === "Escape") requestClose(); };
      window.addEventListener("keydown", onKey);
      return () => {
        if (pollRef.current) clearInterval(pollRef.current);
        if (unsubscribeRef.current) unsubscribeRef.current();
        unsubscribeRef.current = null;
        window.removeEventListener("keydown", onKey);
      };
    }, [loadRun, mergeMessages, requestClose, runId, seed]);

    useEffect(() => {
      const id = setInterval(() => {
        setMessages((current) => {
          let changed = false;
          const next = current.map((message) => {
            if (message.typed >= message.text.length) return message;
            changed = true;
            return { ...message, typed: Math.min(message.text.length, message.typed + 3) };
          });
          return changed ? next : current;
        });
      }, 90);
      return () => clearInterval(id);
    }, []);

    useEffect(() => {
      const el = logRef.current;
      if (el && stickToBottomRef.current) el.scrollTop = el.scrollHeight;
    }, [messages.length, messages.map((message) => message.typed).join(":")]);

    const trackScrollIntent = useCallback(() => {
      const el = logRef.current;
      if (!el) return;
      stickToBottomRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < 96;
    }, []);

    useEffect(() => {
      const speechMessage = factorySpeechMessageFromActivity(speechActivity);
      if (speechMessage) mergeMessages([speechMessage], true);
    }, [mergeMessages, speechActivity]);

    useEffect(() => {
      const toolMessage = factoryToolMessageFromActivity(activity);
      if (toolMessage) mergeMessages([toolMessage], true);
    }, [activity, mergeMessages]);

    const appendLocal = useCallback((kind, role, value) => {
      const clean = String(value || "").trim();
      if (!clean) return;
      setMessages((current) => [...current, {
        id: `local:${Date.now()}:${current.length}`,
        kind,
        role,
        text: clean,
        at: new Date().toISOString(),
        typed: clean.length,
        local: true,
      }]);
    }, []);

    const send = useCallback(async () => {
      const clean = text.trim();
      if (!clean || busy || !runId) return;
      try {
        setBusy("Sending...");
        appendLocal(needsInput ? "answer" : "you", "user", clean);
        setText("");
        if (needsInput) await window.API.answerActionCenterRun(runId, clean);
        else await window.API.sendActionCenterRunMessage(runId, clean);
        await loadRun(true);
        if (onChanged) onChanged();
        if (onToast) onToast("Message sent");
      } catch (err) {
        setError((err && err.message) || "Failed to send message.");
        if (onError) onError(err);
      } finally {
        setBusy("");
      }
    }, [appendLocal, busy, loadRun, needsInput, onChanged, onError, onToast, runId, text]);

    const approve = useCallback(async () => {
      if (busy || !runId || !window.API.approveActionCenterRun) return;
      try {
        setBusy("Approving...");
        appendLocal("step", "system", "You gave your approval");
        await window.API.approveActionCenterRun(runId);
        await loadRun(true);
        if (onChanged) onChanged();
        if (onToast) onToast("Approval sent");
      } catch (err) {
        setError((err && err.message) || "Failed to approve thread.");
        if (onError) onError(err);
      } finally {
        setBusy("");
      }
    }, [appendLocal, busy, loadRun, onChanged, onError, onToast, runId]);

    const archiveThread = useCallback(async () => {
      if (busy || !runId) return;
      if (!window.API.setActionCenterRunArchived) {
        setError("Action Center archive endpoint is not available.");
        return;
      }
      if (!threadId) {
        setError("This Action Center run does not have a persisted thread yet.");
        return;
      }
      try {
        setBusy("Archiving...");
        setError("");
        await window.API.setActionCenterRunArchived(runId, true);
        if (onChanged) await onChanged();
        if (onToast) onToast("Thread archived");
        onClose();
      } catch (err) {
        setError((err && err.message) || "Failed to archive thread.");
        if (onError) onError(err);
      } finally {
        setBusy("");
      }
    }, [busy, onChanged, onClose, onError, onToast, runId, threadId]);

    const deleteThread = useCallback(async () => {
      if (busy || !runId) return;
      if (!window.API.deleteActionCenterRun) {
        setError("Action Center delete endpoint is not available.");
        return;
      }
      if (!window.confirm("Delete this thread? This removes it from the Action Center and queues Codex deletion when available.")) return;
      try {
        setBusy("Deleting...");
        setError("");
        const result = await window.API.deleteActionCenterRun(runId);
        if (onChanged) await onChanged();
        if (onToast) {
          const codexQueued = result && result.codexDeleteQueued;
          const stopped = result && result.activePromptStopped;
          const codexUnavailable = result && (result.codexDeleteError || result.stopError);
          onToast(codexQueued ? "Thread deleted; Codex deletion queued" : stopped ? "Thread deleted; active prompt stopped" : codexUnavailable ? "Thread deleted locally; Codex stop/delete unavailable" : "Thread deleted");
        }
        onClose();
      } catch (err) {
        setError((err && err.message) || "Failed to delete thread.");
        if (onError) onError(err);
      } finally {
        setBusy("");
      }
    }, [busy, onChanged, onClose, onError, onToast, runId]);

    return (
      <div className="factory-thread-modal-scrim" onMouseDown={(event) => { if (event.target === event.currentTarget) requestClose(); }}>
        <section className="factory-thread-modal-shell" role="dialog" aria-modal="true" aria-label={`Thread with ${employee.name || "AI employee"}`}>
          <div className="factory-thread-modal-inner">
            <header className="factory-thread-modal-head">
              <div className="factory-thread-modal-head-row">
                <div className="factory-thread-modal-kicker">Live Thread — Codex Bridge</div>
                <div className="factory-thread-modal-actions">
                  <button type="button" className="factory-thread-modal-action" onClick={archiveThread} disabled={!!busy || loading || !runId || !threadId} title="Archive thread">
                    <Icon name="archive" size={13} />
                    <span>{busy === "Archiving..." ? "Archiving..." : "Archive"}</span>
                  </button>
                  <button type="button" className="factory-thread-modal-action danger" onClick={deleteThread} disabled={!!busy || loading || !runId} title="Delete thread">
                    <Icon name="trash" size={13} />
                    <span>{busy === "Deleting..." ? "Deleting..." : "Delete"}</span>
                  </button>
                  <button type="button" className="factory-thread-modal-close" onClick={requestClose} disabled={!!busy}>Close ✕</button>
                </div>
              </div>
              <div className="factory-thread-modal-title-row">
                <div className="factory-thread-modal-name">{employee.name || "AI employee"} <span>{employee.role ? `- ${employee.role}` : "- AI employee"}</span></div>
                <div className="factory-thread-modal-chip" style={{ background: chip.color }}>{chip.label}</div>
              </div>
              <div className="factory-thread-modal-subtitle">{title}</div>
              <div className="factory-thread-modal-refs">run {String(runId).slice(0, 8) || "unknown"}{threadId ? ` • thread ${threadId.slice(0, 14)}` : ""}</div>
            </header>
            <div ref={logRef} className="factory-thread-modal-log" aria-live="polite" onScroll={trackScrollIntent}>
              {loading && messages.length === 0 && <div className="factory-thread-modal-system"><span>— Loading thread —</span></div>}
              {messages.map((message) => {
                const type = factoryThreadMessageType(message);
                const shown = message.typed >= message.text.length ? message.text : `${message.text.slice(0, message.typed)} ▌`;
                if (type === "system") return <div key={message.id} className="factory-thread-modal-system"><span>— {message.text} —</span></div>;
                return (
                  <div key={message.id} className={`factory-thread-modal-message ${type} ${message.live ? "live" : ""}`}>
                    <div className="factory-thread-modal-label">{type === "tool" ? (message.toolName || "Tool call") : type === "you" ? "You" : employee.name || "Agent"}</div>
                    <div className="factory-thread-modal-bubble">{shown}</div>
                    <time>{factoryThreadTime(message.at)}</time>
                  </div>
                );
              })}
              {error && <div className="factory-thread-modal-system error"><span>— {error} —</span></div>}
            </div>
            {needsInput && active && (
              <div className="factory-thread-modal-approval">
                <div>Approval sought — {approvalTitle}</div>
                <button type="button" onClick={approve} disabled={!!busy}>Approve</button>
              </div>
            )}
            {active ? (
              <div className="factory-thread-modal-composer">
                <input
                  value={text}
                  onChange={(event) => setText(event.target.value)}
                  onKeyDown={(event) => submitPromptOnEnter(event, send)}
                  placeholder={needsInput ? "Give your word — the work stands still..." : followUpMode ? "Add a follow-up and put this thread back on the floor..." : `Write to ${employee.name || "the employee"}...`}
                  disabled={!!busy}
                />
                <button type="button" onClick={send} disabled={!!busy || !text.trim()}>{busy || "Send"}</button>
              </div>
            ) : (
              <div className="factory-thread-modal-ended">This thread is no longer accepting follow-up messages.</div>
            )}
            <footer className="factory-thread-modal-foot">
              <span>Live thread — pushed from the Codex Bridge</span>
              <span>Appligator Ironworks — records office</span>
            </footer>
          </div>
        </section>
      </div>
    );
  }
  function FactoryInputRequestModal({ seed, onClose, onChanged, onToast, onError, onOpenThread }) {
    const [run, setRun] = useState(seed && seed.run || seed && seed.work || null);
    const [loading, setLoading] = useState(true);
    const [busy, setBusy] = useState("");
    const [error, setError] = useState("");
    const runId = factoryRunId(seed && (seed.run || seed.work || seed));
    const employee = seed && seed.employee || {};
    const work = seed && seed.work || {};
    const currentRun = run || work || {};
    const title = String(currentRun.title || seed && seed.title || workTitle(work) || "Needs your input").trim();
    const approvalRequest = factoryApprovalFromRun(currentRun, seed);
    const requestText = approvalRequest
      ? [approvalRequest.title, approvalRequest.body].filter(Boolean).join("\n\n")
      : String((work.queue && work.queue.approvalRequestTitle) || seed && seed.approvalTitle || "This thread is waiting for your input.").trim();
    const chip = FACTORY_THREAD_CHIPS.blocked;
    const RequestCard = window.ActionCenterRequestCard;

    const loadRun = useCallback(async () => {
      if (!runId || !window.API.getActionCenterRun) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const update = await window.API.getActionCenterRun(runId);
        if (update && update.run) setRun(update.run);
        setError(update && update.exists === false ? "This request no longer exists." : "");
      } catch (err) {
        setError((err && err.message) || "Failed to load request.");
        if (onError) onError(err);
      } finally {
        setLoading(false);
      }
    }, [onError, runId]);

    useEffect(() => {
      loadRun();
      const onKey = (event) => { if (event.key === "Escape") onClose(); };
      window.addEventListener("keydown", onKey);
      return () => window.removeEventListener("keydown", onKey);
    }, [loadRun, onClose]);

    const respondApproval = useCallback(async (requestId, decision) => {
      if (!requestId || busy) return;
      const jobId = window.actionCenterApprovalJobIdForRun ? window.actionCenterApprovalJobIdForRun(currentRun) : runId;
      if (!jobId || !window.API.respondCodexPromptApproval) {
        setError("Approval endpoint is not available.");
        return;
      }
      try {
        setBusy("Sending...");
        await window.API.respondCodexPromptApproval(jobId, requestId, decision);
        if (onToast) {
          const structured = window.actionCenterStructuredQuestionDecision && window.actionCenterStructuredQuestionDecision(decision);
          const toast = structured ? "Answers submitted" : window.actionCenterApprovalToast ? window.actionCenterApprovalToast(decision) : "Response sent";
          onToast(toast);
        }
        if (onChanged) onChanged();
        onClose();
      } catch (err) {
        setError((err && err.message) || "Failed to send response.");
        if (onError) onError(err);
      } finally {
        setBusy("");
      }
    }, [busy, currentRun, onChanged, onClose, onError, onToast, runId]);

    return (
      <div className="factory-thread-modal-scrim" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
        <section className="factory-thread-modal-shell factory-input-modal-shell" role="dialog" aria-modal="true" aria-label={`Request from ${employee.name || "AI employee"}`}>
          <div className="factory-thread-modal-inner">
            <header className="factory-thread-modal-head">
              <div className="factory-thread-modal-head-row">
                <div className="factory-thread-modal-kicker">Needs Your Input — Action Center</div>
                <button type="button" className="factory-thread-modal-close" onClick={onClose}>Close ✕</button>
              </div>
              <div className="factory-thread-modal-title-row">
                <div className="factory-thread-modal-name">{employee.name || "AI employee"} <span>{employee.role ? `- ${employee.role}` : "- AI employee"}</span></div>
                <div className="factory-thread-modal-chip" style={{ background: chip.color }}>{chip.label}</div>
              </div>
              <div className="factory-thread-modal-subtitle">{title}</div>
              <div className="factory-thread-modal-refs">run {String(runId).slice(0, 8) || "unknown"}</div>
            </header>
            <div className="factory-input-modal-body">
              {loading && <div className="factory-thread-modal-system"><span>— Loading request —</span></div>}
              {!loading && RequestCard && approvalRequest && (
                <RequestCard approvalRequest={approvalRequest} body={requestText} busy={!!busy} onRespondApproval={respondApproval} className="factory-input-request-card" />
              )}
              {!loading && (!RequestCard || !approvalRequest) && (
                <div className="factory-input-request-fallback">
                  <div className="factory-thread-modal-kicker">Needs your input</div>
                  <div className="factory-input-request-copy">{window.MarkdownText ? <MarkdownText text={requestText} /> : requestText}</div>
                </div>
              )}
              {error && <div className="factory-thread-modal-system error"><span>— {error} —</span></div>}
            </div>
            <footer className="factory-thread-modal-foot">
              <button type="button" className="factory-input-thread-link" onClick={() => onOpenThread && onOpenThread(seed)}>Open full thread</button>
              <span>{busy || "Awaiting response"}</span>
            </footer>
          </div>
        </section>
      </div>
    );
  }
  function eventLabelFromOfficeChange(officeChange) {
    const item = officeChange && officeChange.workItem;
    const meta = metaForWork(item, null);
    const employee = item && (item.employeeName || item.aiEmployeeName || item.employeeId);
    return `${meta.label}: ${workTitle(item)}${employee ? ` - ${employee}` : ""}`;
  }
  function captionFromOfficeChange(officeChange) {
    const item = officeChange && officeChange.workItem;
    if (!item) return "";
    const status = workStatus(item);
    const employee = item.employeeName || item.aiEmployeeName || item.employeeId || "Someone";
    if (status.includes("block") || status.includes("need")) return `${employee} is blocked: ${(item.queue && item.queue.approvalRequestTitle) || workTitle(item)}`;
    if (status.includes("fail") || status.includes("error")) return `${employee}'s task failed: ${workTitle(item)}`;
    if (status.includes("complete") || status.includes("done")) return `${employee} finished: ${workTitle(item)}`;
    if (workCategory(item) === "delegation") return `${employee} hands off: ${workTitle(item)}`;
    return `Dispatch: ${workTitle(item)} -> ${employee}`;
  }
  function speechTextForWork(work) {
    return window.ActionCenterActivity ? window.ActionCenterActivity.speechTextFromOfficeWork(work) : "";
  }
  function factoryCleanSpeechText(value) {
    return window.ActionCenterActivity ? window.ActionCenterActivity.cleanSpeechText(value) : "";
  }
  function factoryMessageKey(item) {
    const activity = window.ActionCenterActivity ? window.ActionCenterActivity.toOfficeWorkActivity(item) : null;
    return String(activity && (activity.messageType || activity.toolName) || "").trim();
  }
  function factoryToolKey(item) {
    const activity = window.ActionCenterActivity ? window.ActionCenterActivity.toOfficeWorkActivity(item) : null;
    return window.ActionCenterActivity ? window.ActionCenterActivity.activityToolKey(activity) : "";
  }
  function factoryIsAssistantSpeechEvent(item) {
    const activity = window.ActionCenterActivity ? window.ActionCenterActivity.toOfficeWorkActivity(item) : null;
    return window.ActionCenterActivity ? window.ActionCenterActivity.isAssistantResponseActivity(activity) || !!window.ActionCenterActivity.speechTextFromOfficeWork(item) : false;
  }
  function factoryToolActivityMeta(item, activityOverride) {
    const activity = activityOverride || (window.ActionCenterActivity ? window.ActionCenterActivity.toOfficeWorkActivity(item) : null);
    const subject = String(item && (item.title || item.displayLabel || item.detail) || "").trim();
    return window.ActionCenterActivity ? window.ActionCenterActivity.factoryAnimationMeta(activity, workCategory(item), subject) : null;
  }
  function factoryToolChipColor(mode) {
    if (mode === "run" || mode === "ticket") return "#40607a";
    if (mode === "search" || mode === "read") return "#4c6342";
    if (mode === "write" || mode === "create") return "#84642e";
    if (mode === "attach" || mode === "mail") return "#8a5a30";
    if (mode === "delete") return "#8c3524";
    if (mode === "sketch") return "#7a4460";
    return "#535e56";
  }
  function factoryEventIdentity(item) {
    const event = item && item.event || {};
    const semantic = item && item.semanticEvent || {};
    const source = semantic.sourceIdentifiers || {};
    return [
      event.latestMessageId || source.latestMessageId || "",
      event.latestMessageKind || source.latestMessageKind || "",
      event.latestMessageAt || "",
      item && (item.updatedAt || item.lastEventAt) || "",
    ].map((part) => String(part || "")).join(":");
  }
  function legacySpeechTextForWork(work) {
    if (!work) return "";
    const event = work.event || {};
    const queue = work.queue || {};
    const delegation = work.delegation || {};
    const role = norm(event.latestMessageRole);
    const kind = norm(event.latestMessageKind);
    const candidates = [];
    if ((!role || ["assistant", "employee", "ai", "system-assistant"].includes(role)) && !(kind.includes("tool") || kind.includes("debug") || kind.includes("internal") || kind.includes("payload") || kind.includes("log"))) candidates.push(event.latestMessageText);
    if (queue.needsInput || queue.approvalRequestTitle) candidates.push(queue.approvalRequestTitle);
    if (delegation.handoffLabel) candidates.push(delegation.handoffLabel);
    for (const candidate of candidates) {
      const text = String(candidate || "").replace(/\s+/g, " ").trim();
      if (!text || text.length > 500) continue;
      if (/https?:\/\//i.test(text) || /(authorization|credential|secret|password|api[_-]?key|bearer\s)/i.test(text)) continue;
      if (/```|^\s*[{[]/.test(text)) continue;
      return text.length > 90 ? `${text.slice(0, 87).trimEnd()}...` : text;
    }
    return "";
  }

  let factoryPackageStageResumeState = null;

  function factoryCloneActor(actor) {
    if (!actor) return actor;
    const next = { ...actor };
    if (Array.isArray(actor.path)) next.path = actor.path.map((point) => ({ ...point }));
    if (actor.next && typeof actor.next === "object") next.next = { ...actor.next };
    if (actor.anchor && typeof actor.anchor === "object") next.anchor = { ...actor.anchor };
    if (actor.shelfAnchor && typeof actor.shelfAnchor === "object") next.shelfAnchor = { ...actor.shelfAnchor };
    if (actor.tableAnchor && typeof actor.tableAnchor === "object") next.tableAnchor = { ...actor.tableAnchor };
    if (actor.chip && typeof actor.chip === "object") next.chip = { ...actor.chip };
    if (actor.toolMeta && typeof actor.toolMeta === "object") next.toolMeta = { ...actor.toolMeta };
    return next;
  }

  function factoryClonePlain(value) {
    return value && typeof value === "object" ? { ...value } : value;
  }

class FactoryPackageStage extends React.Component {
  state = { sel: '', selName: '', selRole: '', selActivity: '', selRunMeta: '', selRunId: '', selEmployeeId: '', selCompleted: false, viewZoom: 1, panX: 0, panY: 0, panMode: false, panning: false };

  canvasRef = React.createRef();
  captionRef = React.createRef();
  popupRef = React.createRef();
  activityRef = React.createRef();
  runMetaRef = React.createRef();
  statusRef = React.createRef();
  speechLayerRef = React.createRef();
  toolLayerRef = React.createRef();
  stageRef = React.createRef();

  // ---------- constants ----------
  TW = 52; TH = 26; OX = 530; OY = 76; LW = 1420; LH = 700;

  MAP = [
    "gggggggggggggggggggggggggggggggg",
    "g##############################g",
    "g#ooooooo#..............#ooooo#g",
    "g#ooooooo#..............#ooooo#g",
    "g#oooooooD..............Dooooo#g",
    "g#ooooooo#..............#ooooo#g",
    "g#ooooooo#..............#ooooo#g",
    "g####D####..............#######g",
    "g#ooooooo#..............#ooooo#g",
    "g#ooooooo#..............Dooooo#g",
    "g#ooooooo#..............#ooooo#g",
    "g#ooooooo#..............#ooooo#g",
    "g#oooooooD.......###D##########g",
    "g#ooooooo#.......#bbbbbb#bbbbb#g",
    "g#ooooooo#.......#bbbbbb#bbbbb#g",
    "g#ooooooo#.......DbbbbbbDbbbbb#g",
    "g#ooooooo#.......#bbbbbb#bbbbb#g",
    "g#ooooooo#.......#bbbbbb#bbbbb#g",
    "g##############################g",
    "cccccccccccccccccccccccccccccccc"
  ];

  FURN = [
    { type: 'shelf', tiles: [[2, 2], [3, 2]] },
    { type: 'shelf', tiles: [[5, 2], [6, 2]] },
    { type: 'lectern', tiles: [[4, 4], [5, 4]] },
    { type: 'plant', tiles: [[8, 2]] },
    { type: 'cabinet', tiles: [[2, 8]] },
    { type: 'deskT', tiles: [[3, 9]] },
    { type: 'deskL', tiles: [[6, 9]] },
    { type: 'deskL', tiles: [[3, 12]] },
    { type: 'deskT', tiles: [[6, 12]] },
    { type: 'pigeon', tiles: [[2, 14]] },
    { type: 'reception', tiles: [[5, 15], [6, 15]] },
    { type: 'plant', tiles: [[2, 17]] },
    { type: 'board', tiles: [[11, 5], [12, 5]] },
    { type: 'press', tiles: [[13, 2], [14, 2], [13, 3], [14, 3]] },
    { type: 'lathe', tiles: [[19, 2], [20, 2]] },
    { type: 'bench', tiles: [[12, 8], [13, 8]] },
    { type: 'bench', tiles: [[17, 8], [18, 8]] },
    { type: 'engine', tiles: [[14, 12], [15, 12]] },
    { type: 'draft', tiles: [[11, 14]] },
    { type: 'easel', tiles: [[10, 16]] },
    { type: 'easel', tiles: [[13, 16]] },
    { type: 'crates', tiles: [[22, 3], [23, 3], [22, 4]] },
    { type: 'pillar', tiles: [[16, 5]] },
    { type: 'stove', tiles: [[23, 13]] },
    { type: 'rack', tiles: [[18, 13]] },
    { type: 'table', tiles: [[20, 15], [21, 15]] },
    { type: 'deskT', tiles: [[28, 3]] },
    { type: 'deskL', tiles: [[28, 9]] },
    { type: 'deskT', tiles: [[28, 15]] },
    { type: 'draft', tiles: [[19, 15]] },
    { type: 'table', tiles: [[22, 15], [23, 15]] }
  ];

  RUGS = [[5, 5], [6, 5], [4, 15]];
  LAMPS = [[5.5, 3.2, 58], [3, 9.5, 54], [13.5, 4.2, 68], [12.5, 8, 60], [17.5, 8, 60], [20.5, 15, 54], [28, 3.5, 52], [28, 9.5, 52], [28, 15.5, 52], [6, 14.4, 54], [16, 5, 60], [11.5, 5.4, 62]];
  POSTS = [[5, 19.85], [13, 19.85], [21, 19.85], [30.5, 19.85]];
  FLOWERS = [[3, 18.62], [6, 18.62], [10, 18.62], [13, 18.62], [16, 18.62], [19, 18.62], [22, 18.62], [28, 18.62], [30.62, 5], [30.62, 10], [30.62, 16]];
  BUSHES = [[31.7, 3], [32.3, 9], [31.9, 15], [8, 23.6], [18, 23.9], [-1.5, 21.5]];

  ZONES = {
    dispatch: [[10, 6], [11, 6], [12, 6], [13, 6]],
    archive_shelves: [[2, 3], [3, 3], [5, 3], [6, 3]],
    archive_tables: [[4, 5], [5, 5], [3, 5], [6, 5]],
    records: [[3, 10], [6, 10], [3, 13], [6, 13]],
    mailroom: [[5, 16], [6, 16], [4, 15], [7, 15], [3, 14]],
    steamworks: [[13, 4], [14, 4], [13, 12], [16, 12], [19, 3], [20, 3], [14, 13], [15, 13]],
    atelier: [[11, 15], [10, 17], [13, 17], [12, 16]],
    workshop: [[12, 9], [13, 9], [17, 9], [18, 9], [14, 8], [16, 8]],
    common_area: [[19, 14], [20, 16], [21, 14], [22, 16], [19, 16], [22, 15], [20, 14], [18, 15]],
    cfo_office: [[26, 3], [27, 4], [29, 4], [26, 5], [29, 5]],
    executive_assistant_office: [[26, 9], [27, 10], [28, 10], [29, 10], [26, 11]],
    senior_dev_office: [[26, 14], [27, 15], [29, 15], [26, 16], [28, 16]],
    design_lead_studio: [[18, 14], [18, 15], [19, 16], [20, 14]],
    planning_office: [[21, 14], [21, 16], [22, 16], [23, 14]]
  };

  CHIPS = {
    action_center_activity: { label: 'DISPATCH', color: '#8a6a28' },
    delegation: { label: 'HANDOFF', color: '#6d5580' },
    project_context_read: { label: 'ARCHIVE', color: '#4c6342' },
    ticket_work_package: { label: 'TICKET', color: '#40607a' },
    note: { label: 'NOTE', color: '#84642e' },
    document: { label: 'DOCUMENT', color: '#84642e' },
    email: { label: 'MAIL', color: '#8a5a30' },
    sketch: { label: 'SKETCH', color: '#7a4460' },
    generic_tool_work: { label: 'TOOL WORK', color: '#535e56' },
    blocked: { label: 'BLOCKED', color: '#8c3524' },
    failed: { label: 'FAILED', color: '#8c3524' },
    completed: { label: 'DONE', color: '#3c6344' },
    idle_available: null
  };

  ZONE_OF_CATEGORY = {
    action_center_activity: 'dispatch',
    delegation: 'dispatch',
    project_context_read: 'archive_shelves',
    ticket_work_package: 'steamworks',
    note: 'records', document: 'records',
    email: 'mailroom',
    sketch: 'atelier',
    generic_tool_work: 'workshop',
    idle_available: 'common_area'
  };

  // ---------- lifecycle ----------
  componentDidMount() {
    if (!this._worldInit) {
      this._worldInit = true;
      this.initWorld();
      if (!this.restoreRuntimeState()) this.resetRuntimeState();
    }
    this._mounted = true;
    if (this.props.snapshot || !factoryPackageStageResumeState) this.applySnapshot(this.props.snapshot || {});
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { this._floorCv = null; });
    this.startLoop();
    if (!this._watchdog) {
      this._watchdog = setInterval(() => {
        if (!this._mounted) return;
        const now = performance.now() / 1000;
        if (now - (this._lastFrameAt || 0) > 0.5) this.startLoop();
      }, 600);
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.snapshot !== this.props.snapshot) this.applySnapshot(this.props.snapshot || {});
    if (prevProps.liveCaption !== this.props.liveCaption && this.props.liveCaption) this.caption(this.props.liveCaption);
    if (prevProps.liveSpeechByRunId !== this.props.liveSpeechByRunId) {
      for (const a of this.actors.values()) {
        if (a.item) this.updateSpeechFor(a, a.item);
      }
    }
    if (prevProps.liveActivityByRunId !== this.props.liveActivityByRunId) {
      for (const a of this.actors.values()) {
        if (a.item) this.updateToolBubbleFor(a, a.item);
      }
    }
  }

  startLoop() {
    cancelAnimationFrame(this._raf);
    const loop = () => {
      if (!this._mounted) return;
      this._lastFrameAt = performance.now() / 1000;
      this.frame();
      this._raf = requestAnimationFrame(loop);
    };
    this._raf = requestAnimationFrame(loop);
  }
  componentWillUnmount() {
    this.saveRuntimeState();
    this._mounted = false;
    cancelAnimationFrame(this._raf);
    clearInterval(this._watchdog); this._watchdog = null;
  }

  resetRuntimeState() {
    this.actors = new Map();
    this.flyingCards = [];
    this.speech = new Map();
    this.toolBubbles = [];
    this.seenSpeechKeys = new Set();
    this.seenToolKeys = new Set();
    this.prevRunState = new Map();
    this.tPrev = performance.now() / 1000;
    this.simT = 0; this.realT = 0;
    this.capQueue = []; this.capShownUntil = 0; this.capNextOk = 0;
    this.smoke = []; this.sparks = [];
    this.feedMode = 'live'; this.lastFeedAt = 0; this.pollAcc = 999;
    this.demo = null;
  }

  restoreRuntimeState() {
    const saved = factoryPackageStageResumeState;
    if (!saved) return false;
    this.actors = new Map((saved.actors || []).map(([id, actor]) => [id, factoryCloneActor(actor)]));
    this.reserved = new Map(saved.reserved || []);
    this.retired = new Set(saved.retired || []);
    this.flyingCards = (saved.flyingCards || []).map(factoryClonePlain);
    this.speech = new Map((saved.speech || []).map(([id, speech]) => [id, factoryClonePlain(speech)]));
    this.toolBubbles = (saved.toolBubbles || []).map(factoryClonePlain);
    this.seenSpeechKeys = new Set(saved.seenSpeechKeys || []);
    this.seenToolKeys = new Set(saved.seenToolKeys || []);
    this.prevRunState = new Map(saved.prevRunState || []);
    this.tPrev = performance.now() / 1000;
    this.simT = Number(saved.simT) || 0;
    this.realT = Number(saved.realT) || 0;
    this.capQueue = Array.isArray(saved.capQueue) ? saved.capQueue.slice() : [];
    this.capShownUntil = Number(saved.capShownUntil) || 0;
    this.capNextOk = Number(saved.capNextOk) || 0;
    this.smoke = (saved.smoke || []).map(factoryClonePlain);
    this.sparks = (saved.sparks || []).map(factoryClonePlain);
    this.feedMode = 'live'; this.lastFeedAt = 0; this.pollAcc = 999;
    this.demo = null;
    return true;
  }

  saveRuntimeState() {
    factoryPackageStageResumeState = {
      actors: Array.from(this.actors || new Map()).map(([id, actor]) => [id, factoryCloneActor(actor)]),
      reserved: Array.from(this.reserved || new Map()),
      retired: Array.from(this.retired || new Set()),
      flyingCards: (this.flyingCards || []).map(factoryClonePlain),
      speech: Array.from(this.speech || new Map()).map(([id, speech]) => [id, factoryClonePlain(speech)]),
      toolBubbles: (this.toolBubbles || []).map(factoryClonePlain),
      seenSpeechKeys: Array.from(this.seenSpeechKeys || new Set()),
      seenToolKeys: Array.from(this.seenToolKeys || new Set()),
      prevRunState: Array.from(this.prevRunState || new Map()),
      simT: this.simT || 0,
      realT: this.realT || 0,
      capQueue: (this.capQueue || []).slice(),
      capShownUntil: this.capShownUntil || 0,
      capNextOk: this.capNextOk || 0,
      smoke: (this.smoke || []).map(factoryClonePlain),
      sparks: (this.sparks || []).map(factoryClonePlain),
    };
  }

  renderVals() {
    return {
      canvasRef: this.canvasRef, captionRef: this.captionRef, popupRef: this.popupRef,
      activityRef: this.activityRef, runMetaRef: this.runMetaRef, statusRef: this.statusRef,
      speechLayerRef: this.speechLayerRef,
      toolLayerRef: this.toolLayerRef,
      onCanvasClick: (e) => this.onClick(e),
      hasSelection: !!this.state.sel,
      selName: this.state.selName, selRole: this.state.selRole,
      selActivity: this.state.selActivity, selRunMeta: this.state.selRunMeta
    };
  }

  // ================= FEED LAYER =================

  norm(v) { return String(v || '').trim().toLowerCase(); }

  delegationEndpoints(item, intent) {
    const semantic = item && item.semanticEvent || {};
    const sourceEmployeeId = String(
      (intent && intent.sourceEmployeeId)
      || semantic.parentEmployeeId
      || (item && item.employeeId)
      || "");
    const targetEmployeeId = String(
      (intent && intent.targetEmployeeId)
      || semantic.childEmployeeId
      || "");
    return { sourceEmployeeId, targetEmployeeId };
  }

  delegationCaption(item, employees, fallbackEmployee, status) {
    const semantic = item && item.semanticEvent || {};
    const endpoints = this.delegationEndpoints(item, item && item.animationIntent);
    const parentId = String(semantic.parentEmployeeId || endpoints.sourceEmployeeId || "");
    const childId = String(semantic.childEmployeeId || (item && item.employeeId) || endpoints.targetEmployeeId || "");
    const parent = employees.find(e => String(e.id) === parentId);
    const child = employees.find(e => String(e.id) === childId);
    const sourceIsChild = childId && endpoints.sourceEmployeeId === childId;
    const targetIsParent = parentId && endpoints.targetEmployeeId === parentId;
    const returning = sourceIsChild && targetIsParent || this.statusOf(item, item && item.animationIntent) === 'completed' || this.norm(status) === 'review';
    const label = item && item.delegation && item.delegation.handoffLabel ? ': ' + item.delegation.handoffLabel : '';
    if (returning) {
      return (child ? child.name : fallbackEmployee ? fallbackEmployee.name : 'A colleague') + ' returns work to ' + (parent ? parent.name : 'a colleague') + label;
    }
    return (parent ? parent.name : fallbackEmployee ? fallbackEmployee.name : 'Someone') + ' hands work to ' + (child ? child.name : 'a colleague') + label;
  }

  // ---------- sample data helpers (contract-shaped, mimics the Codex Bridge) ----------
  initDemo() {
    const uid = () => 'run-' + Math.random().toString(36).slice(2, 10);
    this.demoUid = uid;
    const emps = [
      { id: 'emp-ada', name: 'Ada', role: 'Engineer', gender: 'Female' },
      { id: 'emp-brunel', name: 'Brunel', role: 'Coordinator', gender: 'Male' },
      { id: 'emp-clara', name: 'Clara', role: 'Correspondence Clerk', gender: 'Female' },
      { id: 'emp-edison', name: 'Edison', role: 'Researcher', gender: 'Male' },
      { id: 'emp-flora', name: 'Flora', role: 'Accountant', gender: 'Female' },
      { id: 'emp-george', name: 'George', role: 'Draughtsman', gender: 'Male' }
    ];
    this.demo = { emps, runs: new Map(), nextIn: 1.5 };
  }

  demoTemplates() {
    return {
      action_center_activity: ['Triage the Action Center queue', 'Queue follow-up tasks', 'Review pending approvals'],
      project_context_read: ['Read the OKF file \u2014 Ashworth Mill', 'Update the OKF record for Whitby', 'Collect context for the loom order', 'Write the OKF summary \u2014 Mercer account'],
      ticket_work_package: ['Ticket #142 \u2014 fix invoice rounding', 'Work package \u2014 loom order specs', 'Ticket #157 \u2014 update delivery schedule', 'Ticket #163 \u2014 boiler gauge patch'],
      email: ['Draft reply to Mercer & Sons', 'Summarise the customer inbox', 'Prepare the estimate letter'],
      note: ['Record the site-visit notes', 'File minutes from the works meeting'],
      document: ['File the survey report', 'Update the price-list document'],
      sketch: ['Sketch the boiler-room layout', 'Draft a wiring diagram for the press', 'Paint the client-portal mock-up'],
      generic_tool_work: ['Run the cashflow snapshot', 'Rebuild the price list', 'Sync customer records', 'Compile the weekly ledger']
    };
  }
  demoSpeech(cat) {
    const s = {
      action_center_activity: ['Sorting the queue \u2014 two items need eyes.', 'Dispatching the morning\u2019s tasks now.'],
      project_context_read: ['Reading the Ashworth file for background.', 'The brief mentions a June deadline \u2014 noting it.'],
      ticket_work_package: ['Halfway through the rounding fix.', 'Specs drafted; checking tolerances.'],
      email: ['Drafting the reply to Mercer & Sons now.', 'Inbox summarised \u2014 three need answers.'],
      note: ['Notes filed under the Whitby account.'],
      document: ['Survey report is filed and indexed.'],
      sketch: ['Blocking in the layout on canvas.', 'A few more strokes and the diagram reads well.'],
      generic_tool_work: ['Snapshot running \u2014 ledgers look tidy.', 'Records synced; two duplicates merged.']
    };
    const arr = s[cat] || s.generic_tool_work;
    return arr[Math.floor(Math.random() * arr.length)];
  }

  demoMakeRun(emp, cat, title, extra) {
    const now = new Date().toISOString();
    const run = Object.assign({
      runId: this.demoUid(), employeeId: emp.id, status: 'running', state: 'running',
      title, detail: '', category: cat,
      latestMessageText: this.demoSpeech(cat), latestMessageRole: 'assistant', latestMessageKind: 'message',
      handoffLabel: '', needsInput: false, approvalRequestTitle: '',
      parentEmployeeId: null, childEmployeeId: null,
      createdAt: now, updatedAt: now,
      ttl: 14 + Math.random() * 14, age: 0, phase: 'running',
      threadId: 'thr-' + Math.random().toString(36).slice(2, 8)
    }, extra || {});
    this.demo.runs.set(run.runId, run);
    return run;
  }

  // ---------- snapshot ingestion (office-action-center.v1 shape) ----------
  applySnapshot(snap) {
    const employees = Array.isArray(snap && snap.employees) ? snap.employees : [];
    const work = Array.isArray(snap && snap.work) ? snap.work : [];
    this.roster = employees;
    this.workItems = work;
    this.workByRun = new Map(work.map(w => [String(w.runId), w]));
    // diff captions
    for (const w of work) {
      const key = String(w.runId);
      const status = this.norm(w.status || w.state);
      const prev = this.prevRunState.get(key);
      const emp = employees.find(e => String(e.id) === String(w.employeeId));
      const who = emp ? emp.name : 'Someone';
      const cat = this.norm((w.semanticEvent && w.semanticEvent.category) || '');
      if (!prev) {
        if (cat === 'delegation') {
          this.caption(this.delegationCaption(w, employees, emp, status));
        } else if (status !== 'completed') {
          this.caption('Dispatch: \u201C' + (w.title || 'New task') + '\u201D \u2192 ' + who);
        }
      } else if (prev !== status) {
        if (status === 'blocked') this.caption(who + ' is blocked \u2014 ' + ((w.queue && w.queue.approvalRequestTitle) || 'needs approval'));
        else if (status === 'failed') this.caption(who + '\u2019s task failed: ' + (w.title || ''));
        else if (status === 'completed') this.caption(who + ' finished: ' + (w.title || 'task'));
      }
      this.prevRunState.set(key, status);
    }
    for (const key of [...this.prevRunState.keys()]) if (!this.workByRun.has(key)) this.prevRunState.delete(key);
    this.syncActors();
  }

  // ================= ACTORS =================

  hashStr(s) { let h = 0; for (let i = 0; i < s.length; i++) { h = (h * 31 + s.charCodeAt(i)) | 0; } return Math.abs(h); }

  paletteAt(seed, colors) {
    return colors[this.hashStr(String(seed || 'employee')) % colors.length];
  }

  employeeIsFemale(emp) {
    const gender = this.norm(emp && emp.gender);
    const avatarKey = this.norm(emp && emp.avatarKey);
    if (gender) return gender.startsWith('f') || gender.includes('woman');
    return avatarKey.includes('woman') || avatarKey.includes('annie') || avatarKey.includes('becky') || avatarKey.includes('cassie') || avatarKey.includes('desire') || avatarKey.includes('ida') || avatarKey.includes('vizzy');
  }

  actorTraits(emp, key) {
    const seed = String((emp && (emp.avatarKey || emp.id || emp.name)) || key || 'employee');
    const h = this.hashStr(seed);
    const female = this.employeeIsFemale(emp);
    const palette = ['#4a3d5c', '#33404a', '#5c3a3f', '#4a3526', '#3d4d3a', '#59452e', '#2f3a45', '#4e5a44', '#3a322a', '#41382e'];
    const hair = ['#2a211a', '#3b261a', '#5b3926', '#6f5133', '#d2a85b', '#746352'];
    const skin = ['#dba97c', '#c88f65', '#e0b187', '#b97855', '#8f5f46', '#efc39a'];
    const trim = ['#b08d3f', '#7fa8b8', '#c88a64', '#8dab75', '#c387ad', '#d5c27c'];
    return {
      female,
      gender: (emp && emp.gender) || '',
      avatarKey: (emp && emp.avatarKey) || '',
      dress: female,
      hat: female ? (h % 5 === 0 ? 'ribbon' : 'none') : ['cap', 'none', 'bowler', 'none'][h % 4],
      color: palette[h % palette.length],
      hair: hair[this.hashStr(seed + ':hair') % hair.length],
      skin: skin[this.hashStr(seed + ':skin') % skin.length],
      trim: trim[this.hashStr(seed + ':trim') % trim.length],
      hairStyle: female ? ['wave', 'bob', 'bun'][h % 3] : ['short', 'side', 'cap'][h % 3],
      apron: (h % 4) === 1,
      moust: !female && (h % 5) < 2,
    };
  }

  spawnTileForActor(ownerId) {
    const list = this.ZONES.common_area || [];
    const start = this.hashStr(ownerId) % Math.max(1, list.length);
    for (let i = 0; i < list.length; i++) {
      const c = list[(start + i) % list.length];
      const k = c[0] + ',' + c[1];
      if (!this.reserved.get(k)) {
        this.reserved.set(k, ownerId);
        return { x: c[0], y: c[1] };
      }
    }
    const fallback = list[start] || [20, 15];
    return this.freeTileNear(fallback[0], fallback[1], ownerId) || { x: fallback[0], y: fallback[1] };
  }

  createActor(emp, key) {
    const hk = this.hashStr(String(key));
    const traits = this.actorTraits(emp, key);
    const spawn = this.spawnTileForActor(String(key));
    return {
      id: String(key), empId: String(emp.id), name: emp.name || 'Employee', role: emp.role || '', idleRoom: this.cleanIdleRoom(emp.idleRoom),
      x: spawn.x, y: spawn.y,
      gender: traits.gender, avatarKey: traits.avatarKey, female: traits.female, dress: traits.dress, hat: traits.hat, color: traits.color,
      hair: traits.hair, skin: traits.skin, trim: traits.trim, hairStyle: traits.hairStyle, off: ((hk % 7) - 3), bobPh: (hk % 10) * 0.7, walked: 0,
      face: 1, apron: traits.apron && !traits.female, moust: traits.moust,
      mode: 'idle', t: 0.5 + (hk % 20) / 10, path: null, seg: 0, next: null,
      intentId: '', item: null, chip: null, overlay: null, carryCard: false, carryBook: false,
      anchor: null, doneFlash: 0, doneFlag: false, title: '', threadIdx: 0, multi: false, zone: '', sub: null, rw: 'read', retireAt: 0
    };
  }

  applyActorEmployee(a, emp) {
    if (!a || !emp) return;
    a.name = emp.name || 'Employee';
    a.role = emp.role || '';
    a.idleRoom = this.cleanIdleRoom(emp.idleRoom);
    const traits = this.actorTraits(emp, a.id);
    a.empId = String(emp.id);
    a.gender = traits.gender;
    a.avatarKey = traits.avatarKey;
    a.female = traits.female;
    a.dress = traits.dress;
    a.hat = traits.hat;
    a.color = traits.color;
    a.hair = traits.hair;
    a.skin = traits.skin;
    a.trim = traits.trim;
    a.hairStyle = traits.hairStyle;
    a.apron = traits.apron && !traits.female;
    a.moust = traits.moust;
  }

  ensureDelegationTargetActors(work, empById, seen, employeesWithVisibleActors, hasUnfinishedByEmp) {
    for (const w of work) {
      const intent = w && w.animationIntent || null;
      if (this.catOf(w, intent) !== 'delegation') continue;
      const endpoints = this.delegationEndpoints(w, intent);
      if (!endpoints.targetEmployeeId || endpoints.targetEmployeeId === endpoints.sourceEmployeeId) continue;
      if (hasUnfinishedByEmp && hasUnfinishedByEmp.has(endpoints.targetEmployeeId)) continue;
      let existing = null;
      for (const actor of this.actors.values()) {
        if (actor.empId === endpoints.targetEmployeeId && actor.despawn == null) {
          existing = actor;
          break;
        }
      }
      const emp = empById.get(endpoints.targetEmployeeId);
      if (!emp) continue;
      const key = 'handoff-target:' + endpoints.targetEmployeeId;
      const a = existing || this.actors.get(key) || this.createActor(emp, key);
      this.actors.set(a.id, a);
      this.applyActorEmployee(a, emp);
      seen.add(a.id);
      employeesWithVisibleActors.add(endpoints.targetEmployeeId);
      a.despawn = null;
      if (a.item) continue;
      a.ambientIdle = true;
      a.keepLastFinished = false;
      a.threadIdx = 0;
      a.title = '';
      const idleRoom = this.cleanIdleRoom(emp.idleRoom);
      const idleIntent = { id: 'intent:handoff-target:' + endpoints.targetEmployeeId, category: 'idle_available', sequenceKey: 'idle_available', employeeId: endpoints.targetEmployeeId, movementZoneId: idleRoom };
      if (a.intentId !== idleIntent.id) this.startIntent(a, idleIntent, null, idleIntent.id);
    }
  }

  delegationSourceActorId(endpoints, employeeId, hasUnfinishedByEmp) {
    if (!endpoints || !endpoints.sourceEmployeeId) return employeeId;
    if (endpoints.sourceEmployeeId === employeeId) return employeeId;
    return hasUnfinishedByEmp && hasUnfinishedByEmp.has(endpoints.sourceEmployeeId) ? employeeId : endpoints.sourceEmployeeId;
  }

  releaseTiles(a) {
    for (const [k, owner] of [...this.reserved]) if (owner === a.id) this.reserved.delete(k);
  }

  cleanIdleRoom(value) {
    const room = this.norm(value);
    return this.ZONES[room] ? room : 'common_area';
  }

  idleZoneForActor(a, intent) {
    return this.cleanIdleRoom((intent && intent.movementZoneId) || (intent && intent.targetZone) || (a && a.idleRoom));
  }

  zoneCenter(zone) {
    const list = this.ZONES[zone] || this.ZONES.common_area;
    const total = list.reduce((sum, tile) => ({ x: sum.x + tile[0], y: sum.y + tile[1] }), { x: 0, y: 0 });
    return { x: total.x / Math.max(1, list.length), y: total.y / Math.max(1, list.length) };
  }

  freeTileNear(x, y, ownerId) {
    for (let r = 0; r <= 6; r++) {
      for (let dy = -r; dy <= r; dy++) for (let dx = -r; dx <= r; dx++) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) !== r) continue;
        const nx = x + dx, ny = y + dy;
        if (nx < 1 || ny < 1 || nx >= this.W - 1 || ny >= this.H - 1) continue;
        if (this.blocked[ny] && this.blocked[ny][nx]) continue;
        const k = nx + ',' + ny;
        if (this.reserved.get(k) && this.reserved.get(k) !== ownerId) continue;
        this.reserved.set(k, ownerId);
        return { x: nx, y: ny };
      }
    }
    return null;
  }

  statusOf(item, intent) {
    const s = this.norm((item && (item.status || item.state)) || (intent && intent.sequenceKey) || '');
    if (s === 'needs-input' || s === 'blocked') return 'blocked';
    if (s === 'error' || s === 'failed') return 'failed';
    if (s === 'done' || s === 'completed' || s === 'review') return 'completed';
    return s;
  }

  catOf(item, intent) {
    let cat = this.norm((item && item.semanticEvent && item.semanticEvent.category) || (intent && intent.category) || '');
    if (cat.includes('sketch')) return 'sketch';
    const txt = (String((item && item.title) || '') + ' ' + String((item && item.detail) || '')).toLowerCase();
    if ((cat === 'document' || cat === 'note' || cat === 'generic_tool_work' || cat === '') && /sketch|draw(ing)?\b|paint|canvas|diagram|wireframe|mock-?up|illustrat/.test(txt)) return 'sketch';
    return cat || 'generic_tool_work';
  }

  liveActivityFor(item) {
    const runId = String(workRunId(item) || "").toLowerCase();
    return runId && this.props.liveActivityByRunId ? this.props.liveActivityByRunId[runId] : null;
  }

  syncActors() {
    const emps = this.roster || [];
    const work = (this.workItems || []).slice(0, 22);
    const empById = new Map(emps.map(e => [String(e.id), e]));
    if (!this.retired) this.retired = new Set();
    const seen = new Set();
    const perEmp = new Map();
    const employeesWithVisibleActors = new Set();
    const hasUnfinishedByEmp = new Set();
    const keepCompletedByEmp = new Map();
    for (const w of work) {
      const employeeId = String(w && w.employeeId || "");
      if (!employeeId) continue;
      const status = this.statusOf(w, w.animationIntent);
      if (status === 'completed') {
        if (!keepCompletedByEmp.has(employeeId)) keepCompletedByEmp.set(employeeId, 'run:' + String(w.runId));
      } else {
        hasUnfinishedByEmp.add(employeeId);
      }
    }
    this.ensureDelegationTargetActors(work, empById, seen, employeesWithVisibleActors, hasUnfinishedByEmp);
    // one avatar per run (thread)
    for (const w of work) {
      const key = 'run:' + String(w.runId);
      const status = this.statusOf(w, w.animationIntent);
      const employeeId = String(w.employeeId || "");
      const keepLastFinished = status === 'completed' && !hasUnfinishedByEmp.has(employeeId) && keepCompletedByEmp.get(employeeId) === key;
      if (this.retired.has(key) && status === 'completed' && !keepLastFinished) continue;
      if (this.retired.has(key) && status !== 'completed') this.retired.delete(key);
      if (this.retired.has(key) && keepLastFinished) this.retired.delete(key);
      const intent = w.animationIntent || null;
      const cat = this.catOf(w, intent);
      const endpoints = cat === 'delegation' ? this.delegationEndpoints(w, intent) : null;
      const actorEmployeeId = endpoints ? this.delegationSourceActorId(endpoints, employeeId, hasUnfinishedByEmp) : employeeId;
      const emp = empById.get(String(actorEmployeeId)) || empById.get(String(w.employeeId)) || { id: actorEmployeeId || w.employeeId, name: 'Worker', role: '' };
      let a = this.actors.get(key);
      if (status === 'completed' && !a && !keepLastFinished) continue;
      seen.add(key);
      if (!a) { a = this.createActor(emp, key); this.actors.set(key, a); }
      else this.applyActorEmployee(a, emp);
      a.despawn = null;
      a.name = emp.name || a.name; a.role = emp.role || a.role;
      if (actorEmployeeId) employeesWithVisibleActors.add(actorEmployeeId);
      a.ambientIdle = false;
      a.keepLastFinished = keepLastFinished;
      a.threadIdx = (perEmp.get(a.empId) || 0) + 1; perEmp.set(a.empId, a.threadIdx);
      a.item = w; a.title = w.title || '';
      a.renderDelegatedWorkAsTool = cat === 'delegation' && actorEmployeeId === employeeId && endpoints && endpoints.sourceEmployeeId !== employeeId;
      const liveActivity = this.liveActivityFor(w);
      const iid = (intent ? String(intent.id) : key) + ':' + status + ':' + factoryEventIdentity(w) + ':' + factoryActivityKey(liveActivity);
      const finishedRetentionChanged = status === 'completed' && (
        (keepLastFinished && a.retiringFinished) || (!keepLastFinished && !a.retiringFinished)
      );
      if (iid !== a.intentId || finishedRetentionChanged) this.startIntent(a, intent, w, iid, liveActivity);
      else this.refreshIntent(a, intent, w);
      this.updateSpeechFor(a, w);
      this.updateToolBubbleFor(a, w);
    }
    // one idle avatar per available employee without a visible run actor
    for (const employee of emps) {
      const employeeId = String(employee && employee.id || "");
      if (!employeeId || employeesWithVisibleActors.has(employeeId) || isActiveEmployee(employee)) continue;
      const key = 'idle:' + employeeId;
      const idleIntent = employee.animationIntent || {
        id: 'intent:idle:' + employeeId,
        category: 'idle_available',
        sequenceKey: 'idle_available',
        employeeId,
        movementZoneId: this.cleanIdleRoom(employee.idleRoom),
        movementAnchorId: 'available_employee'
      };
      let a = this.actors.get(key);
      if (!a) { a = this.createActor(employee, key); this.actors.set(key, a); }
      seen.add(key);
      a.despawn = null;
      a.name = employee.name || a.name; a.role = employee.role || a.role;
      a.ambientIdle = true;
      a.keepLastFinished = false; a.threadIdx = 0; a.item = null; a.title = '';
      const iid = String(idleIntent.id || key) + ':idle_available:' + this.cleanIdleRoom(idleIntent.movementZoneId || employee.idleRoom) + ':' + String(employee.lastActivityAt || '');
      if (iid !== a.intentId) this.startIntent(a, idleIntent, null, iid);
      else this.refreshIntent(a, idleIntent, null);
    }
    // duplicate-name marker (same employee, several threads)
    const cnt = new Map();
    for (const a of this.actors.values()) cnt.set(a.empId, (cnt.get(a.empId) || 0) + 1);
    for (const a of this.actors.values()) a.multi = (cnt.get(a.empId) || 0) > 1;
    // fade out actors that vanished from the feed
    for (const [id, a] of [...this.actors]) {
      if (!seen.has(id) && a.despawn == null) a.despawn = 1.2;
    }
  }

  chipFor(cat, status) {
    const st = this.norm(status);
    if (st === 'blocked' || st === 'failed') return this.CHIPS[st];
    if (st === 'completed') return this.CHIPS.completed;
    const cleanCat = this.norm(cat);
    if (Object.prototype.hasOwnProperty.call(this.CHIPS, cleanCat)) return this.CHIPS[cleanCat];
    return this.CHIPS.generic_tool_work;
  }

  zoneAnchor(zone, a, seed) {
    const list = this.ZONES[zone] || this.ZONES.workshop;
    const start = this.hashStr(String(seed || a.id)) % Math.max(1, list.length);
    for (let i = 0; i < list.length; i++) {
      const c = list[(start + i) % list.length];
      const k = c[0] + ',' + c[1];
      const owner = this.reserved.get(k);
      if (!owner || owner === a.id) { this.reserved.set(k, a.id); return { x: c[0], y: c[1] }; }
    }
    const c0 = list[start];
    const t = this.freeTileNear(c0[0], c0[1], a.id);
    if (t) return t;
    return { x: Math.round(a.x), y: Math.round(a.y) };
  }

  startIntent(a, intent, item, iid, liveActivity) {
    a.intentId = iid || (intent ? String(intent.id) : ('idle:' + a.id));
    a.retiringFinished = false;
    a.carryCard = false; a.carryBook = false; a.overlay = null; a.sub = null; a.retireAt = 0; a.doneFlag = false;
    a.toolMeta = item ? factoryToolActivityMeta(item, liveActivity) : null;
    a.toolMode = a.toolMeta ? a.toolMeta.mode : "";
    a.toolAnim = a.toolMeta ? a.toolMeta.anim : "";
    this.releaseTiles(a);
    const cat = !item ? 'idle_available' : a.toolMeta || a.renderDelegatedWorkAsTool ? 'generic_tool_work' : this.catOf(item, intent);
    const status = this.statusOf(item, intent);
    a.cat = cat;
    a.chip = a.toolMeta ? { label: a.toolMeta.chip, color: factoryToolChipColor(a.toolMeta.mode) } : this.chipFor(cat, status);
    if (status === 'blocked' || status === 'failed') {
      a.overlay = (item && item.queue && item.queue.needsInput) ? '?' : '!';
      this.reserved.set(Math.round(a.x) + ',' + Math.round(a.y), a.id);
      a.mode = 'hold'; a.path = null; a.t = 9e9;
      return;
    }
    if (status === 'completed') {
      a.doneFlash = Math.max(a.doneFlash || 0, 2.6); a.doneFlag = true; a.retireAt = 0; a.carryCard = true;
      a.retiringFinished = !a.keepLastFinished;
      const an = this.zoneAnchor('common_area', a, a.id + ':finished');
      a.anchor = an; a.zone = 'common_area';
      this.walkTo(a, an.x, an.y, { type: a.keepLastFinished ? 'finished-idle' : 'retire-done' });
      return;
    }
    if (cat === 'delegation') {
      const tgtEmp = this.delegationEndpoints(item, intent).targetEmployeeId;
      let tgt = null;
      for (const o of this.actors.values()) if (o !== a && o.empId === tgtEmp && o.despawn == null) { tgt = o; break; }
      a.carryCard = true; a.zone = 'dispatch';
      if (tgt) {
        const nb = this.freeNeighbor(Math.round(tgt.x), Math.round(tgt.y), Math.round(a.x), Math.round(a.y), a.id);
        if (nb) { this.reserved.set(nb[0] + ',' + nb[1], a.id); this.walkTo(a, nb[0], nb[1], { type: 'handoff', target: tgt.id }); return; }
      }
      const an = this.zoneAnchor('dispatch', a, intent && intent.id);
      a.anchor = an;
      this.walkTo(a, an.x, an.y, { type: 'act' });
      return;
    }
    if (cat === 'idle_available' || (!intent && !item)) {
      a.chip = null; a.cat = 'idle_available';
      if (!item) {
        a.pendingIdleZone = this.idleZoneForActor(a, intent);
        this.placeIdle(a, a.id);
      }
      else this.goIdle(a);
      return;
    }
    const zone = a.toolMeta && a.toolMeta.zone ? a.toolMeta.zone : (this.ZONE_OF_CATEGORY[cat] || 'workshop');
    a.zone = zone;
    if (zone === 'archive_shelves') {
      a.shelfAnchor = this.zoneAnchor('archive_shelves', a, item && item.runId);
      a.tableAnchor = this.zoneAnchor('archive_tables', a, (item && item.runId) + ':t');
      a.rw = a.toolMeta && ['write', 'create'].includes(a.toolMeta.mode) ? 'write' : /\b(write|update|edit|append|save|create|add|file|record|set)\b/i.test(String((item && item.title) || '')) ? 'write' : 'read';
      this.walkTo(a, a.shelfAnchor.x, a.shelfAnchor.y, { type: 'archive-shelf' });
      return;
    }
    const an = this.zoneAnchor(zone, a, item && item.runId);
    a.anchor = an;
    this.walkTo(a, an.x, an.y, { type: 'act' });
  }

  refreshIntent(a, intent, item) {
    const status = this.statusOf(item, intent);
    if (a.mode === 'hold' && status !== 'blocked' && status !== 'failed') { a.overlay = null; this.startIntent(a, intent, item, a.intentId + ':r'); }
  }

  goIdle(a) {
    const zone = this.idleZoneForActor(a, null);
    a.zone = zone;
    this.releaseTiles(a);
    const an = this.zoneAnchor(zone, a, a.id + ':' + Math.floor(this.simT / 15));
    this.walkTo(a, an.x, an.y, { type: 'idle', sit: Math.random() < 0.55 });
  }

  placeIdle(a, seed) {
    const idleZone = this.cleanIdleRoom(a.pendingIdleZone || a.idleRoom);
    a.pendingIdleZone = "";
    a.zone = idleZone;
    a.cat = 'idle_available';
    a.chip = null;
    a.toolMeta = null;
    a.toolMode = "";
    a.toolAnim = "";
    a.carryCard = false;
    a.carryBook = false;
    a.overlay = null;
    a.sub = null;
    a.retireAt = 0;
    a.doneFlag = false;
    this.releaseTiles(a);
    const an = this.zoneAnchor(idleZone, a, seed || a.id);
    a.anchor = an;
    a.x = an.x;
    a.y = an.y;
    a.path = null;
    a.next = null;
    a.mode = 'idle';
    a.t = 12 + (this.hashStr(String(seed || a.id)) % 14);
    a.sit = this.hashStr(String(seed || a.id) + ':sit') % 100 < 55;
    if (a.sit) {
      const center = this.zoneCenter(idleZone);
      a.face = ((center.x - a.x) - (center.y - a.y)) >= 0 ? 1 : -1;
    }
  }

  // ---------- movement ----------
  initWorld() {
    const H = this.MAP.length, W = this.MAP[0].length;
    this.W = W; this.H = H;
    this.tiles = this.MAP.map(r => r.split(''));
    this.blocked = [];
    for (let y = 0; y < H; y++) { this.blocked[y] = []; for (let x = 0; x < W; x++) this.blocked[y][x] = !'.obD'.includes(this.tiles[y][x]); }
    for (const f of this.FURN) for (const [x, y] of f.tiles) this.blocked[y][x] = true;
    this.shade = [];
    for (let y = 0; y < H; y++) { this.shade[y] = []; for (let x = 0; x < W; x++) { const h = Math.sin(x * 127.3 + y * 311.7) * 43758.54; this.shade[y][x] = (h - Math.floor(h)) - 0.5; } }
    this.roster = []; this.workItems = []; this.workByRun = new Map();
    this.reserved = new Map(); this.retired = new Set();
  }

  iso(x, y) { return [this.OX + (x - y) * this.TW / 2, this.OY + (x + y) * this.TH / 2]; }

  findPath(sx, sy, tx, ty, avoid) {
    if (this.blocked[ty] && this.blocked[ty][tx]) return null;
    const key = (x, y) => y * this.W + x;
    const prev = new Map(); const q = [[sx, sy]]; prev.set(key(sx, sy), -1);
    while (q.length) {
      const [x, y] = q.shift();
      if (x === tx && y === ty) {
        const path = []; let k = key(tx, ty);
        while (k !== -1) { path.unshift({ x: k % this.W, y: Math.floor(k / this.W) }); k = prev.get(k); }
        return path;
      }
      for (const [dx, dy] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) {
        const nx = x + dx, ny = y + dy;
        if (nx < 0 || ny < 0 || nx >= this.W || ny >= this.H) continue;
        if (this.blocked[ny][nx] || prev.has(key(nx, ny))) continue;
        if (avoid && avoid.has(nx + ',' + ny) && !(nx === tx && ny === ty)) continue;
        prev.set(key(nx, ny), key(x, y)); q.push([nx, ny]);
      }
    }
    return null;
  }

  freeNeighbor(tx, ty, fromX, fromY, ownerId) {
    let best = null, bd = 1e9;
    for (const [dx, dy] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) {
      const nx = tx + dx, ny = ty + dy;
      if (nx < 0 || ny < 0 || nx >= this.W || ny >= this.H || this.blocked[ny][nx]) continue;
      const k = nx + ',' + ny;
      if (this.reserved && this.reserved.get(k) && this.reserved.get(k) !== ownerId) continue;
      const d = Math.abs(nx - fromX) + Math.abs(ny - fromY);
      if (d < bd) { bd = d; best = [nx, ny]; }
    }
    return best;
  }

  walkTo(a, tx, ty, next) {
    // route around figures that are standing still (working, blocked, sitting)
    const avoid = new Set();
    for (const o of this.actors.values()) {
      if (o === a || o.despawn != null || o.mode === 'walk') continue;
      avoid.add(Math.round(o.x) + ',' + Math.round(o.y));
    }
    let path = this.findPath(Math.round(a.x), Math.round(a.y), tx, ty, avoid);
    if (!path) path = this.findPath(Math.round(a.x), Math.round(a.y), tx, ty, null);
    if (!path || path.length < 2) { this.arriveActor(a, next || { type: 'idle' }); return; }
    a.path = path; a.seg = 0; a.mode = 'walk'; a.next = next; a.walked = 0;
    a._chk = 0; a._lastWalked = 0;
  }

  arriveActor(a, next) {
    a.path = null;
    if (!next) next = { type: 'idle' };
    if (next.type === 'act') { a.mode = 'act'; a.t = 9e9; a.sit = false; a.sub = null; }
    else if (next.type === 'archive-shelf') { a.mode = 'act'; a.sit = false; a.sub = 'shelf'; a.carryBook = false; a.t = 2.5 + Math.random() * 2.5; }
    else if (next.type === 'archive-table') { a.mode = 'act'; a.sit = false; a.sub = 'table'; a.carryBook = false; a.t = 5 + Math.random() * 5; }
    else if (next.type === 'idle') { a.mode = 'idle'; a.t = 12 + Math.random() * 14; a.sit = !!next.sit; if (a.sit) a.face = ((20.5 - a.x) - (15 - a.y)) >= 0 ? 1 : -1; }
    else if (next.type === 'finished-idle') { a.mode = 'idle'; a.t = 12 + Math.random() * 14; a.sit = false; a.carryCard = false; a.retireAt = 0; }
    else if (next.type === 'retire-done') { a.mode = 'stand'; a.t = 0.9; a.sit = false; a.carryCard = false; a.retireAt = 0.9; }
    else if (next.type === 'handoff') {
      const tgt = this.actors.get(next.target);
      if (tgt && Math.abs(tgt.x - a.x) + Math.abs(tgt.y - a.y) > 2.2 && (a.handoffTries || 0) < 3) {
        a.handoffTries = (a.handoffTries || 0) + 1;
        const nb = this.freeNeighbor(Math.round(tgt.x), Math.round(tgt.y), Math.round(a.x), Math.round(a.y), a.id);
        if (nb) { this.releaseTiles(a); this.reserved.set(nb[0] + ',' + nb[1], a.id); this.walkTo(a, nb[0], nb[1], next); return; }
      }
      a.handoffTries = 0;
      a.mode = 'handoff'; a.t = 2.4; a.sit = false;
      if (tgt) {
        a.face = ((tgt.x - a.x) - (tgt.y - a.y)) >= 0 ? 1 : -1;
        const [x1, y1] = this.iso(a.x, a.y); const [x2, y2] = this.iso(tgt.x, tgt.y);
        this.flyingCards.push({ x1, y1: y1 - 24, x2, y2: y2 - 24, t: 0, dur: 1.1 });
        a.carryCard = false;
      }
    }
  }

  updateActor(a, dt) {
    if (a.despawn != null) { a.despawn -= dt; return; }
    if (a.mode === 'walk') {
      const speed = 2.4; let rem = speed * dt;
      while (rem > 0 && a.path && a.seg < a.path.length - 1) {
        const nx = a.path[a.seg + 1];
        const dx = nx.x - a.x, dy = nx.y - a.y;
        const d = Math.hypot(dx, dy);
        if (d < 1e-6) { a.seg++; continue; }
        const step = Math.min(rem, d);
        const sdx = dx - dy;
        if (Math.abs(sdx) > 0.001) a.face = sdx > 0 ? 1 : -1;
        a.x += dx / d * step; a.y += dy / d * step;
        a.walked += step; rem -= step;
        if (step >= d - 1e-6) a.seg++;
      }
      if (!a.path || a.seg >= a.path.length - 1) { const n = a.next; a.next = null; this.arriveActor(a, n); return; }
      // stuck? (pushed around without making progress) — re-plan the route
      a._chk = (a._chk || 0) + dt;
      if (a._chk > 1.5) {
        if (a.walked - (a._lastWalked || 0) < 0.3) {
          const tgt = a.path[a.path.length - 1];
          this.walkTo(a, tgt.x, tgt.y, a.next);
        } else { a._lastWalked = a.walked; a._chk = 0; }
      }
      return;
    }
    if (a.doneFlash > 0) a.doneFlash -= dt;
    if (a.retireAt) {
      a.retireAt -= dt;
      if (a.retireAt <= 0) { a.retireAt = 0; a.despawn = 1.2; this.retired.add(a.id); }
      return;
    }
    a.t -= dt;
    if (a.t > 0) return;
    if (a.mode === 'act' && a.sub === 'shelf' && a.tableAnchor) {
      a.carryBook = true;
      this.walkTo(a, a.tableAnchor.x, a.tableAnchor.y, { type: 'archive-table' });
    } else if (a.mode === 'act' && a.sub === 'table' && a.shelfAnchor) {
      a.carryBook = true;
      this.walkTo(a, a.shelfAnchor.x, a.shelfAnchor.y, { type: 'archive-shelf' });
    } else if (a.mode === 'handoff') {
      const an = this.zoneAnchor('dispatch', a, a.id);
      a.anchor = an; a.zone = 'dispatch';
      this.walkTo(a, an.x, an.y, { type: 'act' });
    } else if (a.mode === 'idle') { a.ambientIdle ? this.placeIdle(a, a.id) : this.goIdle(a); }
    else { a.t = 9e9; }
  }

  // soft collision: keep figures from overlapping while moving
  nudge(a, dx, dy) {
    if (!dx && !dy) return;
    const ok = (nx, ny) => {
      const tx = Math.round(nx), ty = Math.round(ny);
      return tx >= 0 && ty >= 0 && tx < this.W && ty < this.H && !this.blocked[ty][tx];
    };
    if (ok(a.x + dx, a.y + dy)) { a.x += dx; a.y += dy; return; }
    // slide along whichever axis is free instead of freezing against a wall
    if (dx && ok(a.x + dx, a.y)) { a.x += dx; return; }
    if (dy && ok(a.x, a.y + dy)) { a.y += dy; return; }
  }

  separateActors(dt) {
    const list = [...this.actors.values()].filter(o => o.despawn == null);
    const minD = 0.45;
    const acc = new Map();
    const add = (o, x, y) => { const v = acc.get(o.id) || [0, 0]; v[0] += x; v[1] += y; acc.set(o.id, v); };
    for (let i = 0; i < list.length; i++) for (let j = i + 1; j < list.length; j++) {
      const a = list[i], b = list[j];
      let dx = b.x - a.x, dy = b.y - a.y;
      if (dx > minD || dx < -minD || dy > minD || dy < -minD) continue;
      let d = Math.hypot(dx, dy);
      if (d >= minD) continue;
      if (d < 1e-4) { dx = 0.01; dy = 0.013 * ((i % 2) ? 1 : -1); d = Math.hypot(dx, dy); }
      const push = minD - d;
      const ux = dx / d, uy = dy / d;
      // mostly sideways slip, only a little backward push, so walkers keep their pace
      const px = -uy * 0.8, py = ux * 0.8;
      const aMov = a.mode === 'walk', bMov = b.mode === 'walk';
      if (aMov && bMov) {
        add(a, (-ux * 0.5 + px) * push * 0.5, (-uy * 0.5 + py) * push * 0.5);
        add(b, (ux * 0.5 + px) * push * 0.5, (uy * 0.5 + py) * push * 0.5);
      }
      else if (aMov) add(a, (-ux * 0.5 + px) * push, (-uy * 0.5 + py) * push);
      else if (bMov) add(b, (ux * 0.5 + px) * push, (uy * 0.5 + py) * push);
      // both stationary: anchors are unique, leave them be
    }
    // apply once per figure, capped, so overlapping pairs can't compound into a crawl
    const cap = 2.2 * dt;
    for (const a of list) {
      const v = acc.get(a.id); if (!v) continue;
      const m = Math.hypot(v[0], v[1]); if (m < 1e-6) continue;
      const k = Math.min(m, cap) / m;
      this.nudge(a, v[0] * k, v[1] * k);
    }
  }

  activityOf(a) {
    const st = this.statusOf(a.item, null);
    if (st === 'blocked') return (a.item && a.item.queue && a.item.queue.approvalRequestTitle) ? 'Blocked \u2014 ' + a.item.queue.approvalRequestTitle : 'Blocked \u2014 waiting on approval';
    if (st === 'failed') return 'Task failed \u2014 needs attention';
    if (st === 'completed') return 'Finished: ' + (a.title || 'task');
    if (a.toolMeta) return a.toolMeta.subject ? a.toolMeta.label + ': ' + a.toolMeta.subject : a.toolMeta.label;
    if (a.mode === 'walk' && a.carryCard) return 'Carrying a handoff to a colleague';
    if (a.mode === 'walk' && a.carryBook) return a.rw === 'write' ? 'Carrying the folder \u2014 something to record' : 'Carrying the folder to the reading table';
    if (a.mode === 'handoff') return 'Handing off the task';
    if (a.mode === 'walk') return a.title ? 'Heading off: ' + a.title : 'Crossing the floor';
    if (a.mode === 'act') {
      if (a.sub === 'shelf') return 'Pulling a folder from the shelves';
      if (a.sub === 'table') return (a.rw === 'write' ? 'Writing in the folder: ' : 'Reading the folder: ') + (a.title || '');
      return a.title || 'Working';
    }
    return 'Available';
  }

  runMetaOf(a) {
    if (!a.item) return 'No active run \u2014 idle & available';
    const chip = a.toolMeta ? a.chip : this.chipFor(a.cat, this.statusOf(a.item, null));
    const rid = String(a.item.runId || '').slice(0, 8);
    const thr = a.item.tool && a.item.tool.threadId ? ' \u2022 via Codex Bridge' : '';
    const idx = a.multi && a.threadIdx ? ' \u2022 thread ' + a.threadIdx : '';
    return (chip ? chip.label : 'WORK') + ' \u2022 run ' + rid + idx + thr;
  }

  // ---------- speech ----------
  speechFor(item) {
    if (!item) return null;
    const runId = String(workRunId(item) || "").toLowerCase();
    const liveSpeech = runId && this.props.liveSpeechByRunId && this.props.liveSpeechByRunId[runId];
    const liveKey = factoryActivityKey(liveSpeech);
    const liveText = factorySpeechTextFromActivity(liveSpeech);
    const liveAt = changedAtMillis(liveSpeech && (liveSpeech.changedAt || liveSpeech.createdAt));
    const fresh = !liveAt || Date.now() - liveAt < 12000;
    if (liveText && fresh && liveKey && !this.seenSpeechKeys.has(liveKey)) return { text: liveText, key: liveKey };
    const text = speechTextForWork(item);
    return text ? { text, key: `work:${factoryEventIdentity(item)}:${text}` } : null;
  }

  updateSpeechFor(a, item) {
    if ((this.props.showSpeech ?? true) === false) { this.speech.delete(a.id); return; }
    const speech = this.speechFor(item);
    const text = speech && speech.text;
    const cur = this.speech.get(a.id);
    if (text && (!cur || cur.text !== text || cur.until < this.realT + 2)) {
      this.speech.set(a.id, { text, key: speech.key, until: this.realT + 7.5 });
      if (speech.key && !speech.key.startsWith("work:")) {
        this.seenSpeechKeys.add(speech.key);
        if (this.seenSpeechKeys.size > 200) this.seenSpeechKeys = new Set(Array.from(this.seenSpeechKeys).slice(-120));
      }
    }
    else if (!text && cur) { /* keep until expiry */ }
  }

  updateToolBubbleFor(a, item) {
    if (!item) return;
    const runId = String(workRunId(item) || "").toLowerCase();
    const activity = runId && this.props.liveActivityByRunId && this.props.liveActivityByRunId[runId];
    const bubble = factoryToolBubbleFromActivity(activity);
    if (!bubble || this.seenToolKeys.has(bubble.key)) return;
    this.seenToolKeys.add(bubble.key);
    if (this.seenToolKeys.size > 300) this.seenToolKeys = new Set(Array.from(this.seenToolKeys).slice(-180));
    const actorBubbleCount = this.toolBubbles.filter((item) => item.actorId === a.id && (this.realT || 0) - item.born < item.life).length;
    this.toolBubbles.push({ ...bubble, actorId: a.id, born: this.realT || 0, life: 4.2, stack: actorBubbleCount % 4 });
    if (this.toolBubbles.length > 12) this.toolBubbles = this.toolBubbles.slice(-12);
  }

  renderSpeechDom() {
    const layer = this.speechLayerRef.current, cv = this.canvasRef.current;
    if (!layer || !cv) return;
    const scale = cv.clientWidth / this.LW;
    const active = [];
    for (const [id, s] of [...this.speech]) {
      if (this.realT > s.until || !this.actors.has(id)) { this.speech.delete(id); continue; }
      active.push([id, s]);
    }
    active.sort((p, q) => p[1].until - q[1].until);
    const show = active.slice(-4);
    const want = new Set(show.map(([id]) => id));
    for (const child of [...layer.children]) {
      if (!want.has(child.dataset.aid)) {
        if (child._markdownRoot && child._markdownRoot.unmount) child._markdownRoot.unmount();
        child.remove();
      }
    }
    for (const [id, s] of show) {
      const a = this.actors.get(id);
      let el = [...layer.children].find(c => c.dataset.aid === id);
      if (!el) {
        el = document.createElement('button');
        el.type = 'button';
        el.className = 'factory-speech-bubble collapsed';
        el.dataset.aid = id;
        el.dataset.expanded = 'false';
        el.addEventListener('click', (event) => {
          event.stopPropagation();
          const expanded = el.dataset.expanded === 'true';
          el.dataset.expanded = expanded ? 'false' : 'true';
          el.classList.toggle('expanded', !expanded);
          el.classList.toggle('collapsed', expanded);
          const toggle = el.querySelector('[data-role="toggle"]');
          if (toggle) toggle.textContent = expanded ? 'Show more' : 'Show less';
        });
        const tail = document.createElement('div');
        tail.className = 'factory-speech-tail';
        el.appendChild(tail);
        const body = document.createElement('div');
        body.className = 'factory-speech-body';
        body.dataset.role = 'body';
        el.appendChild(body);
        const hint = document.createElement('span');
        hint.className = 'factory-speech-toggle';
        hint.dataset.role = 'toggle';
        hint.textContent = 'Show more';
        el.appendChild(hint);
        layer.appendChild(el);
      }
      const body = el.querySelector('[data-role="body"]');
      if (body && body.dataset.text !== s.text) {
        body.dataset.text = s.text;
        if (window.MarkdownText && window.ReactDOM && window.ReactDOM.createRoot) {
          if (!el._markdownRoot) el._markdownRoot = window.ReactDOM.createRoot(body);
          el._markdownRoot.render(React.createElement(window.MarkdownText, { text: s.text }));
        } else {
          body.textContent = s.text;
        }
      }
      const [sx, sy] = this.iso(a.x, a.y);
      el.style.left = ((sx + a.off) * scale) + 'px';
      el.style.top = ((sy - 66) * scale) + 'px';
      const fade = Math.min(1, Math.max(0, s.until - this.realT));
      el.style.opacity = fade;
    }
  }

  renderToolDom() {
    const layer = this.toolLayerRef.current, cv = this.canvasRef.current;
    if (!layer || !cv) return;
    const scale = cv.clientWidth / this.LW;
    this.toolBubbles = (this.toolBubbles || []).filter((bubble) => {
      const actor = this.actors.get(bubble.actorId);
      return actor && this.realT - bubble.born < bubble.life;
    });
    const want = new Set(this.toolBubbles.map((bubble) => bubble.key));
    for (const child of [...layer.children]) if (!want.has(child.dataset.key)) child.remove();
    for (const bubble of this.toolBubbles) {
      const actor = this.actors.get(bubble.actorId);
      if (!actor) continue;
      let el = [...layer.children].find(c => c.dataset.key === bubble.key);
      if (!el) {
        el = document.createElement('div');
        el.className = 'factory-tool-bubble';
        el.dataset.key = bubble.key;
        const icon = document.createElement('span');
        icon.className = 'factory-tool-bubble-icon';
        icon.textContent = bubble.glyph;
        el.appendChild(icon);
        const label = document.createElement('span');
        label.className = 'factory-tool-bubble-label';
        label.textContent = bubble.label;
        el.appendChild(label);
        layer.appendChild(el);
      }
      const age = this.realT - bubble.born;
      const progress = Math.max(0, Math.min(1, age / bubble.life));
      const eased = 1 - Math.pow(1 - progress, 2);
      const side = bubble.stack % 2 === 0 ? -1 : 1;
      const lane = Math.floor(bubble.stack / 2);
      const xOffset = side * (18 + lane * 18) * Math.sin(progress * Math.PI);
      const yOffset = 48 + bubble.stack * 18 + eased * 118;
      const [sx, sy] = this.iso(actor.x, actor.y);
      el.style.left = ((sx + actor.off + xOffset) * scale) + 'px';
      el.style.top = ((sy - yOffset) * scale) + 'px';
      el.style.opacity = String(Math.max(0, Math.min(1, progress < 0.12 ? progress / 0.12 : (1 - progress) / 0.22)));
    }
  }

  caption(text) {
    if ((this.props.showCaptions ?? true) === false) return;
    if (this.capQueue.length < 4 && !this.capQueue.includes(text)) this.capQueue.push(text);
  }

  // ================= FRAME =================
  frame() {
    const cv = this.canvasRef.current; if (!cv) return;
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    if (cv.width !== this.LW * dpr) { cv.width = this.LW * dpr; cv.height = this.LH * dpr; }
    const ctx = cv.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    const now = performance.now() / 1000;
    let dt = Math.min(0.05, now - this.tPrev); this.tPrev = now;
    const pace = Math.max(0.1, this.props.pace ?? 1);
    const dts = dt * pace;
    this.simT += dts; this.realT += dt;

    for (const a of this.actors.values()) this.updateActor(a, dts);
    this.separateActors(dts);
    for (const [id, a] of [...this.actors]) {
      if (a.despawn != null && a.despawn <= 0) {
        this.releaseTiles(a);
        this.actors.delete(id); this.speech.delete(id);
        if (this.state.sel === id) this.setState({ sel: '' });
      }
    }
    for (const c of this.flyingCards) c.t += dts;
    this.flyingCards = this.flyingCards.filter(c => c.t < c.dur);
    this.updateSmoke(dts);
    this.updateSparks(dts);

    ctx.fillStyle = '#120d08'; ctx.fillRect(0, 0, this.LW, this.LH);
    this.drawFloor(ctx);

    const dr = [];
    for (let y = 0; y < this.H; y++) for (let x = 0; x < this.W; x++)
      if (this.tiles[y][x] === '#') dr.push({ d: x + y + 0.2, f: () => this.drawWall(ctx, x, y) });
    for (const f of this.FURN) {
      const dmax = Math.max(...f.tiles.map(([x, y]) => x + y));
      dr.push({ d: dmax + 0.1, f: () => this.drawFurniture(ctx, f) });
    }
    for (const [px, py] of this.POSTS) dr.push({ d: px + py + 0.2, f: () => this.drawPost(ctx, px, py) });
    for (const [bx, by] of this.BUSHES) dr.push({ d: bx + by + 0.1, f: () => this.drawBush(ctx, bx, by) });
    for (let i = 0; i < this.FLOWERS.length; i++) { const fb = this.FLOWERS[i]; dr.push({ d: fb[0] + fb[1] + 0.3, f: () => this.drawFlowerBed(ctx, fb[0], fb[1], i) }); }
    dr.push({ d: 23.6, f: () => this.drawShaft(ctx) });
    for (const a of this.actors.values()) dr.push({ d: a.x + a.y + 0.45, f: () => this.drawPerson(ctx, a) });
    dr.sort((p, q) => p.d - q.d);
    for (const d of dr) d.f();

    this.drawSparks(ctx);
    for (const a of this.actors.values()) this.drawActorBadges(ctx, a);
    this.drawFlyingCards(ctx);
    this.drawSmoke(ctx);
    this.drawLamps(ctx);

    const vg = ctx.createRadialGradient(this.LW / 2, this.LH / 2, this.LH * 0.5, this.LW / 2, this.LH / 2, this.LW * 0.72);
    vg.addColorStop(0, 'rgba(0,0,0,0)'); vg.addColorStop(1, 'rgba(0,0,0,0.32)');
    ctx.fillStyle = vg; ctx.fillRect(0, 0, this.LW, this.LH);

    this.renderSpeechDom();
    this.renderToolDom();
    this.updateCaptionDom();
    this.updatePopupDom();
  }

  // ---------- badges (tool-call chips + status overlays) ----------
  drawActorBadges(ctx, a) {
    const [sx0, sy] = this.iso(a.x, a.y);
    const sx = sx0 + a.off;
    if (a.despawn != null) ctx.globalAlpha = Math.max(0, Math.min(1, a.despawn / 1.2));
    if (a.chip) {
      ctx.font = "10px 'IM Fell English SC', serif";
      const tw = ctx.measureText(a.chip.label).width;
      const w = tw + 16, h = 15, bx = sx - w / 2, by = sy - 52;
      ctx.fillStyle = a.chip.color;
      ctx.globalAlpha = 0.94;
      ctx.beginPath();
      if (ctx.roundRect) ctx.roundRect(bx, by, w, h, 3); else ctx.rect(bx, by, w, h);
      ctx.fill();
      ctx.beginPath(); ctx.moveTo(sx - 3, by + h); ctx.lineTo(sx + 3, by + h); ctx.lineTo(sx, by + h + 4); ctx.closePath(); ctx.fill();
      ctx.globalAlpha = 1;
      ctx.fillStyle = '#f2e8d0';
      ctx.fillText(a.chip.label, bx + 8, by + 11);
    }
    if (a.overlay) {
      const pulse = 0.75 + 0.25 * Math.sin(this.simT * 5 + a.bobPh);
      ctx.fillStyle = a.overlay === '?' ? 'rgba(196,142,52,' + pulse + ')' : 'rgba(160,60,46,' + pulse + ')';
      ctx.beginPath(); ctx.arc(sx + 13, sy - 58, 7.5, 0, 7); ctx.fill();
      ctx.fillStyle = '#f5ecd8'; ctx.font = "bold 11px serif";
      ctx.fillText(a.overlay, sx + 13 - 2.5, sy - 54);
    }
    if (a.doneFlag || a.doneFlash > 0) {
      const k = a.doneFlash > 0 ? Math.min(1, a.doneFlash / 2.6) : 0.78;
      ctx.fillStyle = 'rgba(61,99,68,' + (0.72 + 0.18 * k) + ')';
      ctx.strokeStyle = 'rgba(142,211,145,' + (0.74 + 0.2 * k) + ')';
      ctx.lineWidth = 1.8;
      ctx.beginPath(); ctx.arc(sx + 13, sy - 58, 8.2, 0, 7); ctx.fill(); ctx.stroke();
      ctx.strokeStyle = '#f2e8d0'; ctx.lineWidth = 2.1;
      ctx.beginPath(); ctx.moveTo(sx + 9.4, sy - 58); ctx.lineTo(sx + 12, sy - 55.2); ctx.lineTo(sx + 17.3, sy - 62.4); ctx.stroke();
      ctx.fillStyle = 'rgba(61,99,68,' + (0.84 + 0.12 * k) + ')';
      ctx.fillRect(sx + 19, sy - 65, 2, 14);
      ctx.beginPath(); ctx.moveTo(sx + 21, sy - 65); ctx.lineTo(sx + 31, sy - 62); ctx.lineTo(sx + 21, sy - 59); ctx.closePath(); ctx.fill();
    }
    ctx.globalAlpha = 1;
  }

  drawFlyingCards(ctx) {
    for (const c of this.flyingCards) {
      const k = Math.min(1, c.t / c.dur);
      const x = c.x1 + (c.x2 - c.x1) * k;
      const y = c.y1 + (c.y2 - c.y1) * k - Math.sin(k * Math.PI) * 22;
      ctx.save();
      ctx.translate(x, y); ctx.rotate(Math.sin(k * 6) * 0.2);
      ctx.fillStyle = '#e8e0cc'; ctx.fillRect(-6, -4, 12, 8);
      ctx.strokeStyle = '#8a6a35'; ctx.lineWidth = 1; ctx.strokeRect(-6, -4, 12, 8);
      ctx.strokeStyle = 'rgba(90,70,40,0.6)';
      ctx.beginPath(); ctx.moveTo(-4, -1); ctx.lineTo(4, -1); ctx.moveTo(-4, 1.5); ctx.lineTo(2, 1.5); ctx.stroke();
      ctx.restore();
    }
  }

  // ---------- scenery (floor, walls, furniture, people, smoke, lamps) ----------
  tint(hex, d) {
    const n = parseInt(hex.slice(1), 16);
    const r = Math.max(0, Math.min(255, (n >> 16) + d)), g = Math.max(0, Math.min(255, ((n >> 8) & 255) + d)), b = Math.max(0, Math.min(255, (n & 255) + d));
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }

  drawFloor(ctx) {
    if (!this._floorCv || this._floorVer !== 6) {
      const oc = document.createElement('canvas');
      oc.width = this.LW * 2; oc.height = this.LH * 2;
      const c = oc.getContext('2d');
      c.setTransform(2, 0, 0, 2, 0, 0);
      this.paintFloor(c);
      this._floorCv = oc;
      this._floorVer = 6;
    }
    ctx.drawImage(this._floorCv, 0, 0, this.LW, this.LH);
  }

  shadeAt(x, y) { const h = Math.sin(x * 127.3 + y * 311.7) * 43758.54; return (h - Math.floor(h)) - 0.5; }

  fhash(x, y, n) { const v = Math.sin(x * 127.31 + y * 311.7 + n * 74.7) * 43758.5453; return v - Math.floor(v); }

  paintFloor(c) {
    const T2 = this.TW / 2, H2 = this.TH / 2;
    const dia = (sx, sy, k) => { c.beginPath(); c.moveTo(sx, sy - H2 + k); c.lineTo(sx + T2 - k * 2, sy); c.lineTo(sx, sy + H2 - k); c.lineTo(sx - T2 + k * 2, sy); c.closePath(); };
    const quadUV = (sx, sy, u0, v0, u1, v1, fill) => {
      const P = (u, v) => [sx + (u - v) * T2, sy - H2 + (u + v) * H2];
      const p1 = P(u0, v0), p2 = P(u1, v0), p3 = P(u1, v1), p4 = P(u0, v1);
      c.fillStyle = fill; c.beginPath(); c.moveTo(p1[0], p1[1]); c.lineTo(p2[0], p2[1]); c.lineTo(p3[0], p3[1]); c.lineTo(p4[0], p4[1]); c.closePath(); c.fill();
    };
    // --- extended ground plane: lawn, sidewalk, street ---
    for (let y = -22; y < 42; y++) for (let x = -24; x < 52; x++) {
      const inside = (x >= 0 && x < this.W && y >= 0 && y < this.H);
      if (inside && this.tiles[y][x] !== 'g' && this.tiles[y][x] !== 'c') continue;
      const [sx, sy] = this.iso(x, y);
      if (sx < -T2 || sx > this.LW + T2 || sy < -H2 || sy > this.LH + H2) continue;
      if (y === 19) {
        c.fillStyle = this.tint('#757167', (this.fhash(x, y, 1) - 0.5) * 14);
        dia(sx, sy, 0); c.fill();
        c.strokeStyle = 'rgba(30,26,20,0.35)'; c.lineWidth = 1; dia(sx, sy, 0); c.stroke();
      } else if (y >= 20 && y <= 22) {
        c.fillStyle = this.tint('#57544c', (this.fhash(x, y, 0) - 0.5) * 10);
        dia(sx, sy, 0); c.fill();
        for (let i = 0; i < 6; i++) {
          const u = this.fhash(x, y, i) - 0.5, w2 = this.fhash(x, y, i + 6) - 0.5;
          const px = sx + u * T2 * 1.2 * (1 - Math.abs(w2) * 1.4);
          const py = sy + w2 * H2 * 1.2 * (1 - Math.abs(u) * 1.4);
          c.fillStyle = this.tint('#635f56', (this.fhash(x, y, i + 12) - 0.5) * 24);
          c.beginPath(); c.ellipse(px, py, 5, 2.8, 0, 0, 7); c.fill();
        }
      } else {
        c.fillStyle = this.tint(((x + y) % 2) ? '#5f6d44' : '#53603a', this.shadeAt(x, y) * 8);
        dia(sx, sy, 0); c.fill();
        if (this.fhash(x, y, 8) > 0.55) {
          c.strokeStyle = 'rgba(34,48,20,0.4)'; c.lineWidth = 1;
          const tx = sx + (this.fhash(x, y, 2) - 0.5) * T2 * 0.9, ty2 = sy + (this.fhash(x, y, 5) - 0.5) * H2 * 0.8;
          c.beginPath(); c.moveTo(tx, ty2); c.lineTo(tx - 1.2, ty2 - 2.6); c.moveTo(tx + 1.6, ty2); c.lineTo(tx + 2.2, ty2 - 2.2); c.stroke();
        }
      }
    }
    // curb line
    {
      const a1 = this.iso(-24, 19.55), a2 = this.iso(52, 19.55);
      c.strokeStyle = 'rgba(20,16,12,0.45)'; c.lineWidth = 1.5;
      c.beginPath(); c.moveTo(a1[0], a1[1]); c.lineTo(a2[0], a2[1]); c.stroke();
    }
    // wrought-iron fence along the far side of the street
    {
      const yF = 22.75;
      c.strokeStyle = '#14100c'; c.lineWidth = 1.6;
      const b1 = this.iso(-24, yF), b2 = this.iso(52, yF);
      c.beginPath(); c.moveTo(b1[0], b1[1] - 13); c.lineTo(b2[0], b2[1] - 13); c.stroke();
      c.lineWidth = 1.2;
      c.beginPath(); c.moveTo(b1[0], b1[1] - 7); c.lineTo(b2[0], b2[1] - 7); c.stroke();
      for (let x = -24; x < 52; x++) {
        for (const fx of [0, 0.5]) {
          const [px, py] = this.iso(x + fx, yF);
          if (px < -10 || px > this.LW + 10) continue;
          c.lineWidth = fx === 0 ? 2 : 1.1;
          c.beginPath(); c.moveTo(px, py); c.lineTo(px, py - (fx === 0 ? 17 : 14)); c.stroke();
          if (fx === 0) { c.fillStyle = '#14100c'; c.beginPath(); c.arc(px, py - 18.5, 1.7, 0, 7); c.fill(); }
        }
      }
    }
    // --- interior floors ---
    for (let y = 0; y < this.H; y++) for (let x = 0; x < this.W; x++) {
      const ch = this.tiles[y][x]; if (ch === '#' || ch === 'g' || ch === 'c') continue;
      const [sx, sy] = this.iso(x, y);
      const v = this.shade[y][x];
      if (ch === '.') {
        for (let i = 0; i < 2; i++) for (let j = 0; j < 2; j++)
          quadUV(sx, sy, i / 2 + 0.012, j / 2 + 0.012, (i + 1) / 2 - 0.012, (j + 1) / 2 - 0.012, this.tint('#87826f', v * 8 + (this.fhash(x * 2 + i, y * 2 + j, 3) - 0.5) * 16));
        c.strokeStyle = 'rgba(38,32,24,0.30)'; c.lineWidth = 1;
        dia(sx, sy, 0); c.stroke();
        if (this.fhash(x, y, 2) > 0.82) {
          c.fillStyle = 'rgba(20,14,8,0.10)';
          c.beginPath(); c.ellipse(sx + (this.fhash(x, y, 3) - 0.5) * 14, sy + (this.fhash(x, y, 4) - 0.5) * 7, 8, 4, 0, 0, 7); c.fill();
        }
      } else {
        const base = ch === 'o' ? '#96693c' : ch === 'b' ? '#84592f' : '#97815a';
        const A = (k) => [sx - T2 + k * T2, sy - k * H2];
        const B = (k) => [sx + k * T2, sy + H2 - k * H2];
        for (let i = 0; i < 3; i++) {
          const k0 = i / 3, k1 = (i + 1) / 3;
          const p1 = A(k0), p2 = A(k1), p3 = B(k1), p4 = B(k0);
          c.fillStyle = this.tint(base, v * 8 + (this.fhash(x * 3 + i, y, 7) - 0.5) * 22);
          c.beginPath(); c.moveTo(p1[0], p1[1]); c.lineTo(p2[0], p2[1]); c.lineTo(p3[0], p3[1]); c.lineTo(p4[0], p4[1]); c.closePath(); c.fill();
        }
        c.strokeStyle = 'rgba(48,28,10,0.35)'; c.lineWidth = 1;
        for (const k of [1 / 3, 2 / 3]) { const p1 = A(k), p2 = B(k); c.beginPath(); c.moveTo(p1[0], p1[1]); c.lineTo(p2[0], p2[1]); c.stroke(); }
        for (let i = 0; i < 3; i++) if (this.fhash(x, y, i + 20) > 0.55) {
          const km = (i + 0.5) / 3, tj = 0.25 + this.fhash(x, y, i + 24) * 0.5;
          const p1 = A(km), p3 = B(km);
          const jx = p1[0] + (p3[0] - p1[0]) * tj, jy = p1[1] + (p3[1] - p1[1]) * tj;
          c.strokeStyle = 'rgba(48,28,10,0.28)';
          c.beginPath(); c.moveTo(jx - 3, jy - 1.6); c.lineTo(jx + 3, jy + 1.6); c.stroke();
        }
      }
    }
    for (const [rx, ry] of this.RUGS) {
      const [sx, sy] = this.iso(rx, ry);
      c.fillStyle = '#83382d'; dia(sx, sy, 3); c.fill();
      c.strokeStyle = '#caa65a'; c.lineWidth = 1.4; dia(sx, sy, 3); c.stroke();
      c.strokeStyle = 'rgba(202,166,90,0.55)'; c.lineWidth = 1; dia(sx, sy, 8); c.stroke();
      c.fillStyle = 'rgba(202,166,90,0.8)';
      c.beginPath(); c.moveTo(sx, sy - 3); c.lineTo(sx + 5, sy); c.lineTo(sx, sy + 3); c.lineTo(sx - 5, sy); c.closePath(); c.fill();
    }
    // painted room labels
    const zlabel = (x, y, txt) => {
      const [lx, lyv] = this.iso(x, y);
      c.save(); c.translate(lx, lyv);
      c.transform(1, 0.5, -1, 0.5, 0, 0);
      c.scale(0.8, 0.8);
      c.font = "10px 'IM Fell English SC', serif";
      c.fillStyle = 'rgba(30,20,8,0.42)';
      const w = c.measureText(txt).width;
      c.fillText(txt, -w / 2, 0);
      c.restore();
    };
    zlabel(4.2, 6, 'OKF Archive');
    zlabel(4.6, 10.8, 'Records');
    zlabel(5, 17, 'Mail Room');
    zlabel(11.7, 6.8, 'Dispatch');
    zlabel(15, 9.7, 'Workshop');
    zlabel(14.6, 14.6, 'Ticket Steamworks');
    zlabel(11.7, 16.4, 'Atelier');
    zlabel(20.2, 17, 'Common Room');
    zlabel(27.8, 5.8, 'CFO Office');
    zlabel(27.4, 11.4, 'EA Office');
    zlabel(27.8, 17, 'Senior Dev');
    zlabel(18.8, 13.8, 'Design Lead');
    zlabel(22.5, 13.8, 'Planning');
  }

  prism(ctx, cx, cy, hw, hh, h, top, left, right) {
    ctx.fillStyle = left; ctx.beginPath();
    ctx.moveTo(cx - hw, cy - h); ctx.lineTo(cx, cy + hh - h); ctx.lineTo(cx, cy + hh); ctx.lineTo(cx - hw, cy); ctx.closePath(); ctx.fill();
    ctx.fillStyle = right; ctx.beginPath();
    ctx.moveTo(cx + hw, cy - h); ctx.lineTo(cx, cy + hh - h); ctx.lineTo(cx, cy + hh); ctx.lineTo(cx + hw, cy); ctx.closePath(); ctx.fill();
    ctx.fillStyle = top; ctx.beginPath();
    ctx.moveTo(cx, cy - hh - h); ctx.lineTo(cx + hw, cy - h); ctx.lineTo(cx, cy + hh - h); ctx.lineTo(cx - hw, cy - h); ctx.closePath(); ctx.fill();
  }

  facePt(cx, cy, side, u, v) {
    const T2 = this.TW / 2, H2 = this.TH / 2;
    if (side === 'L') return [cx - T2 + u * T2, cy + u * H2 - v];
    return [cx + u * T2, cy + H2 - u * H2 - v];
  }
  faceQuad(ctx, cx, cy, side, u0, u1, v0, v1, fill) {
    const p1 = this.facePt(cx, cy, side, u0, v0), p2 = this.facePt(cx, cy, side, u1, v0),
      p3 = this.facePt(cx, cy, side, u1, v1), p4 = this.facePt(cx, cy, side, u0, v1);
    ctx.fillStyle = fill; ctx.beginPath();
    ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.lineTo(p3[0], p3[1]); ctx.lineTo(p4[0], p4[1]); ctx.closePath(); ctx.fill();
  }

  drawWall(ctx, x, y) {
    const [sx, sy] = this.iso(x, y);
    const T2 = this.TW / 2, H2 = this.TH / 2;
    const tall = (y === 1 || x === 1);
    const front = (y === 18 || x === 24) && !tall;
    const h = tall ? 74 : front ? 26 : 38;
    const wh = (n) => this.fhash(x, y, n);
    if (front) {
      this.prism(ctx, sx, sy, T2, H2, h, '#7c422e', '#8a4a36', '#a05a42');
      for (const side of ['L', 'R']) {
        for (let i = 0; i < 3; i++) {
          const r2 = Math.floor(wh(i + (side === 'L' ? 0 : 7)) * ((h - 10) / 6));
          const u = Math.floor(wh(i + 3 + (side === 'L' ? 0 : 7)) * 4) * 0.25;
          this.faceQuad(ctx, sx, sy, side, u, u + 0.25, 6 + r2 * 6, 11 + r2 * 6, this.tint(side === 'L' ? '#8a4a36' : '#a05a42', (wh(i + 11) - 0.5) * 34));
        }
        this.faceQuad(ctx, sx, sy, side, 0, 1, 0, 5, side === 'L' ? '#767065' : '#847d71');
        ctx.strokeStyle = 'rgba(226,206,178,0.16)'; ctx.lineWidth = 1;
        for (let vv = 6; vv < h - 2; vv += 6) {
          const p1 = this.facePt(sx, sy, side, 0, vv), p2 = this.facePt(sx, sy, side, 1, vv);
          ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.stroke();
        }
        for (let r2 = 0; r2 < 3; r2++) {
          for (const u of ((r2 % 2) ? [0.25, 0.75] : [0.5])) {
            const p1 = this.facePt(sx, sy, side, u, 6 + r2 * 6), p2 = this.facePt(sx, sy, side, u, 11 + r2 * 6);
            ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.stroke();
          }
        }
      }
      this.prism(ctx, sx, sy - h, T2 + 1.5, H2, 3.5, '#bdb3a0', '#9c9484', '#aaa191');
    } else if (tall) {
      const office = (x === 1) || (y === 1 && x <= 9);
      if (office) {
        this.prism(ctx, sx, sy, T2, H2, h, '#6b4534', '#cdbd9a', '#dccca6');
        for (const side of ['L', 'R']) {
          const dk = side === 'L' ? -10 : 0;
          this.faceQuad(ctx, sx, sy, side, 0, 1, 0, 20, this.tint('#57663f', dk));
          ctx.strokeStyle = 'rgba(24,30,16,0.55)'; ctx.lineWidth = 1;
          let p1 = this.facePt(sx, sy, side, 0, 20.5), p2 = this.facePt(sx, sy, side, 1, 20.5);
          ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.stroke();
          ctx.strokeStyle = 'rgba(24,30,16,0.35)';
          p1 = this.facePt(sx, sy, side, 0.18, 4); p2 = this.facePt(sx, sy, side, 0.82, 4);
          const p3 = this.facePt(sx, sy, side, 0.82, 16), p4 = this.facePt(sx, sy, side, 0.18, 16);
          ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.lineTo(p3[0], p3[1]); ctx.lineTo(p4[0], p4[1]); ctx.closePath(); ctx.stroke();
          ctx.strokeStyle = 'rgba(90,70,40,0.4)';
          p1 = this.facePt(sx, sy, side, 0, h - 12); p2 = this.facePt(sx, sy, side, 1, h - 12);
          ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.stroke();
        }
      } else {
        this.prism(ctx, sx, sy, T2, H2, h, '#6b4534', '#c0b494', '#cfc2a0');
        for (const side of ['L', 'R']) {
          this.faceQuad(ctx, sx, sy, side, 0, 1, 0, 11, side === 'L' ? '#6e4434' : '#7c4c3a');
          ctx.strokeStyle = 'rgba(226,206,178,0.14)'; ctx.lineWidth = 1;
          const p1 = this.facePt(sx, sy, side, 0, 5.5), p2 = this.facePt(sx, sy, side, 1, 5.5);
          ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.stroke();
          ctx.strokeStyle = 'rgba(70,58,42,0.18)';
          for (let vv = 18; vv < h - 6; vv += 12) {
            const q1 = this.facePt(sx, sy, side, 0, vv), q2 = this.facePt(sx, sy, side, 1, vv);
            ctx.beginPath(); ctx.moveTo(q1[0], q1[1]); ctx.lineTo(q2[0], q2[1]); ctx.stroke();
          }
        }
      }
    } else if (x === 9 || y === 7) {
      this.prism(ctx, sx, sy, T2, H2, h, '#4f5b3c', '#67754e', '#77865b');
      for (const side of ['L', 'R']) {
        const dk2 = side === 'L' ? -8 : 2;
        this.faceQuad(ctx, sx, sy, side, 0, 1, 0, 14, this.tint('#57653f', dk2));
        ctx.strokeStyle = 'rgba(26,32,18,0.5)'; ctx.lineWidth = 1;
        let p1 = this.facePt(sx, sy, side, 0, 14.5), p2 = this.facePt(sx, sy, side, 1, 14.5);
        ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.stroke();
        ctx.strokeStyle = 'rgba(26,32,18,0.3)';
        p1 = this.facePt(sx, sy, side, 0.2, h - 16); p2 = this.facePt(sx, sy, side, 0.8, h - 16);
        const p3 = this.facePt(sx, sy, side, 0.8, h - 6), p4 = this.facePt(sx, sy, side, 0.2, h - 6);
        ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.lineTo(p3[0], p3[1]); ctx.lineTo(p4[0], p4[1]); ctx.closePath(); ctx.stroke();
      }
    } else {
      this.prism(ctx, sx, sy, T2, H2, h, '#9c8c6c', '#c2b28e', '#d3c3a0');
      for (const side of ['L', 'R']) {
        this.faceQuad(ctx, sx, sy, side, 0, 1, 0, 12, side === 'L' ? '#6d5334' : '#7d6040');
        ctx.strokeStyle = 'rgba(50,36,18,0.45)'; ctx.lineWidth = 1;
        const p1 = this.facePt(sx, sy, side, 0, 12.5), p2 = this.facePt(sx, sy, side, 1, 12.5);
        ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.stroke();
      }
    }
    if (y === 1 && [4, 7, 12, 15, 18, 21, 27].includes(x)) this.drawWindow(ctx, sx, sy, 'L', h);
    if (x === 1 && [3, 6, 10, 13, 16].includes(y)) this.drawWindow(ctx, sx, sy, 'R', h);
    if (y === 1 && x === 5) this.drawPortrait(ctx, sx, sy, 'L', h);
    if (y === 1 && x === 16) this.drawClock(ctx, sx, sy, 'L', h);
  }

  drawWindow(ctx, cx, cy, side, h) {
    const u0 = 0.14, u1 = 0.86;
    const vb = h * 0.20, vt = h * 0.74, arch = 8;
    const P = (u, v) => this.facePt(cx, cy, side, u, v);
    // stone surround
    ctx.fillStyle = side === 'L' ? '#b5a687' : '#c2b391';
    ctx.beginPath();
    let p = P(u0 - 0.07, vb - 3); ctx.moveTo(p[0], p[1]);
    p = P(u1 + 0.07, vb - 3); ctx.lineTo(p[0], p[1]);
    p = P(u1 + 0.07, vt); ctx.lineTo(p[0], p[1]);
    for (let k = 0; k <= 8; k++) { const u = u1 + 0.07 - (u1 - u0 + 0.14) * k / 8; p = P(u, vt + Math.sin(k / 8 * Math.PI) * (arch + 4)); ctx.lineTo(p[0], p[1]); }
    ctx.closePath(); ctx.fill();
    // painted frame
    ctx.fillStyle = '#e6dabc';
    ctx.beginPath();
    p = P(u0 - 0.02, vb - 1); ctx.moveTo(p[0], p[1]);
    p = P(u1 + 0.02, vb - 1); ctx.lineTo(p[0], p[1]);
    p = P(u1 + 0.02, vt); ctx.lineTo(p[0], p[1]);
    for (let k = 0; k <= 8; k++) { const u = u1 + 0.02 - (u1 - u0 + 0.04) * k / 8; p = P(u, vt + Math.sin(k / 8 * Math.PI) * (arch + 1.5)); ctx.lineTo(p[0], p[1]); }
    ctx.closePath(); ctx.fill();
    // glass
    ctx.fillStyle = side === 'L' ? '#8fa8b0' : '#9db6be';
    ctx.beginPath();
    p = P(u0 + 0.03, vb + 1); ctx.moveTo(p[0], p[1]);
    p = P(u1 - 0.03, vb + 1); ctx.lineTo(p[0], p[1]);
    p = P(u1 - 0.03, vt); ctx.lineTo(p[0], p[1]);
    for (let k = 0; k <= 8; k++) { const u = u1 - 0.03 - (u1 - u0 - 0.06) * k / 8; p = P(u, vt + Math.sin(k / 8 * Math.PI) * (arch - 1)); ctx.lineTo(p[0], p[1]); }
    ctx.closePath(); ctx.fill();
    // sheen
    ctx.fillStyle = 'rgba(240,246,244,0.30)';
    ctx.beginPath();
    p = P(u0 + 0.07, vb + 2); ctx.moveTo(p[0], p[1]);
    p = P(u0 + 0.22, vb + 2); ctx.lineTo(p[0], p[1]);
    p = P(u0 + 0.42, vt + 4); ctx.lineTo(p[0], p[1]);
    p = P(u0 + 0.27, vt + 4); ctx.lineTo(p[0], p[1]);
    ctx.closePath(); ctx.fill();
    // glazing bars
    ctx.strokeStyle = '#e6dabc'; ctx.lineWidth = 1.5;
    const mid = (u0 + u1) / 2;
    p = P(mid, vb + 1); let p2 = P(mid, vt + arch - 1);
    ctx.beginPath(); ctx.moveTo(p[0], p[1]); ctx.lineTo(p2[0], p2[1]); ctx.stroke();
    const vm = vb + (vt - vb) * 0.55;
    p = P(u0 + 0.03, vm); p2 = P(u1 - 0.03, vm);
    ctx.beginPath(); ctx.moveTo(p[0], p[1]); ctx.lineTo(p2[0], p2[1]); ctx.stroke();
    ctx.lineWidth = 1;
    for (const uq of [(u0 + mid) / 2, (mid + u1) / 2]) {
      p = P(uq, vb + 1); p2 = P(uq, vt + arch * 0.6);
      ctx.beginPath(); ctx.moveTo(p[0], p[1]); ctx.lineTo(p2[0], p2[1]); ctx.stroke();
    }
    // sill
    ctx.fillStyle = '#c9ba9a';
    const s1 = P(u0 - 0.11, vb - 2), s2 = P(u1 + 0.11, vb - 2), s3 = P(u1 + 0.11, vb - 5.5), s4 = P(u0 - 0.11, vb - 5.5);
    ctx.beginPath(); ctx.moveTo(s1[0], s1[1]); ctx.lineTo(s2[0], s2[1]); ctx.lineTo(s3[0], s3[1]); ctx.lineTo(s4[0], s4[1]); ctx.closePath(); ctx.fill();
  }

  drawPortrait(ctx, cx, cy, side, h) {
    this.faceQuad(ctx, cx, cy, side, 0.3, 0.7, h * 0.42, h * 0.68, '#a8863c');
    this.faceQuad(ctx, cx, cy, side, 0.34, 0.66, h * 0.44, h * 0.66, '#31261c');
    this.faceQuad(ctx, cx, cy, side, 0.4, 0.6, h * 0.46, h * 0.52, '#26221e');
    this.faceQuad(ctx, cx, cy, side, 0.44, 0.56, h * 0.5, h * 0.6, '#c69066');
  }

  drawClock(ctx, cx, cy, side, h) {
    const p = this.facePt(cx, cy, side, 0.5, h * 0.6);
    ctx.fillStyle = '#4a3826'; ctx.beginPath(); ctx.ellipse(p[0], p[1], 6.5, 7.5, 0, 0, 7); ctx.fill();
    ctx.fillStyle = '#e8dcc0'; ctx.beginPath(); ctx.ellipse(p[0], p[1], 5, 6, 0, 0, 7); ctx.fill();
    ctx.strokeStyle = '#26221e'; ctx.lineWidth = 1;
    const ang = this.simT * 0.05 - 1.2;
    ctx.beginPath(); ctx.moveTo(p[0], p[1]); ctx.lineTo(p[0] + Math.cos(ang) * 3.4, p[1] + Math.sin(ang) * 4); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(p[0], p[1]); ctx.lineTo(p[0] + Math.cos(ang * 12) * 2.2, p[1] + Math.sin(ang * 12) * 2.8); ctx.stroke();
  }

  drawFurniture(ctx, f) {
    const tiles = [...f.tiles].sort((a, b) => (a[0] + a[1]) - (b[0] + b[1]));
    const T2 = this.TW / 2, H2 = this.TH / 2;
    const t = f.type;
    const each = (fn) => { for (const [x, y] of tiles) { const [sx, sy] = this.iso(x, y); fn(sx, sy, x, y); } };
    if (t === 'shelf') {
      each((sx, sy) => { this.prism(ctx, sx, sy, T2 - 4, H2 - 2, 44, '#4a3520', '#5a3f24', '#6d4d2c'); });
      each((sx, sy) => { const cols = ['#7a3b33', '#4e5a44', '#8a6a35', '#3d4a5c', '#6b4a2a']; for (let i = 0; i < 5; i++) this.faceQuad(ctx, sx, sy, 'L', 0.12 + i * 0.16, 0.24 + i * 0.16, 10, 36 - (i % 2) * 3, cols[i]); });
    }
    if (t === 'board') {
      each((sx, sy) => this.prism(ctx, sx, sy, T2 - 6, 4, 42, '#3d2f1c', '#4a3a22', '#584428'));
      each((sx, sy, x) => {
        const cards = ['#e8e0cc', '#d9c9a8', '#cfa64a', '#e8e0cc'];
        for (let i = 0; i < 4; i++) this.faceQuad(ctx, sx, sy, 'L', 0.14 + (i % 2) * 0.42, 0.4 + (i % 2) * 0.42, 14 + Math.floor(i / 2) * 13, 24 + Math.floor(i / 2) * 13, cards[(i + x) % 4]);
      });
    }
    if (t === 'easel') each((sx, sy) => {
      ctx.strokeStyle = '#5a3f24'; ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(sx - 6, sy + 3); ctx.lineTo(sx, sy - 27); ctx.lineTo(sx + 6, sy + 3);
      ctx.moveTo(sx, sy - 12); ctx.lineTo(sx + 2.5, sy + 5);
      ctx.stroke();
      ctx.save(); ctx.translate(sx, sy - 19); ctx.transform(1, 0.2, 0, 1, 0, 0);
      ctx.fillStyle = '#ece5d2'; ctx.fillRect(-8.5, -8, 17, 13.5);
      ctx.strokeStyle = '#8a6a35'; ctx.lineWidth = 1.2; ctx.strokeRect(-8.5, -8, 17, 13.5);
      ctx.fillStyle = 'rgba(122,68,96,0.65)'; ctx.fillRect(-5.5, -5, 6.5, 3);
      ctx.fillStyle = 'rgba(163,69,58,0.6)'; ctx.fillRect(-2, -0.5, 7.5, 2.4);
      ctx.fillStyle = 'rgba(64,96,122,0.55)'; ctx.fillRect(-6.5, 0.5, 4, 2);
      ctx.restore();
      ctx.fillStyle = '#8f6c3e'; ctx.fillRect(sx - 7, sy - 6, 14, 2);
      ctx.fillStyle = '#7a4460'; ctx.fillRect(sx - 5, sy - 8, 2.4, 2);
      ctx.fillStyle = '#40607a'; ctx.fillRect(sx - 1, sy - 8, 2.4, 2);
      ctx.fillStyle = '#a3453a'; ctx.fillRect(sx + 3, sy - 8, 2.4, 2);
    });
    if (t === 'pigeon') each((sx, sy) => {
      this.prism(ctx, sx, sy, T2 - 9, H2 - 5, 36, '#4a3520', '#5a3f24', '#6d4d2c');
      for (let r = 0; r < 3; r++) for (let i = 0; i < 3; i++)
        this.faceQuad(ctx, sx, sy, 'R', 0.14 + i * 0.26, 0.32 + i * 0.26, 9 + r * 8.5, 14.5 + r * 8.5, ((r + i) % 2) ? '#2a2018' : '#e8e0cc');
    });
    if (t === 'bigdesk' || t === 'deskT' || t === 'deskL' || t === 'reception' || t === 'draft' || t === 'lectern') {
      const h = t === 'reception' ? 24 : 20;
      each((sx, sy) => this.prism(ctx, sx, sy, T2 - 5, H2 - 3, h, '#9a7443', '#6b4a26', '#7d5830'));
      const [ax, ay] = this.iso(tiles[0][0], tiles[0][1]);
      ctx.fillStyle = '#e8e0cc';
      ctx.beginPath(); ctx.moveTo(ax, ay - h - 7); ctx.lineTo(ax + 9, ay - h - 2); ctx.lineTo(ax, ay - h + 3); ctx.lineTo(ax - 9, ay - h - 2); ctx.closePath(); ctx.fill();
      ctx.strokeStyle = 'rgba(90,70,40,0.5)'; ctx.lineWidth = 0.8;
      ctx.beginPath(); ctx.moveTo(ax - 4, ay - h - 3.5); ctx.lineTo(ax + 3, ay - h - 1.5); ctx.moveTo(ax - 4, ay - h - 1.8); ctx.lineTo(ax + 2, ay - h - 0.2); ctx.stroke();
      if (t === 'bigdesk' || t === 'deskL' || t === 'deskT') {
        const lx = ax - 11, lyv = ay - h - 1;
        ctx.strokeStyle = '#7f6a30'; ctx.lineWidth = 1.4;
        ctx.beginPath(); ctx.moveTo(lx, lyv); ctx.lineTo(lx, lyv - 7); ctx.stroke();
        ctx.fillStyle = '#3f6e4f';
        ctx.beginPath(); ctx.moveTo(lx - 5, lyv - 7); ctx.lineTo(lx + 5, lyv - 7); ctx.lineTo(lx + 3.4, lyv - 10.5); ctx.lineTo(lx - 3.4, lyv - 10.5); ctx.closePath(); ctx.fill();
        ctx.fillStyle = 'rgba(255,214,130,0.85)'; ctx.beginPath(); ctx.arc(lx, lyv - 5.8, 1.6, 0, 7); ctx.fill();
        ctx.fillStyle = '#1e1b17'; ctx.beginPath(); ctx.arc(ax + 8, ay - h - 3.4, 1.6, 0, 7); ctx.fill();
      }
      if (t === 'deskT') {
        ctx.fillStyle = '#211d18'; ctx.fillRect(ax - 5, ay - h - 10, 10, 6.5);
        ctx.fillStyle = '#3a352d'; ctx.fillRect(ax - 6.5, ay - h - 12, 13, 2.2);
        ctx.fillStyle = '#e8e0cc'; ctx.fillRect(ax - 2.6, ay - h - 16.5, 5.2, 5);
        ctx.fillStyle = '#8d8578';
        for (let i = 0; i < 6; i++) ctx.fillRect(ax - 4 + (i % 3) * 3, ay - h - 8.4 + Math.floor(i / 3) * 2.2, 1.3, 1.3);
      }
      if (t === 'draft') {
        ctx.fillStyle = '#8f6c3e';
        ctx.beginPath(); ctx.moveTo(ax - 13, ay - h + 1); ctx.lineTo(ax + 2, ay - h - 11); ctx.lineTo(ax + 13, ay - h - 5); ctx.lineTo(ax - 2, ay - h + 7); ctx.closePath(); ctx.fill();
        ctx.fillStyle = '#dfe6e2';
        ctx.beginPath(); ctx.moveTo(ax - 9.5, ay - h + 0.5); ctx.lineTo(ax + 1.5, ay - h - 8.5); ctx.lineTo(ax + 9.5, ay - h - 4); ctx.lineTo(ax - 1.5, ay - h + 5); ctx.closePath(); ctx.fill();
        ctx.strokeStyle = 'rgba(70,105,140,0.7)'; ctx.lineWidth = 0.8;
        ctx.beginPath(); ctx.moveTo(ax - 6, ay - h + 0.5); ctx.lineTo(ax + 4, ay - h - 7.5); ctx.moveTo(ax - 3, ay - h + 2.5); ctx.lineTo(ax + 6.5, ay - h - 5); ctx.stroke();
      }
      if (t === 'reception') { ctx.fillStyle = '#8a6a35'; ctx.fillRect(ax + 8, ay - h - 6, 12, 4); ctx.fillStyle = '#e8e0cc'; ctx.fillRect(ax + 9.5, ay - h - 9, 9, 3); ctx.fillStyle = '#b08d3f'; ctx.beginPath(); ctx.arc(ax - 8, ay - h - 3, 2, 0, 7); ctx.fill(); }
      if (t === 'lectern') {
        const [bx2, by2] = this.iso(tiles[tiles.length - 1][0], tiles[tiles.length - 1][1]);
        ctx.fillStyle = '#6d4326'; ctx.fillRect(bx2 - 7, by2 - h - 8, 11, 3); ctx.fillRect(bx2 - 6, by2 - h - 11, 10, 2.6);
        ctx.fillStyle = '#7a3b33'; ctx.fillRect(bx2 - 5, by2 - h - 13.5, 8.5, 2.2);
        ctx.fillStyle = '#e8e0cc';
        ctx.beginPath(); ctx.moveTo(ax + 2, ay - h - 8); ctx.lineTo(ax + 11, ay - h - 3); ctx.lineTo(ax + 2, ay - h + 2); ctx.lineTo(ax - 7, ay - h - 3); ctx.closePath(); ctx.fill();
        ctx.strokeStyle = 'rgba(90,70,40,0.6)'; ctx.lineWidth = 0.8;
        ctx.beginPath(); ctx.moveTo(ax + 2, ay - h - 8); ctx.lineTo(ax + 2, ay - h + 2); ctx.stroke();
      }
    }
    if (t === 'cabinet') each((sx, sy) => {
      this.prism(ctx, sx, sy, T2 - 8, H2 - 4, 32, '#5a3f24', '#6b4a2a', '#7d5830');
      ctx.strokeStyle = 'rgba(40,28,14,0.5)'; ctx.lineWidth = 1;
      for (let i = 1; i <= 2; i++) { const p1 = this.facePt(sx, sy, 'R', 0.1, i * 10), p2 = this.facePt(sx, sy, 'R', 0.9, i * 10); ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.stroke(); }
    });
    if (t === 'plant') each((sx, sy) => {
      this.prism(ctx, sx, sy, 8, 4, 8, '#7a4a30', '#5c3822', '#6b4026');
      ctx.fillStyle = '#4e5f3d';
      for (let i = 0; i < 4; i++) { ctx.beginPath(); ctx.arc(sx + Math.sin(i * 2.4) * 6, sy - 16 - Math.cos(i * 1.7) * 5, 6, 0, 7); ctx.fill(); }
    });
    if (t === 'press') {
      each((sx, sy) => this.prism(ctx, sx, sy, T2 - 2, H2 - 1, 34, '#39463a', '#42533f', '#4e614a'));
      const [cx, cy] = this.iso(13.5, 2.5);
      ctx.strokeStyle = 'rgba(168,134,60,0.75)'; ctx.lineWidth = 1.2;
      ctx.beginPath(); ctx.moveTo(cx - 20, cy - 27); ctx.lineTo(cx + 24, cy - 19); ctx.stroke();
      this.prism(ctx, cx + 9, cy - 34, 6.5, 3.2, 30, '#2e3a2e', '#3a4838', '#455543');
      this.prism(ctx, cx + 9, cy - 62, 13, 5.5, 10, '#2a352a', '#354233', '#3f4e3d');
      const ramK = Math.pow((Math.sin(this.simT * 2.4) + 1) / 2, 1.7);
      this.prism(ctx, cx + 9, cy - 50 + ramK * 13, 4.5, 2.2, 11, '#5a6354', '#3c4539', '#48524a');
      const gl = 0.6 + 0.4 * Math.sin(this.simT * 9);
      ctx.fillStyle = 'rgba(255,' + Math.round(120 + 60 * gl) + ',40,0.95)';
      ctx.fillRect(cx + 5, cy - 37, 8, 3);
      if (ramK > 0.93 && (this._pk || 0) <= 0.93) this.spawnSparks(cx + 9, cy - 36, 7);
      this._pk = ramK;
      const [wx, wy] = this.pressWheelPos();
      const ang = this.simT * 2.4;
      ctx.strokeStyle = '#1d231b'; ctx.lineWidth = 4; ctx.beginPath(); ctx.arc(wx, wy, 15, 0, 7); ctx.stroke();
      ctx.strokeStyle = '#57654f'; ctx.lineWidth = 2;
      for (let i = 0; i < 5; i++) { const aa = ang + i * Math.PI * 2 / 5; ctx.beginPath(); ctx.moveTo(wx, wy); ctx.lineTo(wx + Math.cos(aa) * 13, wy + Math.sin(aa) * 13); ctx.stroke(); }
      ctx.fillStyle = '#b08d3f'; ctx.beginPath(); ctx.arc(wx, wy, 3.2, 0, 7); ctx.fill();
      const [tx2, ty2] = this.iso(14, 2);
      this.prism(ctx, tx2 + 6, ty2 - 66, 5, 2.5, 24, '#1f1c18', '#2a2622', '#332e28');
    }
    if (t === 'lathe') {
      each((sx, sy) => this.prism(ctx, sx, sy, T2 - 4, H2 - 3, 20, '#3c423c', '#474e47', '#545c54'));
      const [ax, ay] = this.iso(19.5, 2);
      this.prism(ctx, ax + 14, ay - 20, 6, 3, 9, '#31372f', '#3c433a', '#474f45');
      const [lwx, lwy] = this.latheWheelPos();
      const ang = this.simT * 7;
      ctx.strokeStyle = '#23261f'; ctx.lineWidth = 3; ctx.beginPath(); ctx.arc(lwx, lwy, 8, 0, 7); ctx.stroke();
      ctx.strokeStyle = '#6a7366'; ctx.lineWidth = 1.6;
      for (let i = 0; i < 3; i++) { const aa = ang + i * Math.PI * 2 / 3; ctx.beginPath(); ctx.moveTo(lwx, lwy); ctx.lineTo(lwx + Math.cos(aa) * 6.6, lwy + Math.sin(aa) * 6.6); ctx.stroke(); }
      ctx.strokeStyle = '#8d938a'; ctx.lineWidth = 3;
      ctx.beginPath(); ctx.moveTo(ax - 16, ay - 26); ctx.lineTo(ax + 10, ay - 22); ctx.stroke();
      ctx.strokeStyle = 'rgba(240,244,238,' + (0.25 + 0.22 * Math.sin(this.simT * 16)) + ')'; ctx.lineWidth = 1.2;
      ctx.beginPath(); ctx.moveTo(ax - 15, ay - 27); ctx.lineTo(ax + 9, ay - 23); ctx.stroke();
    }
    if (t === 'bench') {
      each((sx, sy) => this.prism(ctx, sx, sy, T2 - 4, H2 - 3, 19, '#8f6c3e', '#6b4a26', '#7d5830'));
      const [ax, ay] = this.iso(tiles[0][0], tiles[0][1]);
      ctx.fillStyle = '#777d75'; ctx.fillRect(ax - 6, ay - 24, 5, 3); ctx.fillRect(ax + 3, ay - 26, 6, 4);
    }
    if (t === 'engine') {
      each((sx, sy) => this.prism(ctx, sx, sy, T2 - 3, H2 - 2, 24, '#2e2a26', '#3a352f', '#453f38'));
      const [ax, ay] = this.iso(14.5, 12);
      this.prism(ctx, ax + 10, ay - 24, 8, 4, 9, '#3a332c', '#453d34', '#514840');
      const ang = this.simT * 3.1;
      const fwx = ax - 18, fwy = ay - 20;
      ctx.strokeStyle = '#1f1c18'; ctx.lineWidth = 3.5; ctx.beginPath(); ctx.arc(fwx, fwy, 12, 0, 7); ctx.stroke();
      ctx.strokeStyle = '#4a423a'; ctx.lineWidth = 1.8;
      for (let i = 0; i < 4; i++) { const aa = ang + i * Math.PI / 2; ctx.beginPath(); ctx.moveTo(fwx, fwy); ctx.lineTo(fwx + Math.cos(aa) * 10.5, fwy + Math.sin(aa) * 10.5); ctx.stroke(); }
      const px2 = fwx + Math.cos(ang) * 8, py2 = fwy + Math.sin(ang) * 4.5;
      ctx.strokeStyle = '#8d8578'; ctx.lineWidth = 2.2;
      ctx.beginPath(); ctx.moveTo(px2, py2); ctx.lineTo(ax + 4, ay - 27); ctx.stroke();
      ctx.fillStyle = '#b08d3f'; ctx.beginPath(); ctx.arc(px2, py2, 1.9, 0, 7); ctx.fill();
      ctx.fillStyle = '#b08d3f'; ctx.beginPath(); ctx.arc(ax + 9, ay - 35, 2.4, 0, 7); ctx.fill();
      ctx.fillStyle = '#d9d0bd'; ctx.beginPath(); ctx.arc(ax + 9, ay - 35, 1.1, 0, 7); ctx.fill();
    }
    if (t === 'crates') {
      each((sx, sy) => {
        this.prism(ctx, sx, sy, T2 - 6, H2 - 3, 24, '#b08d54', '#82653a', '#977647');
        for (const side of ['L', 'R']) {
          ctx.strokeStyle = 'rgba(56,38,16,0.45)'; ctx.lineWidth = 1;
          for (const vv of [8, 16]) {
            const p1 = this.facePt(sx, sy, side, 0.3, vv), p2 = this.facePt(sx, sy, side, 0.9, vv);
            ctx.beginPath(); ctx.moveTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]); ctx.stroke();
          }
          ctx.lineWidth = 1.5;
          const d1 = this.facePt(sx, sy, side, 0.32, 3), d2 = this.facePt(sx, sy, side, 0.88, 21);
          ctx.beginPath(); ctx.moveTo(d1[0], d1[1]); ctx.lineTo(d2[0], d2[1]); ctx.stroke();
        }
      });
      const [ax, ay] = this.iso(22, 3);
      this.prism(ctx, ax, ay - 24, 12, 6, 14, '#bb9a61', '#8a6c3e', '#9d7d4a');
    }
    if (t === 'pillar') each((sx, sy) => this.prism(ctx, sx, sy, 7, 3.5, 68, '#2a2622', '#38332d', '#423c35'));
    if (t === 'stove') {
      each((sx, sy) => {
        this.prism(ctx, sx, sy, 11, 5.5, 26, '#26221e', '#332e28', '#3d3730');
        this.prism(ctx, sx + 2, sy - 26, 3.5, 1.8, 22, '#1c1916', '#26221e', '#2e2924');
        ctx.fillStyle = '#c96f38'; ctx.fillRect(sx - 4, sy - 10, 4, 3);
      });
    }
    if (t === 'rack') each((sx, sy) => {
      ctx.strokeStyle = '#4a3826'; ctx.lineWidth = 3;
      ctx.beginPath(); ctx.moveTo(sx, sy); ctx.lineTo(sx, sy - 34); ctx.stroke();
      ctx.fillStyle = '#3d4a5c'; ctx.fillRect(sx - 6, sy - 30, 8, 14);
    });
    if (t === 'table') {
      const [ax, ay] = this.iso(20.5, 15);
      this.prism(ctx, ax, ay, 8, 4, 13, '#6b4a26', '#5a3e20', '#644524');
      ctx.fillStyle = '#8f6c3e'; ctx.beginPath(); ctx.ellipse(ax, ay - 14, 30, 15, 0, 0, 7); ctx.fill();
      ctx.strokeStyle = '#5a3e20'; ctx.lineWidth = 1.5; ctx.stroke();
      ctx.fillStyle = '#d9d0bd'; ctx.beginPath(); ctx.arc(ax - 6, ay - 17, 3.5, 0, 7); ctx.fill();
      ctx.beginPath(); ctx.arc(ax + 8, ay - 15, 2.2, 0, 7); ctx.fill();
    }
  }

  drawPost(ctx, x, y) {
    const [sx, sy] = this.iso(x, y);
    const H = 62;
    ctx.fillStyle = '#14110d';
    ctx.beginPath(); ctx.ellipse(sx, sy + 1, 5.5, 2.8, 0, 0, 7); ctx.fill();
    this.prism(ctx, sx, sy, 3.4, 1.7, 7, '#221e18', '#14110d', '#1b1712');
    ctx.strokeStyle = '#1b1712'; ctx.lineWidth = 3;
    ctx.beginPath(); ctx.moveTo(sx, sy - 6); ctx.lineTo(sx, sy - H + 12); ctx.stroke();
    ctx.lineWidth = 1.2; ctx.strokeStyle = '#2e2820';
    ctx.beginPath(); ctx.moveTo(sx - 1, sy - 8); ctx.lineTo(sx - 1, sy - H + 14); ctx.stroke();
    ctx.strokeStyle = '#1b1712'; ctx.lineWidth = 1.6;
    ctx.beginPath(); ctx.moveTo(sx - 7, sy - H + 10); ctx.lineTo(sx + 7, sy - H + 10); ctx.stroke();
    const ly = sy - H;
    ctx.fillStyle = '#1b1712';
    ctx.beginPath(); ctx.moveTo(sx - 6, ly + 9); ctx.lineTo(sx + 6, ly + 9); ctx.lineTo(sx + 4, ly - 2); ctx.lineTo(sx - 4, ly - 2); ctx.closePath(); ctx.fill();
    const fl = 0.75 + 0.25 * Math.sin(this.simT * 6 + x);
    ctx.fillStyle = 'rgba(255,201,110,' + (0.92 * fl) + ')';
    ctx.beginPath(); ctx.moveTo(sx - 4.6, ly + 7.6); ctx.lineTo(sx + 4.6, ly + 7.6); ctx.lineTo(sx + 3.2, ly - 0.6); ctx.lineTo(sx - 3.2, ly - 0.6); ctx.closePath(); ctx.fill();
    ctx.strokeStyle = '#0f0c09'; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(sx, ly + 8); ctx.lineTo(sx, ly - 1); ctx.stroke();
    ctx.fillStyle = '#1b1712';
    ctx.beginPath(); ctx.moveTo(sx - 6.5, ly - 2); ctx.lineTo(sx + 6.5, ly - 2); ctx.lineTo(sx, ly - 8); ctx.closePath(); ctx.fill();
    ctx.beginPath(); ctx.arc(sx, ly - 9.5, 1.6, 0, 7); ctx.fill();
    ctx.save(); ctx.globalCompositeOperation = 'lighter';
    const g = ctx.createRadialGradient(sx, ly + 4, 2, sx, ly + 4, 44);
    g.addColorStop(0, 'rgba(255,180,90,' + (0.16 + 0.05 * fl) + ')'); g.addColorStop(1, 'rgba(255,180,90,0)');
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(sx, ly + 4, 44, 0, 7); ctx.fill();
    ctx.restore();
  }

  drawBush(ctx, x, y) {
    const [sx, sy] = this.iso(x, y);
    ctx.fillStyle = '#3a4a2c';
    ctx.beginPath(); ctx.arc(sx - 7, sy - 4, 8, 0, 7); ctx.fill();
    ctx.beginPath(); ctx.arc(sx + 6, sy - 6, 9, 0, 7); ctx.fill();
    ctx.beginPath(); ctx.arc(sx, sy - 1, 8, 0, 7); ctx.fill();
    ctx.beginPath(); ctx.arc(sx + 12, sy - 2, 6, 0, 7); ctx.fill();
    ctx.fillStyle = '#465836';
    ctx.beginPath(); ctx.arc(sx - 4, sy - 8, 5.5, 0, 7); ctx.fill();
    ctx.beginPath(); ctx.arc(sx + 5, sy - 9, 5, 0, 7); ctx.fill();
    ctx.fillStyle = '#a3453a';
    for (let i = 0; i < 6; i++) {
      const fx = sx + Math.sin(i * 2.1 + x) * 9, fy = sy - 5 - Math.abs(Math.cos(i * 1.7 + y)) * 6;
      ctx.beginPath(); ctx.arc(fx, fy, 1.7, 0, 7); ctx.fill();
    }
  }

  drawPerson(ctx, a) {
    const [wxp, wyp] = this.iso(a.x, a.y);
    const sx = wxp + a.off, sy = wyp;
    const t = this.simT;
    const anim = this.animOf(a);
    const walk = anim === 'walk';
    const ph = a.walked * 8 + a.bobPh;
    const bob = walk ? Math.abs(Math.cos(ph)) * 1.1 : (a.mode === 'act' ? Math.sin(t * 4 + a.bobPh) * 0.5 : Math.sin(t * 1.6 + a.bobPh) * 0.35);
    const s = a.sit ? 5 : 0;
    const face = a.face || 1;
    const skin = a.skin || '#dba97c';
    const trim = a.trim || '#b08d3f';

    if (a.despawn != null) ctx.globalAlpha = Math.max(0, Math.min(1, a.despawn / 1.2));
    ctx.fillStyle = 'rgba(8,5,2,0.30)';
    ctx.beginPath(); ctx.ellipse(sx, sy + 2, 9.5, 4.2, 0, 0, 7); ctx.fill();
    if (a.sit) this.prism(ctx, sx - face * 2, sy + 2, 6.5, 3.2, 6.5, '#7a5a32', '#5c421f', '#6a4d26');

    ctx.save();
    ctx.translate(sx, sy);
    if (face < 0) ctx.scale(-1, 1);

    const hipY = -10 + s;
    const shY = -19.5 + s + bob;
    const headY = -26.5 + s + bob;
    const lean = (anim === 'write' || anim === 'sort') ? 1.2 : 0;
    const sleeve = a.apron ? '#e9e2d2' : (a.dress ? '#e7dfcd' : a.color);

    let far = { x: -4.2, y: -8.5 + s }, near = { x: 4.2, y: -8.5 + s }, held = null, hamAng = 0;
    if (walk) {
      const swing = Math.sin(ph);
      far = { x: -swing * 3.2 - 1, y: -8.5 }; near = { x: swing * 3.2 + 1, y: -8.5 };
      if (a.carryCard) { far = { x: 4.2, y: shY + 6.5 }; near = { x: 5.8, y: shY + 5.5 }; held = 'card'; }
      if (a.carryBook) { far = { x: 4.2, y: shY + 6.5 }; near = { x: 5.8, y: shY + 5.5 }; held = 'book'; }
    } else if (anim === 'hammer') {
      const k = Math.pow((Math.sin(t * 5 + a.bobPh) + 1) / 2, 2.2);
      hamAng = -1.75 + k * 1.3;
      near = { x: 3.6 + Math.cos(hamAng) * 7.5, y: shY + 2 + Math.sin(hamAng) * 7.5 };
      far = { x: 6.4, y: -11 + s };
      held = 'hammer';
      if (k > 0.9 && (a._hk || 0) <= 0.9) this.spawnSparks(sx + face * 10, sy - 21, 4);
      a._hk = k;
    } else if (anim === 'stoke') {
      const k = (Math.sin(t * 3 + a.bobPh) + 1) / 2;
      near = { x: 5 + k * 3, y: -12.5 - k * 3.5 };
      far = { x: 3 + k * 3, y: -11 - k * 3.5 };
      held = 'lever';
      if (k > 0.92 && (a._sk || 0) <= 0.92) this.spawnSparks(sx + face * 12, sy - 26, 2);
      a._sk = k;
    } else if (anim === 'paint') {
      near = { x: 6.2 + Math.sin(t * 5 + a.bobPh) * 1.4, y: -15.5 + Math.cos(t * 3.4 + a.bobPh) * 1.8 };
      far = { x: -4.2, y: -8.5 };
      held = 'brush';
    } else if (anim === 'read') {
      near = { x: 5.4, y: -12.8 + Math.sin(t * 1.4 + a.bobPh) * 0.4 };
      far = { x: 2, y: -12.8 };
      held = 'book';
    } else if (anim === 'write') {
      near = { x: 6 + Math.cos(t * 3.2 + a.bobPh) * 1.1, y: -12.5 + Math.sin(t * 6.4 + a.bobPh) * 0.5 };
      far = { x: 4.2, y: -11.5 };
    } else if (anim === 'sort') {
      const w2 = Math.sin(t * 4 + a.bobPh) * 2;
      near = { x: 6, y: -13.5 - w2 }; far = { x: 3.2, y: -13.5 + w2 };
    } else if (anim === 'search') {
      const k2 = (Math.sin(t * 1.9 + a.bobPh) + 1) / 2;
      near = { x: 5.4, y: -13.5 - k2 * 6.5 }; far = { x: -4.2, y: -8.5 };
      held = k2 < 0.35 ? 'paper' : null;
    } else if (anim === 'tea') {
      const k3 = Math.pow((Math.sin(t * 1.25 + a.bobPh) + 1) / 2, 2);
      near = { x: 3.8 - k3 * 2, y: -10 + s - k3 * 7.5 }; far = { x: 0.5, y: -9 + s };
      held = 'cup';
    } else if (anim === 'fret') {
      near = { x: 2.4 + Math.sin(t * 2.6 + a.bobPh) * 0.7, y: headY + 3.2 }; far = { x: -4.2, y: -8.3 };
    } else if (anim === 'give') {
      near = { x: 9, y: -14 }; far = { x: -4, y: -8.6 };
    } else {
      near = { x: 4.2 + Math.sin(t * 1.5 + a.bobPh) * 0.4, y: -8.5 + s };
    }

    const arm = (shx, hand, bias) => {
      const ex = (shx + hand.x) / 2 + (bias || 0);
      const ey = (shY + 2 + hand.y) / 2 + 1.4;
      ctx.strokeStyle = sleeve; ctx.lineWidth = 2.6; ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(shx, shY + 2.2); ctx.quadraticCurveTo(ex, ey, hand.x, hand.y); ctx.stroke();
      ctx.fillStyle = skin; ctx.beginPath(); ctx.arc(hand.x, hand.y, 1.7, 0, 7); ctx.fill();
    };

    arm(-3.6, far, -1.4);

    if (a.dress) {
      const sway = walk ? Math.sin(ph) * 1.7 : 0;
      ctx.fillStyle = this.tint(a.color, -14);
      ctx.beginPath();
      ctx.moveTo(-6.4 + sway * 0.4, 1.2);
      ctx.quadraticCurveTo(-5.2, -5, -3.6, hipY - 1.5);
      ctx.lineTo(3.6, hipY - 1.5);
      ctx.quadraticCurveTo(5.2, -5, 6.4 + sway, 1.2);
      ctx.closePath(); ctx.fill();
      ctx.fillStyle = 'rgba(0,0,0,0.16)';
      ctx.fillRect(-6 + sway * 0.5, 0.2, 12.4, 1.3);
      if (walk) { ctx.fillStyle = '#17140f'; ctx.fillRect(Math.sin(ph) * 2.6 - 0.5, 0.2, 3, 1.8); }
    } else {
      const trouser = this.tint(a.color, -26);
      const leg = (side, phase) => {
        const hx2 = side * 2.2;
        let kx, ky, fx, fy;
        if (a.sit) { kx = 4.4; ky = -4.5 + s; fx = 5; fy = 1; }
        else if (walk) {
          const sw2 = Math.sin(phase);
          fx = hx2 + sw2 * 3.5; fy = 1 - Math.max(0, Math.cos(phase - 0.7)) * 1.7;
          kx = (hx2 + fx) / 2 + 1.2; ky = (hipY + fy) / 2 + 0.4;
        } else { kx = hx2 + 0.3; ky = (hipY + 1) / 2; fx = hx2; fy = 1; }
        ctx.strokeStyle = trouser; ctx.lineWidth = 3; ctx.lineCap = 'round';
        ctx.beginPath(); ctx.moveTo(hx2, hipY); ctx.quadraticCurveTo(kx, ky, fx, fy); ctx.stroke();
        ctx.fillStyle = '#17140f'; ctx.fillRect(fx - 1.2, fy - 1.2, 4, 2.2);
      };
      leg(-1, ph); leg(1, ph + Math.PI);
    }

    const th = (hipY + 2.5) - (shY - 1);
    if (a.dress) {
      ctx.fillStyle = '#e7dfcd';
      ctx.beginPath();
      if (ctx.roundRect) ctx.roundRect(-4.6 + lean * 0.4, shY - 1, 9.2, th, 3); else ctx.rect(-4.6, shY - 1, 9.2, th);
      ctx.fill();
      ctx.fillStyle = a.color;
      ctx.beginPath();
      if (ctx.roundRect) ctx.roundRect(-4.6 + lean * 0.4, shY + 4, 9.2, th - 5, 2); else ctx.rect(-4.6, shY + 4, 9.2, th - 5);
      ctx.fill();
      ctx.fillStyle = trim; ctx.beginPath(); ctx.arc(0.4, shY + 3, 0.9, 0, 7); ctx.fill();
      ctx.fillStyle = 'rgba(255,246,218,0.74)';
      ctx.beginPath(); ctx.moveTo(-2.8, shY + 4.4); ctx.lineTo(0.2, shY + 7.2); ctx.lineTo(3.2, shY + 4.4); ctx.closePath(); ctx.fill();
    } else {
      ctx.fillStyle = a.color;
      ctx.beginPath();
      if (ctx.roundRect) ctx.roundRect(-4.8 + lean * 0.4, shY - 1, 9.6, th, 2.6); else ctx.rect(-4.8, shY - 1, 9.6, th);
      ctx.fill();
      ctx.fillStyle = 'rgba(0,0,0,0.15)'; ctx.fillRect(-4.8 + lean * 0.4, shY - 1, 2, th - 1);
      ctx.fillStyle = '#e9e2d2';
      ctx.beginPath(); ctx.moveTo(-0.6, shY - 1); ctx.lineTo(3.6, shY - 1); ctx.lineTo(1.2, shY + 2.6); ctx.closePath(); ctx.fill();
      ctx.fillStyle = 'rgba(15,10,6,0.5)'; ctx.fillRect(0.8, shY + 4, 1.1, 1.1); ctx.fillRect(0.8, shY + 7, 1.1, 1.1);
      ctx.fillStyle = trim; ctx.beginPath(); ctx.arc(-2.8, shY + 5.3, 0.9, 0, 7); ctx.fill();
      if (a.apron) {
        ctx.fillStyle = '#8d7c5e';
        ctx.beginPath(); ctx.moveTo(-3.2, shY + 2.4); ctx.lineTo(3.8, shY + 2.4); ctx.lineTo(4.5, hipY + 2.4); ctx.lineTo(-3.9, hipY + 2.4); ctx.closePath(); ctx.fill();
        ctx.strokeStyle = 'rgba(245,235,206,0.45)'; ctx.lineWidth = 0.8;
        ctx.beginPath(); ctx.moveTo(-2.3, shY + 4); ctx.lineTo(3.1, hipY + 0.6); ctx.stroke();
      }
    }

    const hx = lean * 0.9, hy = headY - lean * 0.2;
    ctx.fillStyle = skin;
    ctx.fillRect(hx - 1.5, headY + 2.6, 3, 2.6);
    ctx.beginPath(); ctx.arc(hx, hy, 4.5, 0, 7); ctx.fill();
    ctx.beginPath(); ctx.arc(hx + 4.2, hy + 0.9, 1.05, 0, 7); ctx.fill();
    ctx.fillStyle = '#2a211a'; ctx.beginPath(); ctx.arc(hx + 2.4, hy - 0.7, 0.65, 0, 7); ctx.fill();
    ctx.strokeStyle = 'rgba(70,42,24,0.42)'; ctx.lineWidth = 0.8;
    ctx.beginPath(); ctx.moveTo(hx + 1.8, hy - 2.0); ctx.lineTo(hx + 3.5, hy - 2.1); ctx.stroke();
    ctx.strokeStyle = 'rgba(90,52,32,0.58)'; ctx.lineWidth = 0.7;
    ctx.beginPath(); ctx.moveTo(hx + 2.0, hy + 2.6); ctx.quadraticCurveTo(hx + 3.7, hy + 3.4, hx + 4.8, hy + 2.3); ctx.stroke();
    if (a.moust && !a.dress) { ctx.strokeStyle = '#38291c'; ctx.lineWidth = 1.3; ctx.beginPath(); ctx.moveTo(hx + 1.7, hy + 2.1); ctx.lineTo(hx + 4.5, hy + 1.8); ctx.stroke(); }
    if (a.dress) {
      ctx.fillStyle = a.hair;
      ctx.beginPath(); ctx.arc(hx - 0.4, hy - 1.3, 4.5, Math.PI * 0.8, Math.PI * 2.06); ctx.fill();
      ctx.beginPath(); ctx.arc(hx - 4.2, hy + 0.2, 2.4, 0, 7); ctx.fill();
      if (a.hairStyle === 'bun') {
        ctx.beginPath(); ctx.arc(hx - 4.9, hy - 1.6, 2.6, 0, 7); ctx.fill();
      } else if (a.hairStyle === 'wave') {
        ctx.strokeStyle = a.hair; ctx.lineWidth = 1.1;
        ctx.beginPath(); ctx.moveTo(hx - 4.2, hy + 2.5); ctx.quadraticCurveTo(hx - 5.4, hy + 4.8, hx - 3.4, hy + 6.2); ctx.stroke();
      }
      if (a.hat === 'ribbon') {
        ctx.fillStyle = trim;
        ctx.beginPath(); ctx.arc(hx + 2.3, hy - 5.0, 1.2, 0, 7); ctx.arc(hx + 4.2, hy - 4.7, 1.2, 0, 7); ctx.fill();
      }
    } else if (a.hat === 'bowler') {
      ctx.fillStyle = '#2a231c';
      ctx.beginPath(); ctx.arc(hx, hy - 3.4, 4.5, Math.PI, 2 * Math.PI); ctx.fill();
      ctx.fillRect(hx - 6.3, hy - 4, 12.6, 1.8);
    } else if (a.hat === 'cap') {
      ctx.fillStyle = '#4d4336';
      ctx.beginPath(); ctx.arc(hx, hy - 2.5, 4.5, Math.PI, 2 * Math.PI); ctx.fill();
      ctx.fillRect(hx + 0.5, hy - 3.2, 6.2, 1.6);
    } else {
      ctx.fillStyle = a.hair;
      ctx.beginPath(); ctx.arc(hx - 0.3, hy - 1.6, 4.4, Math.PI * 0.95, Math.PI * 2.05); ctx.fill();
    }

    arm(3.6, near, 1.4);
    if (held === 'hammer') {
      const hx2 = near.x + Math.cos(hamAng) * 6.5, hy2 = near.y + Math.sin(hamAng) * 6.5;
      ctx.strokeStyle = '#6b4a26'; ctx.lineWidth = 1.8;
      ctx.beginPath(); ctx.moveTo(near.x, near.y); ctx.lineTo(hx2, hy2); ctx.stroke();
      ctx.fillStyle = '#3c3f3c'; ctx.beginPath(); ctx.arc(hx2, hy2, 2.3, 0, 7); ctx.fill();
    } else if (held === 'card') {
      ctx.fillStyle = '#e8e0cc'; ctx.fillRect(near.x - 0.5, near.y - 3.6, 8, 6.2);
      ctx.strokeStyle = '#8a6a35'; ctx.lineWidth = 1; ctx.strokeRect(near.x - 0.5, near.y - 3.6, 8, 6.2);
      ctx.strokeStyle = 'rgba(90,70,40,0.55)';
      ctx.beginPath(); ctx.moveTo(near.x + 1, near.y - 1.6); ctx.lineTo(near.x + 6, near.y - 1.6); ctx.moveTo(near.x + 1, near.y + 0.4); ctx.lineTo(near.x + 5, near.y + 0.4); ctx.stroke();
    } else if (held === 'paper') {
      ctx.fillStyle = '#e8e0cc'; ctx.fillRect(near.x - 0.5, near.y - 4.5, 6.5, 7.5);
      ctx.strokeStyle = 'rgba(90,70,40,0.5)'; ctx.lineWidth = 0.8;
      ctx.beginPath(); ctx.moveTo(near.x + 0.8, near.y - 2.4); ctx.lineTo(near.x + 4.8, near.y - 2.4); ctx.moveTo(near.x + 0.8, near.y - 0.4); ctx.lineTo(near.x + 4.4, near.y - 0.4); ctx.stroke();
    } else if (held === 'cup') {
      ctx.fillStyle = '#efe8d6'; ctx.beginPath(); ctx.arc(near.x + 1, near.y - 1.4, 2, 0, 7); ctx.fill();
      ctx.strokeStyle = '#b5a888'; ctx.lineWidth = 0.8; ctx.beginPath(); ctx.arc(near.x + 3.2, near.y - 1.4, 1, 0, 7); ctx.stroke();
    } else if (held === 'book') {
      ctx.fillStyle = '#6d4326'; ctx.fillRect(near.x - 1, near.y - 4.2, 8, 6.6);
      ctx.fillStyle = '#e8e0cc'; ctx.fillRect(near.x + 0.2, near.y - 3.2, 5.6, 4.6);
      ctx.strokeStyle = 'rgba(90,70,40,0.55)'; ctx.lineWidth = 0.8;
      ctx.beginPath(); ctx.moveTo(near.x + 1.2, near.y - 1.8); ctx.lineTo(near.x + 4.8, near.y - 1.8); ctx.moveTo(near.x + 1.2, near.y - 0.2); ctx.lineTo(near.x + 4.2, near.y - 0.2); ctx.stroke();
    } else if (held === 'brush') {
      ctx.strokeStyle = '#8f6c3e'; ctx.lineWidth = 1.4;
      ctx.beginPath(); ctx.moveTo(near.x, near.y); ctx.lineTo(near.x + 4.4, near.y - 4.4); ctx.stroke();
      ctx.fillStyle = '#7a4460'; ctx.beginPath(); ctx.arc(near.x + 5.2, near.y - 5.2, 1.5, 0, 7); ctx.fill();
    } else if (held === 'lever') {
      ctx.strokeStyle = '#3c3f3c'; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(near.x + 3, near.y - 7); ctx.lineTo(near.x - 2, near.y + 8); ctx.stroke();
      ctx.fillStyle = '#b08d3f'; ctx.beginPath(); ctx.arc(near.x + 3, near.y - 7, 1.8, 0, 7); ctx.fill();
    }

    ctx.restore();

    if (this.state.sel === a.id) {
      ctx.strokeStyle = 'rgba(232,198,110,0.95)'; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.ellipse(sx, sy + 2, 12, 6, 0, 0, 7); ctx.stroke();
    }
    ctx.font = "9.5px 'IM Fell English', serif";
    ctx.fillStyle = 'rgba(233,216,172,0.75)';
    const nm = a.name + (a.multi && a.threadIdx ? ' \u00B7' + a.threadIdx : '');
    const nw = ctx.measureText(nm).width;
    ctx.fillText(nm, sx - nw / 2, sy + 13);
    ctx.globalAlpha = 1;
  }

  updateSmoke(dt) {
    this._smokeAcc = (this._smokeAcc || 0) + dt;
    this._steamAcc = (this._steamAcc || 0) + dt;
    const srcs = [];
    { const [x, y] = this.iso(14, 2); srcs.push([x + 6, y - 92]); }
    { const [x, y] = this.iso(23, 13); srcs.push([x + 2, y - 72]); }
    while (this._smokeAcc > 0.45) {
      this._smokeAcc -= 0.45;
      for (const [x, y] of srcs) this.smoke.push({ x: x + (Math.random() - 0.5) * 3, y, age: 0, life: 2.8 + Math.random() });
    }
    let busySteam = 0;
    for (const a of this.actors.values()) if (a.zone === 'steamworks' && a.mode === 'act') busySteam++;
    const steamEvery = busySteam > 0 ? 0.55 : 1.4;
    while (this._steamAcc > steamEvery) {
      this._steamAcc -= steamEvery;
      { const [x, y] = this.iso(14.5, 12); this.smoke.push({ x: x + 10, y: y - 36, age: 0, life: 1.1, steam: true }); }
      { const [x, y] = this.iso(23, 13); this.smoke.push({ x: x - 4, y: y - 14, age: 0, life: 1.0, steam: true }); }
      { const [x, y] = this.iso(20.5, 15); this.smoke.push({ x: x - 6, y: y - 20, age: 0, life: 1.2, steam: true }); }
    }
    for (const p of this.smoke) { p.age += dt; p.y -= dt * (p.steam ? 16 : 11); p.x += dt * (p.steam ? 1.5 : 3); }
    this.smoke = this.smoke.filter(p => p.age < p.life);
  }
  drawSmoke(ctx) {
    for (const p of this.smoke) {
      const k = p.age / p.life;
      ctx.fillStyle = p.steam ? 'rgba(232,230,224,' + (0.30 * (1 - k)) + ')' : 'rgba(190,185,175,' + (0.22 * (1 - k)) + ')';
      ctx.beginPath(); ctx.arc(p.x, p.y, (p.steam ? 1.6 : 3) + k * (p.steam ? 4 : 7), 0, 7); ctx.fill();
    }
  }
  drawLamps(ctx) {
    const glow = (this.props.lampGlow ?? true);
    ctx.save();
    for (let i = 0; i < this.LAMPS.length; i++) {
      const [gx, gy, h] = this.LAMPS[i];
      const [sx, sy] = this.iso(gx, gy);
      const ly = sy - h;
      ctx.strokeStyle = '#1f1c18'; ctx.lineWidth = 1.5;
      ctx.beginPath(); ctx.moveTo(sx, ly - 14); ctx.lineTo(sx, ly - 5); ctx.stroke();
      ctx.fillStyle = '#2a2622'; ctx.beginPath(); ctx.moveTo(sx - 5, ly - 5); ctx.lineTo(sx + 5, ly - 5); ctx.lineTo(sx + 3, ly - 1); ctx.lineTo(sx - 3, ly - 1); ctx.closePath(); ctx.fill();
      const fl = 0.7 + 0.3 * (0.5 + 0.5 * Math.sin(this.simT * 6.5 + i * 2.4) * Math.sin(this.simT * 2.3 + i));
      ctx.fillStyle = 'rgba(255,205,120,' + (0.9 * fl) + ')';
      ctx.beginPath(); ctx.arc(sx, ly + 2, 3, 0, 7); ctx.fill();
      if (glow) {
        ctx.globalCompositeOperation = 'lighter';
        const g = ctx.createRadialGradient(sx, ly + 6, 2, sx, ly + 6, 58);
        g.addColorStop(0, 'rgba(255,180,90,' + (0.12 + 0.05 * fl) + ')');
        g.addColorStop(1, 'rgba(255,180,90,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(sx, ly + 6, 58, 0, 7); ctx.fill();
        ctx.globalCompositeOperation = 'source-over';
      }
    }
    ctx.restore();
  }

  // ---------- animation helpers ----------
  animOf(a) {
    if (a.mode === 'walk') return 'walk';
    if (a.mode === 'hold') return 'fret';
    if (a.mode === 'handoff') return 'give';
    if (a.sit) return 'tea';
    if (a.toolAnim) return a.toolAnim;
    if (a.mode === 'act') {
      if (a.sub === 'shelf') return 'search';
      if (a.sub === 'table') return a.rw === 'write' ? 'write' : 'read';
      const z = a.zone;
      if (z === 'steamworks') return 'stoke';
      if (z === 'atelier') return 'paint';
      if (z === 'workshop') return 'hammer';
      if (z === 'dispatch' || z === 'mailroom') return 'sort';
      return 'write';
    }
    return 'stand';
  }

  spawnSparks(x, y, n) {
    if (!this.sparks) this.sparks = [];
    for (let i = 0; i < n; i++) this.sparks.push({ x, y, vx: (Math.random() - 0.5) * 60, vy: -40 - Math.random() * 50, age: 0, life: 0.35 + Math.random() * 0.3 });
  }
  updateSparks(dt) {
    if (!this.sparks) this.sparks = [];
    for (const p of this.sparks) { p.age += dt; p.vy += 240 * dt; p.x += p.vx * dt; p.y += p.vy * dt; }
    this.sparks = this.sparks.filter(p => p.age < p.life);
  }
  drawSparks(ctx) {
    if (!this.sparks || !this.sparks.length) return;
    ctx.save(); ctx.globalCompositeOperation = 'lighter';
    for (const p of this.sparks) {
      const k = 1 - p.age / p.life;
      ctx.strokeStyle = 'rgba(255,' + Math.round(150 + 80 * k) + ',80,' + (0.9 * k) + ')';
      ctx.lineWidth = 1.4;
      ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(p.x - p.vx * 0.02, p.y - p.vy * 0.02); ctx.stroke();
    }
    ctx.restore();
  }

  pressWheelPos() { const [cx, cy] = this.iso(13.5, 2.5); return [cx - 30, cy - 36]; }
  latheWheelPos() { const [ax, ay] = this.iso(19.5, 2); return [ax + 16, ay - 30]; }

  drawShaft(ctx) {
    const [x1, yA] = this.iso(11.6, 1.7); const [x2, yB] = this.iso(21.6, 1.7);
    const p = (x) => { const k = (x - 11.6) / 10; return [x1 + (x2 - x1) * k, yA + (yB - yA) * k - 96]; };
    ctx.strokeStyle = '#2c2620'; ctx.lineWidth = 2;
    for (const hx of [12.3, 16.4, 20.6]) { const [px, py] = p(hx); ctx.beginPath(); ctx.moveTo(px, py - 14); ctx.lineTo(px, py); ctx.stroke(); }
    ctx.strokeStyle = '#4a423a'; ctx.lineWidth = 3.2;
    const pa = p(11.6), pb = p(21.6);
    ctx.beginPath(); ctx.moveTo(pa[0], pa[1]); ctx.lineTo(pb[0], pb[1]); ctx.stroke();
    const belts = [
      { at: 13.05, to: this.pressWheelPos(), r: 15 },
      { at: 19.9, to: this.latheWheelPos(), r: 8 }
    ];
    for (const b of belts) {
      const [px, py] = p(b.at);
      ctx.fillStyle = '#33302a'; ctx.beginPath(); ctx.ellipse(px, py, 6, 3.4, 0, 0, 7); ctx.fill();
      ctx.save();
      ctx.strokeStyle = 'rgba(74,56,36,0.9)'; ctx.lineWidth = 1.6;
      ctx.setLineDash([5, 4]); ctx.lineDashOffset = -this.simT * 26;
      const [wx2, wy2] = b.to;
      ctx.beginPath(); ctx.moveTo(px - 4.5, py); ctx.lineTo(wx2 - b.r * 0.72, wy2); ctx.stroke();
      ctx.lineDashOffset = this.simT * 26;
      ctx.beginPath(); ctx.moveTo(px + 4.5, py); ctx.lineTo(wx2 + b.r * 0.72, wy2); ctx.stroke();
      ctx.restore();
    }
  }

  drawFlowerBed(ctx, x, y, i) {
    const [sx, sy] = this.iso(x, y);
    ctx.fillStyle = '#3e4f2d';
    ctx.beginPath(); ctx.ellipse(sx, sy - 3, 9, 4.5, 0, 0, 7); ctx.fill();
    ctx.beginPath(); ctx.ellipse(sx - 6, sy - 1, 5.5, 3, 0, 0, 7); ctx.fill();
    ctx.beginPath(); ctx.ellipse(sx + 6, sy - 1.5, 5.5, 3, 0, 0, 7); ctx.fill();
    const cols = ['#a3453a', '#c08a3c', '#9c5a80', '#b45c3a'];
    for (let k = 0; k < 5; k++) {
      const fx = sx + (this.fhash(i, k, 1) - 0.5) * 16, fy = sy - 3 - this.fhash(i, k, 2) * 5;
      ctx.fillStyle = cols[(i + k) % cols.length];
      ctx.beginPath(); ctx.arc(fx, fy, 1.6, 0, 7); ctx.fill();
    }
  }

  // ---------- DOM overlays ----------
  updateCaptionDom() {
    const el = this.captionRef.current; if (!el) return;
    if ((this.props.showCaptions ?? true) === false) { el.style.opacity = 0; return; }
    if (this.realT > this.capShownUntil && this.realT > this.capNextOk && this.capQueue.length) {
      el.textContent = this.capQueue.shift();
      el.style.opacity = 1;
      this.capShownUntil = this.realT + 3.4;
      this.capNextOk = this.capShownUntil + 0.7;
    }
    if (this.realT > this.capShownUntil) el.style.opacity = 0;
  }

  updatePopupDom() {
    if (!this.state.sel) return;
    const el = this.popupRef.current, cv = this.canvasRef.current; if (!el || !cv) return;
    const a = this.actors.get(this.state.sel);
    if (!a) return;
    const scale = cv.clientWidth / this.LW;
    const [sx, sy] = this.iso(a.x, a.y);
    el.style.left = ((sx + a.off) * scale) + 'px';
    el.style.top = ((sy - 44) * scale) + 'px';
    const act = this.activityRef.current;
    if (act) { const s = this.activityOf(a); if (act.textContent !== s) act.textContent = s; }
    const meta = this.runMetaRef.current;
    if (meta) { const s = this.runMetaOf(a); if (meta.textContent !== s) meta.textContent = s; }
  }

  onClick(e) {
    if (this.state.panMode || this._suppressNextClick) {
      this._suppressNextClick = false;
      return;
    }
    const cv = this.canvasRef.current; if (!cv) return;
    const rect = cv.getBoundingClientRect();
    const px = (e.clientX - rect.left) * this.LW / rect.width;
    const py = (e.clientY - rect.top) * this.LH / rect.height;
    let best = '', bd = 1e9;
    for (const a of this.actors.values()) {
      const [sx0, sy] = this.iso(a.x, a.y);
      const sx = sx0 + a.off;
      if (px > sx - 15 && px < sx + 15 && py > sy - 40 && py < sy + 8) {
        const d = Math.hypot(px - sx, py - (sy - 16));
        if (d < bd) { bd = d; best = a.id; }
      }
    }
    if (best) {
      const a = this.actors.get(best);
      const item = a.item || {};
      if (item && factoryRunId(item) && factoryWorkNeedsInput(item) && this.props.onOpenInputRequestModal) {
        this.setState({ sel: '', selRunId: '', selEmployeeId: '', selCompleted: false });
        this.props.onOpenInputRequestModal({
          run: item,
          work: item,
          employee: { id: a.empId, name: a.name, role: a.role },
          title: a.title || workTitle(item),
          threadId: workThreadId(item),
          approvalTitle: item.queue && item.queue.approvalRequestTitle || "",
          active: true,
        });
        return;
      }
      if (item && factoryRunId(item) && this.props.onOpenThreadModal) {
        this.setState({ sel: '', selRunId: '', selEmployeeId: '', selCompleted: false });
        this.props.onOpenThreadModal({
          run: item,
          work: item,
          employee: { id: a.empId, name: a.name, role: a.role },
          title: a.title || workTitle(item),
          threadId: workThreadId(item),
          approvalTitle: item.queue && item.queue.approvalRequestTitle || "",
          active: !["completed", "failed"].includes(this.statusOf(item, null)),
        });
        return;
      }
      this.setState({
        sel: best,
        selName: a.name,
        selRole: a.role,
        selActivity: this.activityOf(a),
        selRunMeta: this.runMetaOf(a),
        selRunId: item.runId || item.id || '',
        selEmployeeId: item.employeeId || a.empId || '',
        selCompleted: this.statusOf(item, null) === 'completed',
      });
    } else if (this.state.sel) {
      this.setState({ sel: '', selRunId: '', selEmployeeId: '', selCompleted: false });
    }
  }

  setViewZoom(nextZoom) {
    const viewZoom = Math.max(0.75, Math.min(2.4, Number(nextZoom) || 1));
    this.setState({ viewZoom });
  }

  resetView() {
    this.setState({ viewZoom: 1, panX: 0, panY: 0, panMode: false, panning: false });
  }

  onStageWheel(event) {
    if (!event.ctrlKey && !event.metaKey) return;
    event.preventDefault();
    const step = event.deltaY > 0 ? -0.1 : 0.1;
    this.setViewZoom(this.state.viewZoom + step);
  }

  onPanPointerDown(event) {
    if (!this.state.panMode) return;
    event.preventDefault();
    this._panStart = { x: event.clientX, y: event.clientY, panX: this.state.panX, panY: this.state.panY };
    this._panMoved = false;
    if (event.currentTarget.setPointerCapture) event.currentTarget.setPointerCapture(event.pointerId);
    this.setState({ panning: true });
  }

  onPanPointerMove(event) {
    if (!this.state.panning || !this._panStart) return;
    const dx = event.clientX - this._panStart.x;
    const dy = event.clientY - this._panStart.y;
    if (Math.abs(dx) + Math.abs(dy) > 3) this._panMoved = true;
    this.setState({ panX: this._panStart.panX + dx, panY: this._panStart.panY + dy });
  }

  onPanPointerUp(event) {
    if (!this.state.panning) return;
    if (event.currentTarget.releasePointerCapture) {
      try { event.currentTarget.releasePointerCapture(event.pointerId); } catch (_) { /* ignore stale capture */ }
    }
    this._suppressNextClick = !!this._panMoved;
    this._panStart = null;
    this._panMoved = false;
    this.setState({ panning: false });
  }

  render() {
    const hasSelection = !!this.state.sel;
    const sceneStyle = {
      transform: `translate(${this.state.panX}px, ${this.state.panY}px) scale(${this.state.viewZoom})`,
    };
    const zoomPct = Math.round(this.state.viewZoom * 100);
    return (
      <div
        ref={this.stageRef}
        className={`factory-package-stage ${this.state.panMode ? "pan-mode" : ""} ${this.state.panning ? "panning" : ""}`}
        data-appligator-id="factory-package-stage"
        onPointerDown={(event) => this.onPanPointerDown(event)}
        onPointerMove={(event) => this.onPanPointerMove(event)}
        onPointerUp={(event) => this.onPanPointerUp(event)}
        onPointerCancel={(event) => this.onPanPointerUp(event)}
        onWheel={(event) => this.onStageWheel(event)}
      >
        <div className="factory-view-controls" data-appligator-id="factory-view-controls" onPointerDown={(event) => event.stopPropagation()} onWheel={(event) => event.stopPropagation()}>
          <button type="button" title="Zoom out" onClick={() => this.setViewZoom(this.state.viewZoom - 0.15)}><Icon name="minus" size={13} /></button>
          <span>{zoomPct}%</span>
          <button type="button" title="Zoom in" onClick={() => this.setViewZoom(this.state.viewZoom + 0.15)}><Icon name="plus" size={13} /></button>
          <button type="button" className={this.state.panMode ? "active" : ""} title="Pan mode" onClick={() => this.setState((current) => ({ panMode: !current.panMode, panning: false }))}><Icon name="maximize" size={13} />Pan</button>
          <button type="button" title="Reset view" onClick={() => this.resetView()}><Icon name="refresh" size={13} /></button>
        </div>
        <div className="factory-scene-content" style={sceneStyle}>
          <canvas
            ref={this.canvasRef}
            className="factory-canvas"
            onClick={(event) => this.onClick(event)}
            aria-label="Appligator Ironworks Action Center factory view"
          />
          <div ref={this.speechLayerRef} className="factory-speech-layer" />
          <div ref={this.toolLayerRef} className="factory-tool-layer" />
          <div ref={this.captionRef} className="factory-caption factory-package-caption" />
          {hasSelection && (
            <div ref={this.popupRef} className="factory-package-popup" data-appligator-id="factory-run-popup">
              <div className="factory-package-popup-head">
                <strong>{this.state.selName}</strong>
                <span>{this.state.selRole}</span>
              </div>
              <div ref={this.activityRef} className="factory-package-popup-activity">{this.state.selActivity}</div>
              <div ref={this.runMetaRef} className="factory-package-popup-meta">{this.state.selRunMeta}</div>
            </div>
          )}
        </div>
        {this.props.loading && (
          <div className="factory-empty loading" data-appligator-id="factory-loading">
            <Icon name="refresh" size={20} />
            <strong>Loading factory floor</strong>
            <span>Reading the Office snapshot before waiting for push deltas.</span>
          </div>
        )}
        {!this.props.loading && !((this.roster && this.roster.length) || (this.workItems && this.workItems.length)) && (
          <div className="factory-empty" data-appligator-id="factory-empty">
            <Icon name="server" size={20} />
            <strong>No AI employees on shift</strong>
            <span>The Office snapshot loaded, but no AI employees were returned.</span>
          </div>
        )}
      </div>
    );
  }

}

  function AppligatorFactory({ db, bridgeActivityByRunId, bridgeSpeechByRunId, onToast, onError }) {
    const [snapshot, setSnapshot] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [liveState, setLiveState] = useState({ state: "connecting", reason: "Connecting to live Office stream.", fallback: false });
    const [pushedRunIds, setPushedRunIds] = useState({});
    const [liveEvents, setLiveEvents] = useState([]);
    const [caption, setCaption] = useState("");
    const [busyKey, setBusyKey] = useState("");
    const [compose, setCompose] = useState(null);
    const [composePrompt, setComposePrompt] = useState("");
    const [standardTaskMenu, setStandardTaskMenu] = useState(null);
    const [rosterThreadMenu, setRosterThreadMenu] = useState(null);
    const [threadModal, setThreadModal] = useState(null);
    const [inputRequestModal, setInputRequestModal] = useState(null);
    const mountedRef = useRef(true);
    const snapshotRef = useRef(null);
    const refreshTimerRef = useRef(null);
    const seenOfficeEventIdsRef = useRef(new Set());
    const officeRunClockRef = useRef(new Map());
    const pulseTimersRef = useRef({});
    const captionTimerRef = useRef(null);

    const load = useCallback(async (silent, fallbackReason) => {
      if (!window.API.getActionCenterOffice) {
        const message = "Factory snapshot endpoint is not available.";
        snapshotRef.current = null;
        setSnapshot(null);
        setError(message);
        setLiveState({ state: "error", reason: message, fallback: false });
        setLoading(false);
        if (onError) onError(new Error(message));
        return false;
      }
      try {
        if (!silent) setLoading(true);
        if (fallbackReason) setLiveState({ state: "fallback", reason: fallbackReason, fallback: true });
        const next = await window.API.getActionCenterOffice();
        if (!mountedRef.current) return false;
        snapshotRef.current = next || null;
        setSnapshot(next || null);
        setError("");
        officeRunClockRef.current = new Map();
        setLiveState({ state: fallbackReason ? "live" : "snapshot", reason: fallbackReason ? "Snapshot fallback completed; live stream remains subscribed." : "Snapshot loaded.", fallback: false });
        return true;
      } catch (err) {
        if (!mountedRef.current) return false;
        const message = (err && err.message) || "Failed to load Factory snapshot.";
        snapshotRef.current = null;
        setSnapshot(null);
        setError(message);
        setLiveState({ state: factoryPermissionDenied(err) ? "denied" : "error", reason: message, fallback: !!fallbackReason });
        if (onError) onError(err);
        return false;
      } finally {
        if (mountedRef.current && !silent) setLoading(false);
      }
    }, [onError]);

    const scheduleRefresh = useCallback((reason) => {
      if (refreshTimerRef.current) clearTimeout(refreshTimerRef.current);
      refreshTimerRef.current = setTimeout(() => {
        refreshTimerRef.current = null;
        load(true, reason || "Live Factory stream requested a snapshot fallback.");
      }, 180);
    }, [load]);

    const pulseRun = useCallback((runId) => {
      if (!runId) return;
      const key = String(runId);
      if (pulseTimersRef.current[key]) clearTimeout(pulseTimersRef.current[key]);
      setPushedRunIds((current) => ({ ...current, [key]: true }));
      pulseTimersRef.current[key] = setTimeout(() => {
        delete pulseTimersRef.current[key];
        setPushedRunIds((current) => {
          const next = { ...current };
          delete next[key];
          return next;
        });
      }, 2400);
    }, []);

    const applyOfficeChange = useCallback((officeChange) => {
      if (!officeChange) return false;
      const eventId = String(officeChange.eventId || "");
      if (!eventId) {
        scheduleRefresh("Live Factory event was missing a durable event id.");
        return false;
      }
      if (seenOfficeEventIdsRef.current.has(eventId)) return true;
      seenOfficeEventIdsRef.current.add(eventId);
      if (seenOfficeEventIdsRef.current.size > 500) {
        seenOfficeEventIdsRef.current = new Set(Array.from(seenOfficeEventIdsRef.current).slice(-300));
      }

      const runKey = officeChangeRunKey(officeChange);
      const currentSnapshot = snapshotRef.current;
      const existingWork = currentSnapshot && runKey ? workByRunId(currentSnapshot, runKey) : null;
      if (existingWork && changedAtMillis(latestWorkTime(existingWork)) > changedAtMillis(officeChange.changedAt)) return true;
      if (runKey) {
        const previous = officeRunClockRef.current.get(runKey);
        if (!officeChangeIsNewer(previous, officeChange)) return true;
        officeRunClockRef.current.set(runKey, { version: officeChange.version, changedAt: officeChange.changedAt });
      }

      if (officeChange.requiresSnapshotRefresh || !officeChange.workItem) {
        scheduleRefresh(officeChange.resyncReason || "Live Factory event requires snapshot refresh.");
        return true;
      }

      const current = snapshotRef.current;
      if (!current || current.freshness && current.freshness.state === "stale") {
        scheduleRefresh("Local Factory snapshot is stale or unavailable.");
        return true;
      }
      const next = mergeFactoryWorkItemIntoSnapshot(current, officeChange);
      if (!next) {
        scheduleRefresh("Live Factory delta could not be safely merged.");
        return true;
      }
      snapshotRef.current = next;
      setSnapshot(next);
      setError("");
      setLiveState({ state: "live", reason: "Live Factory event merged.", fallback: false });
      pulseRun(runKey);
      const meta = metaForWork(officeChange.workItem, null);
      const label = eventLabelFromOfficeChange(officeChange);
      const nextCaption = captionFromOfficeChange(officeChange);
      if (nextCaption) {
        setCaption(nextCaption);
        if (captionTimerRef.current) clearTimeout(captionTimerRef.current);
        captionTimerRef.current = setTimeout(() => {
          captionTimerRef.current = null;
          setCaption("");
        }, 5200);
      }
      setLiveEvents((events) => [{
        eventId,
        runId: runKey,
        at: officeChange.changedAt || new Date().toISOString(),
        label,
        tone: meta.tone,
      }, ...events].slice(0, MAX_FACTORY_EVENTS));
      return true;
    }, [pulseRun, scheduleRefresh]);

    useEffect(() => {
      mountedRef.current = true;
      load(false);
      return () => {
        mountedRef.current = false;
        if (refreshTimerRef.current) clearTimeout(refreshTimerRef.current);
        if (captionTimerRef.current) clearTimeout(captionTimerRef.current);
        Object.values(pulseTimersRef.current).forEach((timerId) => clearTimeout(timerId));
        pulseTimersRef.current = {};
        seenOfficeEventIdsRef.current.clear();
        officeRunClockRef.current.clear();
      };
    }, [load]);

    useEffect(() => {
      snapshotRef.current = snapshot;
    }, [snapshot]);

    useEffect(() => {
      if (!standardTaskMenu) return undefined;
      const isMenuTarget = (target) => !!(target && target.closest && target.closest(".ac-standard-task-menu"));
      const close = () => setStandardTaskMenu(null);
      const onMouseDown = (event) => { if (!isMenuTarget(event.target)) close(); };
      const onKey = (event) => { if (event.key === "Escape") close(); };
      const onScroll = (event) => { if (!isMenuTarget(event.target)) close(); };
      window.addEventListener("mousedown", onMouseDown);
      window.addEventListener("scroll", onScroll, true);
      window.addEventListener("resize", close);
      window.addEventListener("keydown", onKey);
      return () => {
        window.removeEventListener("mousedown", onMouseDown);
        window.removeEventListener("scroll", onScroll, true);
        window.removeEventListener("resize", close);
        window.removeEventListener("keydown", onKey);
      };
    }, [standardTaskMenu]);

    useEffect(() => {
      if (!rosterThreadMenu) return undefined;
      const isMenuTarget = (target) => !!(target && target.closest && target.closest(".factory-roster-thread-menu"));
      const close = () => setRosterThreadMenu(null);
      const onMouseDown = (event) => { if (!isMenuTarget(event.target)) close(); };
      const onKey = (event) => { if (event.key === "Escape") close(); };
      const onScroll = (event) => { if (!isMenuTarget(event.target)) close(); };
      window.addEventListener("mousedown", onMouseDown);
      window.addEventListener("scroll", onScroll, true);
      window.addEventListener("resize", close);
      window.addEventListener("keydown", onKey);
      return () => {
        window.removeEventListener("mousedown", onMouseDown);
        window.removeEventListener("scroll", onScroll, true);
        window.removeEventListener("resize", close);
        window.removeEventListener("keydown", onKey);
      };
    }, [rosterThreadMenu]);

    useEffect(() => {
      if (!window.API.subscribeToChanges) return undefined;
      const unsubscribe = window.API.subscribeToChanges((change) => {
        const officeChange = officeChangeFromChange(change);
        if (officeChange) {
          applyOfficeChange(officeChange);
          return;
        }
        if (isFactoryRefreshChange(change)) scheduleRefresh("Action Center change did not include a Factory delta.");
      }, {
        onOpen: () => setLiveState({ state: "live", reason: "Live Factory stream connected.", fallback: false }),
        onError: () => {
          setLiveState({ state: "stale", reason: "Live Factory stream disconnected or returned invalid data.", fallback: true });
          scheduleRefresh("Live Factory stream disconnected or returned invalid data.");
        },
      });
      return () => unsubscribe();
    }, [applyOfficeChange, scheduleRefresh]);

    const rosterEmployees = useMemo(() => factoryRosterEmployees(snapshot, db), [snapshot, db]);
    const finishedThreads = useMemo(() => factoryFinishedThreads(snapshot), [snapshot]);
    const threadModalRunId = threadModal ? String(factoryRunId(threadModal.run || threadModal.work || threadModal)).toLowerCase() : "";
    const threadModalActivity = threadModalRunId && bridgeActivityByRunId ? bridgeActivityByRunId[threadModalRunId] : null;
    const threadModalSpeechActivity = threadModalRunId && bridgeSpeechByRunId ? bridgeSpeechByRunId[threadModalRunId] : null;
    const standardTasksFor = useCallback((employee) => ((employee && employee.standardTasks) || [])
      .filter((task) => task && String(task.title || "").trim() && String(task.prompt || "").trim())
      .slice()
      .sort((a, b) => (Number(a.position) || 0) - (Number(b.position) || 0)), []);
    const scopedEntities = useCallback((scopeType) => {
      const clean = norm(scopeType);
      if (clean === "project") return ((db && db.projects) || []).slice().sort((a, b) => String(a.name || "").localeCompare(String(b.name || "")));
      if (clean === "customer") return ((db && db.customers) || []).slice().sort((a, b) => String(a.name || "").localeCompare(String(b.name || "")));
      return [];
    }, [db]);
    const workPackagesForProject = useCallback((project) => ((project && project.workPackages) || [])
      .slice()
      .sort((a, b) => (Number(a.position) || 0) - (Number(b.position) || 0) || String(a.name || "").localeCompare(String(b.name || ""))), []);
    const standardTaskAllowsInput = useCallback((task) => !!(task && task.additionalInput), []);
    const standardTaskRequiresWorkPackage = useCallback((task) => norm(task && task.scopeType) === "project" && !!(task && task.workPackageScope), []);
    const standardTaskActionLabel = useCallback((task) => {
      if (task && task.scopeType) return `Select ${String(task.scopeType).toLowerCase()}`;
      return standardTaskAllowsInput(task) ? "Add custom prompt" : "Start now";
    }, [standardTaskAllowsInput]);
    const standardTaskPrompt = useCallback((task, additionalInput) => {
      const prompt = String(task && task.prompt || "").trim();
      const input = String(additionalInput || "").trim();
      return input ? `${prompt}\n\nCustom prompt:\n${input}` : prompt;
    }, []);
    const contextReferenceForStandardTask = useCallback((employee, task, entity, workPackage) => {
      const scopeType = String(task && task.scopeType || "").trim();
      const title = String(task && task.title || "Standard task").trim();
      const baseFields = {
        Employee: (employee && employee.name) || "",
        EmployeeId: (employee && employee.id) || "",
        Role: (employee && employee.role) || "AI employee",
        StandardTask: title,
      };
      if (norm(scopeType) === "project" && entity) {
        const customerId = (entity.customerIds || [])[0] || "";
        const customer = ((db && db.customers) || []).find((item) => item.id === customerId);
        if (workPackage) {
          return {
            type: "Project work package",
            id: workPackage.id || "",
            label: `${title}: ${entity.name || "Project"} / ${workPackage.name || "Work package"}`,
            url: `${currentUrlWithoutHash()}#projects/${encodeURIComponent(entity.id || "")}`,
            fields: { ...baseFields, Project: entity.name || "", ProjectId: entity.id || "", Customer: (customer && customer.name) || "", CustomerId: customerId, WorkPackage: workPackage.name || "", WorkPackageTitle: workPackage.name || "", WorkPackageId: workPackage.id || "" },
          };
        }
        return {
          type: "Project",
          id: entity.id || "",
          label: `${title}: ${entity.name || "Project"}`,
          url: `${currentUrlWithoutHash()}#projects/${encodeURIComponent(entity.id || "")}`,
          fields: { ...baseFields, Project: entity.name || "", ProjectId: entity.id || "", Customer: (customer && customer.name) || "", CustomerId: customerId },
        };
      }
      if (norm(scopeType) === "customer" && entity) {
        return {
          type: "Customer",
          id: entity.id || "",
          label: `${title}: ${entity.name || "Customer"}`,
          url: currentUrlWithoutHash(),
          fields: { ...baseFields, Customer: entity.name || "", CustomerId: entity.id || "" },
        };
      }
      return {
        ...activityReferenceFor(employee),
        label: title,
        fields: baseFields,
      };
    }, [db]);
    const openComposer = useCallback((employee) => {
      if (!employee) return;
      setStandardTaskMenu(null);
      setRosterThreadMenu(null);
      setCompose({ employee, reference: activityReferenceFor(employee) });
      setComposePrompt("");
    }, []);
    const openStandardTaskMenu = useCallback((employee, event) => {
      const tasks = standardTasksFor(employee);
      if (!employee || tasks.length === 0) {
        openComposer(employee);
        return;
      }
      const rect = event && event.currentTarget && event.currentTarget.getBoundingClientRect ? event.currentTarget.getBoundingClientRect() : null;
      const width = 420;
      const margin = 10;
      const maxLeft = Math.max(margin, window.innerWidth - width - margin);
      const maxTop = Math.max(margin, window.innerHeight - margin - 560);
      setRosterThreadMenu(null);
      setStandardTaskMenu({
        employee,
        mode: "tasks",
        task: null,
        entity: null,
        workPackage: null,
        input: "",
        x: rect ? Math.min(Math.max(margin, rect.left - width + rect.width), maxLeft) : margin,
        y: rect ? Math.min(Math.max(margin, rect.bottom + 8), maxTop) : margin,
      });
    }, [openComposer, standardTasksFor]);
    const openRosterThreadMenu = useCallback((employee, event) => {
      const threads = Array.isArray(employee && employee.activeThreads) ? employee.activeThreads : [];
      if (!employee || threads.length === 0) return;
      const rect = event && event.currentTarget && event.currentTarget.getBoundingClientRect ? event.currentTarget.getBoundingClientRect() : null;
      const width = 360;
      const margin = 10;
      const maxLeft = Math.max(margin, window.innerWidth - width - margin);
      const maxTop = Math.max(margin, window.innerHeight - margin - 420);
      const preferredLeft = rect && rect.left - width - 8 >= margin ? rect.left - width - 8 : rect ? rect.right + 8 : margin;
      setStandardTaskMenu(null);
      setRosterThreadMenu({
        employee,
        x: rect ? Math.min(Math.max(margin, preferredLeft), maxLeft) : margin,
        y: rect ? Math.min(Math.max(margin, rect.top), maxTop) : margin,
      });
    }, []);
    const openRosterThread = useCallback((seed) => {
      setRosterThreadMenu(null);
      setThreadModal(seed);
    }, []);
    const submitStandardTask = useCallback(async (employee, task, entity, options = {}) => {
      const prompt = standardTaskPrompt(task, options.additionalInput);
      if (!employee || !prompt || busyKey) return;
      if (!window.API.startActionCenterContextTask) {
        const message = "Action Center context task endpoint is not available.";
        setError(message);
        if (onError) onError(new Error(message));
        return;
      }
      try {
        setBusyKey("Starting...");
        const reference = contextReferenceForStandardTask(employee, task, entity, options.workPackage);
        await window.API.startActionCenterContextTask(employee.id, prompt, reference);
        setStandardTaskMenu(null);
        await load(true);
        if (onToast) onToast("Action Center task queued");
      } catch (err) {
        if (onError) onError(err);
      } finally {
        setBusyKey("");
      }
    }, [busyKey, contextReferenceForStandardTask, load, onError, onToast, standardTaskPrompt]);
    const submitStartComposer = useCallback(async () => {
      const clean = composePrompt.trim();
      if (!compose || !clean || busyKey) return;
      if (!window.API.startActionCenterContextTask) {
        const message = "Action Center context task endpoint is not available.";
        setError(message);
        if (onError) onError(new Error(message));
        return;
      }
      try {
        setBusyKey("Sending...");
        await window.API.startActionCenterContextTask(compose.employee.id, clean, compose.reference);
        setCompose(null);
        setComposePrompt("");
        await load(true);
        if (onToast) onToast("Action Center task queued");
      } catch (err) {
        if (onError) onError(err);
      } finally {
        setBusyKey("");
      }
    }, [busyKey, compose, composePrompt, load, onError, onToast]);
    return (
      <section className="factory-page factory-package-page" data-appligator-id="appligator-factory">
        {error && (
          <div className="factory-error" data-appligator-id={liveState.state === "denied" ? "appligator-factory-denied" : "appligator-factory-unavailable"}>
            <Icon name={liveState.state === "denied" ? "shield" : "alert"} size={18} />
            <strong>{liveState.state === "denied" ? "Factory access denied" : "Factory unavailable"}</strong>
            <span>{error}</span>
          </div>
        )}

        <div className="factory-main-layout">
          <FactoryFinishedThreadStack
            threads={finishedThreads}
            onOpen={setThreadModal}
          />
          <div className="factory-package-shell">
            <FactoryPackageStage
              snapshot={snapshot}
              loading={loading}
              liveCaption={caption}
              showSpeech={true}
              showCaptions={true}
              lampGlow={true}
              pace={1}
              liveActivityByRunId={bridgeActivityByRunId}
              liveSpeechByRunId={bridgeSpeechByRunId}
              onOpenInputRequestModal={setInputRequestModal}
              onOpenThreadModal={setThreadModal}
            />
          </div>
          <FactoryRoster
            employees={rosterEmployees}
            busyKey={busyKey}
            onStart={openStandardTaskMenu}
            onOpenThreads={openRosterThreadMenu}
          />
        </div>

        {rosterThreadMenu && (
          <FactoryRosterThreadMenu
            menu={rosterThreadMenu}
            onClose={() => setRosterThreadMenu(null)}
            onOpen={openRosterThread}
          />
        )}

        {standardTaskMenu && (
          <div className="ac-standard-task-menu factory-standard-task-menu" style={{ left: standardTaskMenu.x, top: standardTaskMenu.y }} onMouseDown={(event) => event.stopPropagation()}>
            {standardTaskMenu.mode === "tasks" ? (
              <div className="ac-standard-task-list">
                {standardTasksFor(standardTaskMenu.employee).map((task) => (
                  <button
                    key={task.id || task.title}
                    type="button"
                    className="ac-standard-task"
                    disabled={!!busyKey}
                    onClick={() => {
                      if (task.scopeType) setStandardTaskMenu({ ...standardTaskMenu, mode: "scope", task });
                      else if (standardTaskAllowsInput(task)) setStandardTaskMenu({ ...standardTaskMenu, mode: "input", task, entity: null, workPackage: null, input: "" });
                      else submitStandardTask(standardTaskMenu.employee, task, null);
                    }}
                  >
                    <span><strong>{task.title}</strong><em>{standardTaskActionLabel(task)}</em></span>
                    <Icon name={task.scopeType || standardTaskAllowsInput(task) ? "chevR" : "send"} size={13} />
                  </button>
                ))}
                <button type="button" className="ac-standard-task custom" onClick={() => openComposer(standardTaskMenu.employee)}>
                  <span><strong>Custom prompt</strong><em>Write a one-off task</em></span>
                  <Icon name="edit" size={13} />
                </button>
              </div>
            ) : standardTaskMenu.mode === "scope" ? (
              <div className="ac-standard-task-list scoped">
                <button type="button" className="ac-standard-task back" onClick={() => setStandardTaskMenu({ ...standardTaskMenu, mode: "tasks", task: null, entity: null, workPackage: null })}>
                  <Icon name="chevL" size={13} />
                  <span><strong>Back</strong><em>{standardTaskMenu.task.title}</em></span>
                </button>
                {scopedEntities(standardTaskMenu.task.scopeType).map((entity) => (
                  <button
                    key={entity.id}
                    type="button"
                    className="ac-standard-task"
                    disabled={!!busyKey}
                    onClick={() => {
                      if (standardTaskRequiresWorkPackage(standardTaskMenu.task)) setStandardTaskMenu({ ...standardTaskMenu, mode: "workPackage", entity });
                      else if (standardTaskAllowsInput(standardTaskMenu.task)) setStandardTaskMenu({ ...standardTaskMenu, mode: "input", entity, workPackage: null, input: "" });
                      else submitStandardTask(standardTaskMenu.employee, standardTaskMenu.task, entity);
                    }}
                  >
                    <span><strong>{entity.name || "Untitled"}</strong><em>{standardTaskMenu.task.title}</em></span>
                    <Icon name={standardTaskRequiresWorkPackage(standardTaskMenu.task) || standardTaskAllowsInput(standardTaskMenu.task) ? "chevR" : "send"} size={13} />
                  </button>
                ))}
                {scopedEntities(standardTaskMenu.task.scopeType).length === 0 && <div className="ac-empty">No {standardTaskMenu.task.scopeType.toLowerCase()}s available.</div>}
              </div>
            ) : standardTaskMenu.mode === "workPackage" ? (
              <div className="ac-standard-task-list scoped">
                <button type="button" className="ac-standard-task back" onClick={() => setStandardTaskMenu({ ...standardTaskMenu, mode: "scope", entity: null, workPackage: null })}>
                  <Icon name="chevL" size={13} />
                  <span><strong>Back</strong><em>{standardTaskMenu.entity && standardTaskMenu.entity.name}</em></span>
                </button>
                {workPackagesForProject(standardTaskMenu.entity).map((workPackage) => (
                  <button
                    key={workPackage.id}
                    type="button"
                    className="ac-standard-task"
                    disabled={!!busyKey}
                    onClick={() => {
                      if (standardTaskAllowsInput(standardTaskMenu.task)) setStandardTaskMenu({ ...standardTaskMenu, mode: "input", workPackage, input: "" });
                      else submitStandardTask(standardTaskMenu.employee, standardTaskMenu.task, standardTaskMenu.entity, { workPackage });
                    }}
                  >
                    <span><strong>{workPackage.name || "Work package"}</strong><em>{standardTaskMenu.entity && standardTaskMenu.entity.name}</em></span>
                    <Icon name={standardTaskAllowsInput(standardTaskMenu.task) ? "chevR" : "send"} size={13} />
                  </button>
                ))}
                {workPackagesForProject(standardTaskMenu.entity).length === 0 && <div className="ac-empty">No work packages available.</div>}
              </div>
            ) : (
              <form className="ac-standard-task-input" onSubmit={(event) => { event.preventDefault(); submitStandardTask(standardTaskMenu.employee, standardTaskMenu.task, standardTaskMenu.entity, { workPackage: standardTaskMenu.workPackage, additionalInput: standardTaskMenu.input }); }}>
                <button
                  type="button"
                  className="ac-standard-task back"
                  onClick={() => setStandardTaskMenu({
                    ...standardTaskMenu,
                    mode: standardTaskMenu.workPackage ? "workPackage" : standardTaskMenu.task && standardTaskMenu.task.scopeType ? "scope" : "tasks",
                    input: "",
                  })}
                >
                  <Icon name="chevL" size={13} />
                  <span><strong>Back</strong><em>{standardTaskMenu.task.title}</em></span>
                </button>
                <label>
                  <span>Custom prompt</span>
                  <textarea
                    className="inp"
                    rows={10}
                    value={standardTaskMenu.input || ""}
                    onChange={(event) => setStandardTaskMenu({ ...standardTaskMenu, input: event.target.value })}
                    onKeyDown={(event) => submitPromptOnEnter(event, () => submitStandardTask(standardTaskMenu.employee, standardTaskMenu.task, standardTaskMenu.entity, { workPackage: standardTaskMenu.workPackage, additionalInput: standardTaskMenu.input }))}
                    placeholder="Add optional instructions for this run..."
                    autoFocus
                    data-appligator-id="factory-standard-task-input"
                  />
                </label>
                <button type="submit" className="btn sm primary" disabled={!!busyKey}><Icon name="send" size={13} />Start task</button>
              </form>
            )}
          </div>
        )}

        {compose && (
          <div className="factory-compose-backdrop" onMouseDown={(event) => { if (event.target === event.currentTarget && !busyKey) setCompose(null); }}>
            <section className="factory-compose-panel" role="dialog" aria-modal="true" aria-labelledby="factory-compose-title">
              <header>
                {avatarFor(compose.employee)}
                <div>
                  <h2 id="factory-compose-title">Message {compose.employee.name}</h2>
                  <p>{compose.reference.type} - {compose.reference.label}</p>
                </div>
                <button className="icon-btn" type="button" title="Close" onClick={() => !busyKey && setCompose(null)} disabled={!!busyKey}><Icon name="close" size={16} /></button>
              </header>
              <label>
                <span>Prompt</span>
                <textarea
                  className="inp factory-compose-textarea"
                  rows={10}
                  value={composePrompt}
                  onChange={(event) => setComposePrompt(event.target.value)}
                  onKeyDown={(event) => submitPromptOnEnter(event, submitStartComposer)}
                  placeholder="What should this employee do?"
                  autoFocus
                  data-appligator-id="factory-start-composer"
                />
              </label>
              <footer>
                <button className="btn ghost" type="button" onClick={() => setCompose(null)} disabled={!!busyKey}>Cancel</button>
                <button className="btn" type="button" onClick={submitStartComposer} disabled={!!busyKey || !composePrompt.trim()}><Icon name="send" size={14} />{busyKey || "Send"}</button>
              </footer>
            </section>
          </div>
        )}

        {threadModal && (
          <FactoryThreadModal
            seed={threadModal}
            activity={threadModalActivity}
            speechActivity={threadModalSpeechActivity}
            onClose={() => setThreadModal(null)}
            onChanged={() => load(true)}
            onToast={onToast}
            onError={onError}
          />
        )}

        {inputRequestModal && (
          <FactoryInputRequestModal
            seed={inputRequestModal}
            onClose={() => setInputRequestModal(null)}
            onChanged={() => load(true)}
            onToast={onToast}
            onError={onError}
            onOpenThread={(seed) => {
              setInputRequestModal(null);
              setThreadModal(seed);
            }}
          />
        )}

      </section>
    );
  }

  window.AppligatorFactory = AppligatorFactory;
})();
